import { Component, OnInit, OnDestroy, AfterViewInit, AfterViewChecked } from '@angular/core';
import { StateService } from '../services/state.service';
import { VehicleService } from '../services/vehicle.service';
import * as moment from 'moment';
import jsPDF from 'jspdf';
// import 'select2';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit, AfterViewInit, OnDestroy {

  objectKeys = Object.keys
  reportOptions = {
	// dMovement:'Daily Movement',
	fDriving:'Fleet Driving',
	fPark: 'Fleet Parking',
	ffUse:'Fleet Fuel Use',
	frEvent:'Fuel Refill Event',
	fMovement:'Full Movement',
	iEvent:'Input Event',
	mEvent:'Mobile Event',
	genCert:'Fleet Certificate'
  }
  fMovReportTypes = {
	engine_on: 'Engine On',
	engine_off: 'Engine Off',
	beacon: 'Beacon',
	alarm: 'Alarm',
	speed: 'Speed',
	idling: 'Idling',
	input: 'Input',
	others: 'Others'  
  };
  eventCodes = {
	'00': 'Engine On and Off Events',
	'01': 'Input Events',
	'02': 'Alarm Events',
	'03': 'Tamper Events',
	'04': 'Idling Events',
	'05': 'Speed Events',
	'06': 'Hard Brake Events',
	'07': 'Fuel Refill Events',
	'08': 'Fuel Alert Events',
	'09': 'Power Off Events',
	'10': 'Towed Events',
	'11': 'No GPS Events'  
  };
  reportType = '';
  timeIntvl = [5,10,15,20,25,30,35,40,45,50,55,60];
  today = new Date().toISOString().split('T')[0];
  dateStart = this.today;
  dateEnd = this.today;
  timeStart = '00:00';
  timeEnd = '23:59';
  vehicleFilter = 'All';
  vehicleList:any = '';
  vehicleListAlt:any = [];
  vehicleListBsj:any = '';
  eventSelect = '';
  eventType = '';
  mvEventType = ['all','engine_on','engine_off','beacon','alarm','speed','idling','input','others'];
  timeInterval = 'all';
	
  vehicles:any = [];
  vehicleStatusGroups:any = [];
  vehicleGroups:any = [];
  listedVehicles:any = [];
  processingSummary = false;
  eventDatas:any = [];
  
  reportData:any = [];
  processingDetail = false;
  
  selAll = true;
  selectionVehicle:any = {};
  table:any = null;
  
  oriTop:any = 0;
  vehicleSubs:any;

  locationPreference = "0";
  initialized = false;

  coordRpt = "";
  addressRpt = "";

  userObj:any = {};

  eventOuts:any = {
	speed: [
		325,3,10,17
	],
	idling: [
		108,89,90,92
	],
	alarm: [
		//brake
		86,305,
		//power off
		12,101,
		//alarm
		327,335,95,25,7,85,84,116,11,
		//refuel
		339,
		//fuel alert
		338,45,
		//tamper
		58,59,
	],
	engine_on: [
		87, 322
	],
	engine_off: [
		88,91,323
	]
  };

  eventTracksolids:any = {
	speed: [
		"135","202","6", "fenceOverspeed", "overSpeed"
	],
	idling: [
		"stayAlertOn"
	],
	alarm: [
		//brake
		"ubiDece",
		//power off
		"136","17","2","21","40",
		//alarm
		"ubiAcce","ubiTurn","ubiColl","76","146",
		//refuel
		"113",
		//fuel alert
		"83",
		//tamper
		"burglarStatus_0","burglarStatus_2","19","191"
	],
	engine_on: [
		"197"
	],
	engine_off: [
		"198"
	]
  };

  outDetailsReport:any = {};
  totalDaySeconds = 24 * 3600;

  chasisNo = "";
  dealerName = "";
  dealerAddress = "";
  installDate = "";
  activationDate:any = "";
  expiryDate:any = "";
  issueDate:any = this.today;

  certGenerateVehicle:any = "";
  
  constructor(private stateSvc: StateService, private vehicleSvc: VehicleService) { }

  ngOnInit(): void {
	this.userObj = this.stateSvc.getLocalSession();
	if(this.userObj?.source == 'bsj'){
		this.vehicleList = [];
	}
	this.vehicleSubs = this.stateSvc.vehicles
	.subscribe((result) => {
		this.vehicles = result;
		this.stateSvc.vehicleStatusGroups
		.subscribe((statuses) => {
			this.vehicleStatusGroups = statuses;
		});
		this.stateSvc.vehicleGroups
		.subscribe((groups) => {
			this.vehicleGroups = groups;
		});
		this.stateSvc.vehicleFiltered
		.subscribe((filtered) => {
			this.listedVehicles = filtered;
		});
		this.redeclareVehicleSelection(this.vehicleFilter);
	});
	this.reinitClickAction();
	this.reinitBackToTopReportDetail();

	let self = this;
	$(document).on('click', '.rpt-coord', function(){
		let latData = $(this).data('lat');
		let lonData = $(this).data('lon');
		let locData = $(this).data('loc');
		let fullCoord = latData + ', ' + lonData;
		self.coordRpt = fullCoord;

		let arrayCoords = self.stateSvc.getDecodedCoords(fullCoord);
		if(!arrayCoords){
			self.vehicleSvc.reverseGeocode(latData, lonData)
			.subscribe((res) => {
				if(res && res != ""){
					self.addressRpt = res;
				}else{
					self.addressRpt = locData;
				}
			})
		}else{
			self.addressRpt = arrayCoords;
		}

		$('#disp-coord').show().addClass('in');
		$('#dispCoordBackdrop').show().addClass('in');
	});
  }
  
  ngOnDestroy(){
	this.vehicleSubs.unsubscribe();
	// ($('.js-example-basic-single') as any).select2('destroy');
  }

  ngAfterViewInit() {
		setTimeout(() => {
			if(this?.userObj?.source == 'oncore'){
				($('.js-example-basic-single') as any).select2();
				$('span.select2-selection').addClass('pt-0');
				$('.select2-container--default .select2-selection--single').css('background', 'transparent');

				($('.js-example-basic-single') as any).on('change', (e: any) => {
					// this.vehicleList = e.target.value;

					let valueSelected:any = e.target.value;
					let cleanVal:any = [];
					if((valueSelected).indexOf(':') > -1){
						let splitVsel = (valueSelected).split(': ');
						let quotedId = (splitVsel[1]).replace(/^["']|["']$/g, '');
						this.vehicleList = quotedId;
					}else{
						this.vehicleList = valueSelected;
					}
				});
				$('#vehicle_list_bsj_multi,#vehicle_list_bsj_single').remove();
			}else{
				const selectElem = $('.js-example-basic-multiple') as any;
				$('.select2-container--default .select2-selection--multiple').css('background', 'transparent');
				selectElem.select2({
					width: '100%',
					placeholder: 'Select Vehicles',
					closeOnSelect: false,   // important for multi-select UX
					maximumSelectionLength: 10
				});
				// Sync back to Angular model
				selectElem.on('change', () => {
					let valueSelected:any = selectElem.val();
					let cleanVal:any = [];
					if(valueSelected.length > 0){
						valueSelected.forEach((vsel) => {
							if((vsel).indexOf(':') > -1){
								let splitVsel = (vsel).split(': ');
								let quotedId = (splitVsel[1]).replace(/^["']|["']$/g, '');
								cleanVal.push(quotedId);
							}
						})
					}
					this.vehicleListAlt = cleanVal;
				});

				($('.js-example-basic-single') as any).select2();
				$('span.select2-selection').addClass('pt-0');
				$('.select2-container--default .select2-selection--single').css('background', 'transparent');

				($('.js-example-basic-single') as any).on('change', (e: any) => {
					// this.vehicleList = e.target.value;

					let valueSelected:any = e.target.value;
					let cleanVal:any = [];
					if((valueSelected).indexOf(':') > -1){
						let splitVsel = (valueSelected).split(': ');
						let quotedId = (splitVsel[1]).replace(/^["']|["']$/g, '');
						this.vehicleListBsj = quotedId;
					}else{
						this.vehicleListBsj = valueSelected;
					}
				});
				$('#vehicle_list_oncore').remove();
			}
		}, 1000)
	}

	updateVehicles() {
		setTimeout(() => {
			($('.js-example-basic-single') as any).trigger('change.select2');
		});
	}
  
  reinitClickAction(){
	$('#oncore2,#oncore2b,#oncore2c,#oncore2d,#oncore2e,#oncore2f,#oncore2g,#oncore2h').on('click', '.fleetDtl', (e) => {
		let selId = e.currentTarget.dataset.id;
		let reportType = e.currentTarget.dataset.report;
		let eventType = e.currentTarget.dataset.event;
		let eventCode = e.currentTarget.dataset.code? e.currentTarget.dataset.code : '00';
		this.oriTop = e.pageY;
		this.processReportDetail(reportType, selId, eventType, eventCode);
	});
  }
  
  reinitBackToTopReportDetail(){
	$('#oncore3').on( 'click', 'i', (e) => {
		$('html,body').animate({
		  scrollTop: (this.oriTop - 15)
		}, 1000);
	} );
  }
  
  checkIfClick(selVal){
	if($.inArray('all', selVal) !== -1){
		this.selAll =  true;
		this.mvEventType = ['all','engine_on','engine_off','beacon','alarm','speed','idling','input','others'];
	}else{
		this.selAll =  false;        
	}
  }
  
  redeclareVehicleSelection(newValue){
		this.selectionVehicle = {};
		this.vehicles.forEach((vehicle,key) => {
			if(newValue == "All"){
				this.selectionVehicle[vehicle.description] = {
					plate: vehicle.description,
					unitId: vehicle.unitid,
					group: vehicle.groupname,
					status: vehicle.status
				};
			}else if(newValue == "Active" || newValue == "Stop" || newValue == "Idle"){
				if(vehicle.status == newValue.toLowerCase()){
					this.selectionVehicle[vehicle.description] = {
						plate: vehicle.description,
						unitId: vehicle.unitid,
						group: vehicle.groupname,
						status: vehicle.status
					};
				}
			}else{
				if(vehicle.groupname == newValue){
					this.selectionVehicle[vehicle.description] = {
						plate: vehicle.description,
						unitId: vehicle.unitid,
						group: vehicle.groupname,
						status: vehicle.status
					};
				}
			}
		});
	}
	
	calculateDayDiff(){
		let date1 = new Date(moment(this.dateStart).format('YYYY/MM/DD'));
		let date2 = new Date(moment(this.dateEnd).format('YYYY/MM/DD'));
		let timeDiff = Math.abs(date2.getTime() - date1.getTime());
		let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
		if(!this.reportType){
			alert('Please select report type');
			return false;
		}
		if(date1 > date2){
			alert('End date must be greater than start date');
			return false;
		}else{
			if(date2.getMonth() != date1.getMonth()){
				alert('Date selection must be within same month');
				return false;
			}
		}
		return true;
	}
	
	clickEvent(){
		let sctRep = this.reportType;
		let dayDiff = this.calculateDayDiff();
		if(dayDiff){
			this.genReport();
		}
	}
  
  genReport(){
	let startTime = this.timeStart + ":00";
	let endTime = this.timeEnd + ":00";
	let startDate = moment(this.dateStart).format('YYYY-MM-DD')+' '+startTime;
	let endDate = moment(this.dateEnd).format('YYYY-MM-DD')+' '+endTime;
	let startDateOnly = moment(this.dateStart).format('DDMMYY');
	let endDateOnly = moment(this.dateEnd).format('DDMMYY');
	let summData:any = {};
	this.eventDatas = [];
	this.reportData = [];
	if(this.reportType){
		this.processingDetail = true;
		// $('#oncore2').html('');
		$('.res-core').html('');
		$('#oncore2_wrapper,#oncore2b_wrapper,#oncore2c_wrapper,#oncore2d_wrapper,#oncore2e_wrapper,#oncore2f_wrapper,#oncore2g_wrapper,#oncore2h_wrapper').html('');
		$('#oncore3').html('');
		if($('#oncore3') && $('#oncore3_wrapper')[0]){
			$('#oncore3_wrapper').remove();
			$('.panel-oncore').append('<table id="oncore3" class="display table " cellspacing="0" width="100%"></table>');
		}
	}
	if(this.reportType == this.reportOptions.fDriving){
		if(this.userObj.source == "oncore"){
			let dropUnitId = this.vehicleList;console.log('dropUnitId',dropUnitId)
			this.vehicleSvc.getAllMobileEvents('00',startDate,startDateOnly,endDateOnly)
			.subscribe((firstData) => {
				this.vehicleSvc.getAllMobileEvents('04',startDate,startDateOnly,endDateOnly)
				.subscribe((res) => {
					let frefDatas = res;
					this.processingSummary = false;
					this.eventDatas = firstData;
					let eventName = {};
					let engine_run = {};
					let tempObjEngine = {};
					this.eventDatas?.forEach((event, index) => {
						if(dropUnitId){
							if(dropUnitId != event.unitid){
								return;
							}
						}
						let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
						if(formattedTime < startDate || formattedTime > endDate){
							return;
						}
						// fleet summary - start
						if(!summData[event.unitid]){
							summData[event.unitid] = {};
							this.vehicles.forEach((vehicle,key) => {
								if(vehicle.unitid == event.unitid){
									summData[event.unitid].plate = vehicle.description;
									summData[event.unitid].mobile_idle = parseFloat(vehicle.idle_period);
									summData[event.unitid].mobile_fuel = vehicle.fuel_usage;
								}
							});
							summData[event.unitid].fuel_liter = (0).toFixed(4);
							summData[event.unitid].idling = '00:00:00';
							summData[event.unitid].total_distance = (0).toFixed(2);
							summData[event.unitid].total_duration = '00:00:00';
							summData[event.unitid].total_level = (0).toFixed(4);
						}
						if(!engine_run[event.unitid]){
							engine_run[event.unitid] = {};
						}
						if(!summData[event.unitid].count_engine_on){
							summData[event.unitid].count_engine_on = 0;
						}
						if(!summData[event.unitid].count_engine_off){
							summData[event.unitid].count_engine_off = 0;   
						}
						if(!summData[event.unitid].count_idle){
							summData[event.unitid].count_idle = 0;   
						}
						if(event.event == "Engine_Off"){
							if(engine_run[event.unitid].tempObjEngine){
								summData[event.unitid].count_engine_off += 1;

								engine_run[event.unitid].tempObjEngine.odometer.push(event.odometer);
								engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
								engine_run[event.unitid].tempObjEngine.level.push(event.level);

								
								frefDatas.forEach((fr, ky) => {
									let formattedFrTime = (fr.updated).format('YYYY-MM-DD HH:mm:ss');
									if(formattedFrTime < startDate || formattedFrTime > endDate){
										return;
									}
									if(fr.unitid == event.unitid && (fr.updated > engine_run[event.unitid].tempObjEngine.updated[0] && fr.updated < engine_run[event.unitid].tempObjEngine.updated[1])){
										//if(engine_run[event.unitid].tempObjEngine){
											summData[event.unitid].count_idle += 1; 
											let idle_raw:any = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle);
											summData[event.unitid].idle_raw = idle_raw;
											let idle_hours:any = Math.floor( idle_raw / 60);
											idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
											let idle_minutes:any = idle_raw % 60;
											idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
											let idle_time:any = idle_hours + ':' + idle_minutes + ':00';
											summData[event.unitid].idling = idle_time;

											delete frefDatas[ky];
										// }
									}
								});

								let dist = (parseFloat(engine_run[event.unitid].tempObjEngine.odometer[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.odometer[0])).toFixed(2);
								
								let total_level:any = parseFloat(engine_run[event.unitid].tempObjEngine.level[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.level[0]); 
								let from_mili:any = (engine_run[event.unitid].tempObjEngine.updated[1] - engine_run[event.unitid].tempObjEngine.updated[0]);
								let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
								hours = (hours < 10)? '0'+hours : hours;
								let seconds:any = Math.floor((from_mili / 1000) % 60);
								seconds = (seconds < 10)? '0'+seconds : seconds;
								let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
								minutes = (minutes < 10)? '0'+minutes : minutes;
								let diff_dur:any = (hours + ':' + minutes + ":" + seconds);
								if(!summData[event.unitid].total_distance){
									summData[event.unitid].total_distance = 0;
								}
								if(!summData[event.unitid].total_duration){
									summData[event.unitid].total_duration = '00:00:00';
								}
								if(!summData[event.unitid].total_level){
									summData[event.unitid].total_level = 0;
								}

								let tempSumm = parseFloat(summData[event.unitid].total_distance);
								tempSumm += parseFloat(dist);
								summData[event.unitid].total_distance = tempSumm.toFixed(2);
								let tempLvl = parseFloat(summData[event.unitid].total_level);
								tempLvl += total_level;
								summData[event.unitid].total_level = tempLvl;
								summData[event.unitid].total_duration = this.vehicleSvc.addTwoTime(summData[event.unitid].total_duration, diff_dur);                                    
								summData[event.unitid].fuel_liter = (summData[event.unitid].total_distance * parseFloat(summData[event.unitid].mobile_fuel));

								if(!summData[event.unitid].journeys){
									summData[event.unitid].journeys = {};
								}
								if(!summData[event.unitid].journeys[index]){
									summData[event.unitid].journeys[index] = {};
								}
								summData[event.unitid].journeys[index].dist = diff_dur;
								summData[event.unitid].journeys[index].start_time = engine_run[event.unitid].tempObjEngine.updated[0].format('YYYY-MM-DD HH:mm:ss');
								summData[event.unitid].journeys[index].end_time = engine_run[event.unitid].tempObjEngine.updated[1].format('YYYY-MM-DD HH:mm:ss');
								summData[event.unitid].journeys[index].start_level = engine_run[event.unitid].tempObjEngine.level[0];
								summData[event.unitid].journeys[index].end_level = engine_run[event.unitid].tempObjEngine.level[1];
								summData[event.unitid].journeys[index].start_odo = engine_run[event.unitid].tempObjEngine.odometer[0];
								summData[event.unitid].journeys[index].end_odo = engine_run[event.unitid].tempObjEngine.odometer[1];

								delete engine_run[event.unitid].tempObjEngine;
							}
						}else if(event.event == "Engine_On"){
							summData[event.unitid].count_engine_on += 1; 

							//if(!engine_run[event.unitid].tempObjEngine){
							engine_run[event.unitid].tempObjEngine = {
								odometer:[],
								updated:[],
								level:[]
							};
							//}
							engine_run[event.unitid].tempObjEngine.odometer.push(event.odometer);
							engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
							engine_run[event.unitid].tempObjEngine.level.push(event.level);
						}else if(event.event == "Idling"){
							summData[event.unitid].count_idle += 1; 
							let idle_raw:any = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle);
							summData[event.unitid].idle_raw = idle_raw;
							let idle_hours:any = Math.floor( idle_raw / 60);
							idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
							let idle_minutes:any = idle_raw % 60;
							idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
							let idle_time:any = idle_hours + ':' + idle_minutes + ':00';
							summData[event.unitid].idling = idle_time;
						}
					});
					for(let index in summData){
						let mbl = summData[index];
						if(mbl.count_engine_off && mbl.plate !== undefined){
							let repData = {
								mobile: '<a class="fleetDtl" data-report="fDriving" data-id="'+index+'">'+mbl.plate+'</a>',
								count: (mbl.count_engine_off < mbl.count_engine_on) ? mbl.count_engine_off : mbl.count_engine_on,
								distance: Math.round(mbl.total_distance),
								duration: mbl.total_duration,
								idling: mbl.idling,
								fuel_liter: mbl.fuel_liter.toFixed(2)
							};
							this.reportData.push(repData);
						}
					};
					console.log(summData);
					let options = {
						data: this.reportData,
						//pageLength: 25,
						paging: false,
						responsive: false,
						scrollX: true,
						searching: false,
						destroy: true,
						retrieve: true,
						//dom: '<lf<t>ip>',
						dom: "Blf<t>rtip",
						"stateSave": true,
						buttons: [
							{
								extend: 'colvis',
								className: 'fa fa-eye',
								text: '',
							},
							{
								extend: 'excelHtml5',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore2b').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-excel-o rptBtn',
								text: '',
								title: 'Fleet Driving Report Summary'
							}, {
								extend: 'pdfHtml5',
								orientation: 'landscape',
								pageSize: 'A4',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore2b').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-pdf-o rptBtn',
								text: '',
								title: 'Fleet Driving Report Summary'
							}
						],
						columns: [
							{
								data: "mobile",
								width: "20%",
								title: "Mobile"
							},
							{
								data: "count",
								width: "15%",
								title: "Count"
							},
							{
								data: "distance",
								width: "15%",
								title: "Distance"
							},
							{
								data: "duration",
								width: "20%",
								title: "Duration"
							},
							{
								data: "idling",
								width: "15%",
								title: "Idling"
							},
							{
								data: "fuel_liter",
								width: "15%"  ,
								title: "Fuel Liters"
							}
						]
					};
					if($('#oncore2b') && $('#oncore2b_wrapper')[0]){
						$('#oncore2b_wrapper').remove();
						$('#oncore3').before('<table id="oncore2b" class="display table " cellspacing="0" width="100%"></table>');
					}
					this.table = $('#oncore2b').DataTable(options);
					this.reinitClickAction();
					$('.dataTables_scrollBody').scroll(function(){
						$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
					});
					$('#oncore2b').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Fleet Driving Report Summary</caption>');
					$('.dt-buttons').css('float','left');
					this.processingDetail = false;
				},
				(err) => {
					alert(err.statusText);
					if($('#oncore2b') && $('#oncore2b_wrapper')[0]){
						$('#oncore2_wrapper').remove();
						$('#oncore3').before('<table id="oncore2b" class="display table " cellspacing="0" width="100%"></table>');
					}
					this.processingDetail = false;
				})
			},
			err => {
				alert(err.statusText);
				if($('#oncore2b') && $('#oncore2b_wrapper')[0]){
					$('#oncore2b_wrapper').remove();
					$('#oncore3').before('<table id="oncore2b" class="display table " cellspacing="0" width="100%"></table>');
				}
				this.processingDetail = false;
			}
			);
		}else{
			let driveVhcls:any = [];
			if(this.vehicleListAlt.length > 0){
				driveVhcls = this.vehicleListAlt;
				if(this.vehicleListAlt.length > 10){
					alert('Only allow to select maximum 10 vehicles');
					this.processingDetail = false;
					return false;
				}
			}else{
				alert('Please select a vehicle');
				this.processingDetail = false;
				return false;
				// for(let key of this.objectKeys(this.selectionVehicle)){
				// 	driveVhcls.push(this.selectionVehicle[key].unitId);
				// }
			}
			this.vehicleSvc.getVehicleTrakcsAll(driveVhcls,startDate,endDate,1)
			.subscribe((events:any) => {
			// this.vehicleSvc.getVehicleTracks(driveVhcls[0],startDate,endDate,1)
			// .subscribe((events:any) => {
				let frefDatas = events;
				this.processingSummary = false;
				this.eventDatas = events;
				let eventName = {};
				let engine_run = {};
				let tempObjEngine = {};
				let selectedVehicle:any = {};
				this.eventDatas?.forEach((event, index) => {
					const dateStr = event.devTime;
					// Convert to ISO format (important)
					const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
					// Get milliseconds
					const timestamp = date.getTime();
					// Build .NET format
					const dotNetDate = "/Date(" + timestamp + "+0800)/";

					this.vehicles.forEach((vhc) => {
						if(vhc.vehicleId == event.vehicleId){
							selectedVehicle = vhc;
							return;
						}
					})
					
					event.updated = (moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x'));
					// fleet summary - start
					event.unitid = event.vehicleId;
					if(!summData[event.unitid]){
						summData[event.unitid] = {};
						this.vehicles.forEach((vehicle,key) => {
							if(vehicle.vehicleId == event.unitid){
								summData[event.unitid].plate = vehicle.description;
								summData[event.unitid].mobile_idle = event.timeSecond;
								summData[event.unitid].mobile_fuel = 0;
								summData[event.unitid].terminalNo = vehicle.terminalNo;
							}
						});
						summData[event.unitid].fuel_liter = (0).toFixed(4);
						summData[event.unitid].idling = '00:00:00';
						summData[event.unitid].total_distance = (0).toFixed(2);
						summData[event.unitid].total_duration = '00:00:00';
						summData[event.unitid].total_level = (0).toFixed(4);
					}
					if(!engine_run[event.unitid]){
						engine_run[event.unitid] = {};
					}
					if(!summData[event.unitid].count_engine_on){
						summData[event.unitid].count_engine_on = 0;
					}
					if(!summData[event.unitid].count_engine_off){
						summData[event.unitid].count_engine_off = 0;   
					}
					if(!summData[event.unitid].count_idle){
						summData[event.unitid].count_idle = 0;   
					}
					if(!summData[event.unitid].idle_raw){
						summData[event.unitid].idle_raw = 0;   
					}
					if(event.accState == 1){
						if(engine_run[event.unitid].tempObjEngine){
							summData[event.unitid].count_engine_off += 1;

							engine_run[event.unitid].tempObjEngine.odometer.push(event.mileage);
							engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
							engine_run[event.unitid].tempObjEngine.level.push(event.oil);

							
							// frefDatas.forEach((fr, ky) => {
							// 	let formattedFrTime = (fr.updated).format('YYYY-MM-DD HH:mm:ss');
							// 	if(formattedFrTime < startDate || formattedFrTime > endDate){
							// 		return;
							// 	}
							// 	if(fr.unitid == event.unitid && (fr.updated > engine_run[event.unitid].tempObjEngine.updated[0] && fr.updated < engine_run[event.unitid].tempObjEngine.updated[1])){
							// 		//if(engine_run[event.unitid].tempObjEngine){
							// 			summData[event.unitid].count_idle += 1; 
							// 			let idle_raw:any = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle);
							// 			summData[event.unitid].idle_raw = idle_raw;
							// 			let idle_hours:any = Math.floor( idle_raw / 60);
							// 			idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
							// 			let idle_minutes:any = idle_raw % 60;
							// 			idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
							// 			let idle_time:any = idle_hours + ':' + idle_minutes + ':00';
							// 			summData[event.unitid].idling = idle_time;

							// 			delete frefDatas[ky];
							// 		// }
							// 	}
							// });

							let dist = (parseFloat(engine_run[event.unitid].tempObjEngine.odometer[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.odometer[0])).toFixed(2);
							
							let total_level:any = parseFloat(engine_run[event.unitid].tempObjEngine.level[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.level[0]); 
							let from_mili:any = (engine_run[event.unitid].tempObjEngine.updated[1] - engine_run[event.unitid].tempObjEngine.updated[0]);
							let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
							hours = (hours < 10)? '0'+hours : hours;
							let seconds:any = Math.floor((from_mili / 1000) % 60);
							seconds = (seconds < 10)? '0'+seconds : seconds;
							let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
							minutes = (minutes < 10)? '0'+minutes : minutes;
							let diff_dur:any = (hours + ':' + minutes + ":" + seconds);
							if(!summData[event.unitid].total_distance){
								summData[event.unitid].total_distance = 0;
							}
							if(!summData[event.unitid].total_duration){
								summData[event.unitid].total_duration = '00:00:00';
							}
							if(!summData[event.unitid].total_level){
								summData[event.unitid].total_level = 0;
							}

							let tempSumm = parseFloat(summData[event.unitid].total_distance);
							tempSumm += parseFloat(dist);
							summData[event.unitid].total_distance = tempSumm.toFixed(2);
							let tempLvl = parseFloat(summData[event.unitid].total_level);
							tempLvl += total_level;
							summData[event.unitid].total_level = tempLvl;
							summData[event.unitid].total_duration = this.vehicleSvc.addTwoTime(summData[event.unitid].total_duration, diff_dur);                                    
							summData[event.unitid].fuel_liter = 0;

							if(!summData[event.unitid].journeys){
								summData[event.unitid].journeys = {};
							}
							if(!summData[event.unitid].journeys[index]){
								summData[event.unitid].journeys[index] = {};
							}
							summData[event.unitid].journeys[index].dist = diff_dur;
							summData[event.unitid].journeys[index].start_time = engine_run[event.unitid].tempObjEngine.updated[0].format('YYYY-MM-DD HH:mm:ss');
							summData[event.unitid].journeys[index].end_time = engine_run[event.unitid].tempObjEngine.updated[1].format('YYYY-MM-DD HH:mm:ss');
							summData[event.unitid].journeys[index].start_level = engine_run[event.unitid].tempObjEngine.level[0];
							summData[event.unitid].journeys[index].end_level = engine_run[event.unitid].tempObjEngine.level[1];
							summData[event.unitid].journeys[index].start_odo = engine_run[event.unitid].tempObjEngine.odometer[0];
							summData[event.unitid].journeys[index].end_odo = engine_run[event.unitid].tempObjEngine.odometer[1];

							delete engine_run[event.unitid].tempObjEngine;
						}
					}else if(event.accState == 0){
						summData[event.unitid].count_engine_on += 1; 

						if(!engine_run[event.unitid].tempObjEngine){
							engine_run[event.unitid].tempObjEngine = {
								odometer:[],
								updated:[],
								level:[]
							};
							engine_run[event.unitid].tempObjEngine.odometer.push(event.mileage);
							engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
							engine_run[event.unitid].tempObjEngine.level.push(event.oil);
						}else{

						}

						if(event.runState == 3){
							summData[event.unitid].count_idle += 1; 
							summData[event.unitid].idle_raw += event.timeSecond;
							let idle_raw = summData[event.unitid].idle_raw;
							let idle_hours:any = Math.floor( idle_raw / (60*60));
							idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
							let idle_minutes:any = Math.floor(idle_raw / 60);
							idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
							let idle_secs:any = idle_raw % 60;
							idle_secs = (idle_secs < 10)? '0'+idle_secs : idle_secs;
							let idle_time:any = idle_hours + ':' + idle_minutes + ':' + idle_secs;
							summData[event.unitid].idling = idle_time;
						}
					}
				});
				console.log('summData',summData);
				for(let index in summData){
					let mbl = summData[index];console.log('mbl',mbl);
					if(mbl.count_engine_off && mbl.plate !== undefined){
						let repData = {
							mobile: '<a class="fleetDtl" data-report="fDriving" data-id="'+mbl.terminalNo+'">'+mbl.plate+'</a>',
							count: (mbl.count_engine_off < mbl.count_engine_on) ? mbl.count_engine_off : mbl.count_engine_on,
							distance: Math.round(mbl.total_distance),
							duration: mbl.total_duration,
							idling: mbl.idling,
							fuel_liter: mbl.fuel_liter.toFixed(2)
						};
						this.reportData.push(repData);
					}
				};
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging: false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					retrieve: true,
					//dom: '<lf<t>ip>',
					dom: "Blf<t>rtip",
					"stateSave": true,
					buttons: [
						{
							extend: 'colvis',
							className: 'fa fa-eye',
							text: '',
						},
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore2b').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: 'Fleet Driving Report Summary'
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore2b').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: 'Fleet Driving Report Summary'
						}
					],
					columns: [
						{
							data: "mobile",
							width: "20%",
							title: "Mobile"
						},
						{
							data: "count",
							width: "15%",
							title: "Count"
						},
						{
							data: "distance",
							width: "15%",
							title: "Distance"
						},
						{
							data: "duration",
							width: "20%",
							title: "Duration"
						},
						{
							data: "idling",
							width: "15%",
							title: "Idling"
						},
						{
							data: "fuel_liter",
							width: "15%"  ,
							title: "Fuel Liters"
						}
					]
				};
				if($('#oncore2b') && $('#oncore2b_wrapper')[0]){
					$('#oncore2b_wrapper').remove();
					$('#oncore3').before('<table id="oncore2b" class="display table " cellspacing="0" width="100%"></table>');
				}
				this.table = $('#oncore2b').DataTable(options);
				this.reinitClickAction();
				$('.dataTables_scrollBody').scroll(function(){
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
				$('#oncore2b').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Fleet Driving Report Summary</caption>');
				$('.dt-buttons').css('float','left');
				this.processingDetail = false;
			},
			err => {
				alert(err.statusText);
				if($('#oncore2b') && $('#oncore2b_wrapper')[0]){
					$('#oncore2b_wrapper').remove();
					$('#oncore3').before('<table id="oncore2b" class="display table " cellspacing="0" width="100%"></table>');
				}
				this.processingDetail = false;
			})
		}
	} else if(this.reportType == this.reportOptions.mEvent){
		if(this.userObj.source == "oncore"){
			this.vehicleSvc.getAllMobileEvents('12',startDate,startDateOnly,endDateOnly)
			.subscribe((res) => {
				this.eventDatas = res;
				let eventName = {};
				let engine_run = {};
				let tempObjEngine = {};
				this.eventDatas?.forEach((event, index) => {
					let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
					if(formattedTime < startDate || formattedTime > endDate){
						return;
					}
					// mobile event summary - start
					if(!summData[event.unitid]){
						summData[event.unitid] = {};
						this.vehicles.forEach((vehicle,key) => {
							if(vehicle.unitid == event.unitid){
								summData[event.unitid].plate = vehicle.description;
							}
						});
					}
					if(!summData[event.unitid].count_alarm){
						summData[event.unitid].count_alarm = 0;
					}
					if(!summData[event.unitid].count_tamper){
						summData[event.unitid].count_tamper = 0;
					}
					if(!summData[event.unitid].count_idling){
						summData[event.unitid].count_idling = 0;
					}
					if(!summData[event.unitid].count_speed){
						summData[event.unitid].count_speed = 0;
					}
					if(!summData[event.unitid].count_break){
						summData[event.unitid].count_break = 0;
					}
					if(!summData[event.unitid].count_fuel_refill){
						summData[event.unitid].count_fuel_refill = 0;
					}
					if(!summData[event.unitid].count_fuel_alert){
						summData[event.unitid].count_fuel_alert = 0;
					}
					if(!summData[event.unitid].count_engine_off){
						summData[event.unitid].count_engine_off = 0;
					}
					if(!summData[event.unitid].count_towed){
						summData[event.unitid].count_towed = 0;
					}
					if(!summData[event.unitid].count_no_gps){
						summData[event.unitid].count_no_gps = 0;
					}
					if(!summData[event.unitid].events){
						summData[event.unitid].events = {};
					}

					let smallEvent = event.event.toLowerCase();

					if(smallEvent == 'alarm'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_alarm += 1;
					}else if(smallEvent == 'tamper'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_tamper += 1;
					}else if(smallEvent == 'idling'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_idling += 1;
					}else if(smallEvent == 'speed'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_speed += 1;
					}else if(smallEvent == 'hard_brake'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_break += 1;
					}else if(smallEvent == 'fuel_refill'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_fuel_refill += 1;
					}else if(smallEvent == 'fuel_alert'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_fuel_alert += 1;
					}else if(smallEvent == 'power_off'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_engine_off += 1;
					}else if(smallEvent == 'towed'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_towed += 1;
					}else if(smallEvent == 'no_gps'){
						summData[event.unitid].events[smallEvent] = smallEvent;
						summData[event.unitid].count_no_gps += 1;
					}
					if(!eventName[event.unitid]){
						eventName[event.unitid] = {};
					}
					if(!eventName[event.unitid][index]){
						eventName[event.unitid][index] = {};
					}
					eventName[event.unitid][index] = {plate:summData[event.unitid].plate,event:event.event};
					// mobile event summary end */
				});console.log(summData);
				let totalRow = {
					t_count_alarm: 0,
					t_count_tamper: 0,
					t_count_idling: 0,
					t_count_speed: 0,
					t_count_break: 0,
					t_count_fuel_refill: 0,
					t_count_fuel_alert: 0,
					t_count_engine_off: 0,
					t_count_towed: 0,
					t_count_no_gps: 0,
				};
				for(let index in summData){
					let mbl = summData[index];
					if(mbl.plate){
						let repData = {
							mobile: mbl.plate,
							alarm: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['alarm']+'" data-id="'+index+'" data-code="02">'+mbl.count_alarm+'</a>',
							tamper: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['tamper']+'" data-id="'+index+'" data-code="03">'+mbl.count_tamper+'</a>',
							idling: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['idling']+'" data-id="'+index+'" data-code="04">'+mbl.count_idling+'</a>',
							speed: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['speed']+'" data-id="'+index+'" data-code="05">'+mbl.count_speed+'</a>',
							break: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['hard_brake']+'" data-id="'+index+'" data-code="06">'+mbl.count_break+'</a>',
							refill: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['fuel_refill']+'" data-id="'+index+'" data-code="07">'+mbl.count_fuel_refill+'</a>',
							alert: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['fuel_alert']+'" data-id="'+index+'" data-code="08">'+mbl.count_fuel_alert+'</a>',
							off: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['power_off']+'" data-id="'+index+'" data-code="09">'+mbl.count_engine_off+'</a>',
							towed: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['towed']+'" data-id="'+index+'" data-code="10">'+mbl.count_towed+'</a>',
							no_gps: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['no_gps']+'" data-id="'+index+'" data-code="19">'+mbl.count_no_gps+'</a>'
						};
						this.reportData.push(repData);
					}
					totalRow.t_count_alarm +=  mbl.count_alarm;
					totalRow.t_count_tamper +=  mbl.count_tamper;
					totalRow.t_count_idling +=  mbl.count_idling;
					totalRow.t_count_speed +=  mbl.count_speed;
					totalRow.t_count_break +=  mbl.count_break;
					totalRow.t_count_fuel_refill +=  mbl.count_fuel_refill;
					totalRow.t_count_fuel_alert +=  mbl.count_fuel_alert;
					totalRow.t_count_engine_off +=  mbl.count_engine_off;
					totalRow.t_count_towed +=  mbl.count_towed;
					totalRow.t_count_no_gps +=  mbl.count_no_gps;
				};
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging:false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					dom: "Blf<t>rtip",
					"stateSave": true,
					buttons: [
						{
							extend: 'colvis',
							className: 'fa fa-eye',
							text: '',
						},
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore2c').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: 'Mobile Events Report Summary'
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore2c').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: 'Mobile Events Report Summary'
						}
					],
					columns: [
						{
							data: "mobile",
							width: "20%",
							title: "Mobile"
						},
						{
							data: "alarm",
							width: "8%",
							title: "Alarm"
						},
						{
							data: "tamper",
							width: "8%",
							title: "Tamper"
						},
						{
							data: "idling",
							width: "8%",
							title: "Idling"
						},
						{
							data: "speed",
							width: "8%",
							title: "Speed"
						},
						{
							data: "break",
							width: "8%"  ,
							title: "Brake"
						},
						{
							data: "refill",
							width: "8%",
							title: "Fuel Refill"
						},
						{
							data: "alert",
							width: "8%",
							title: "Fuel Alert"
						},
						{
							data: "off",
							width: "8%",
							title: "Power Off"
						},
						{
							data: "towed",
							width: "8%",
							title: "Towed"
						},
						{
							data: "no_gps",
							width: "8%" ,
							title: "No GPS" 
						}
					]
				};
				if($('#oncore2c') && $('#oncore2c_wrapper')[0]){
					$('#oncore2c_wrapper').remove();
					$('#oncore3').before('<table id="oncore2c" class="display table " cellspacing="0" width="100%"></table>');
				}
				this.table = $('#oncore2c').DataTable(options);
				this.reinitClickAction();
				$('.dataTables_scrollBody').scroll(function() {
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
				$('#oncore2c').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Mobile Events Report Summary</caption>');
				$('.dt-buttons').css('float','left');
				this.processingDetail = false;
			},
			err => {
				alert(err.statusText);
				this.processingDetail = false;
				if($('#oncore2c') && $('#oncore2c_wrapper')[0]){
					$('#oncore2c_wrapper').remove();
					$('#oncore3').before('<table id="oncore2c" class="display table " cellspacing="0" width="100%"></table>');
				}
			}
			);
		}else{
			this.outDetailsReport['mEvent'] = {};
			let eventShown:any = this.mvEventType;
			let listOpt = [
				//speed
				17,10,325,
				//idling
				92,108,
				//brake
				86,305,
				//power off
				12,101,
				//alarm
				327,335,95,25,7,85,84,116,11,
				//refuel
				339,
				//fuel alert
				338,45,
				//tamper
				58,59,
				//84,113,7,85,14,11,116
			];
			let vids:any = [];
			this.vehicles.forEach((vhclist) => {
				vids.push(vhclist.terminalNo);
			})
			this.vehicleSvc.getVehicleAlarmsAll(vids,startDate,endDate,listOpt)
			.subscribe((res) => {
				// this.vehicleSvc.getVehicleTracks(this.vehicleList,startDate,endDate,1)
				// .subscribe((details) => {
					this.eventDatas = res;
					let eventName = {};
					let engine_run = {};
					let tempObjEngine = {};
					let debugObj:any = {};
					this.eventDatas?.forEach((event, index) => {
						const dateStr = event.startTime;
						// Convert to ISO format (important)
						const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
						// Get milliseconds
						const timestamp = date.getTime();
						// Build .NET format
						const dotNetDate = "/Date(" + timestamp + "+0800)/";
						
						event.updated = (moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x'));
						event.unitid = event.deviceId;

						let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
						// if(formattedTime < startDate || formattedTime > endDate){
						// 	return;
						// }
						// mobile event summary - start
						if(!summData[event.unitid]){
							summData[event.unitid] = {};
							this.vehicles.forEach((vehicle,key) => {
								if(vehicle.terminalNo == event.unitid){
									summData[event.unitid].plate = vehicle.description;
								}
							});
						}
						
						if(!summData[event.unitid].count_alarm){
							summData[event.unitid].count_alarm = 0;
						}
						if(!summData[event.unitid].count_tamper){
							summData[event.unitid].count_tamper = 0;
						}
						if(!summData[event.unitid].count_idling){
							summData[event.unitid].count_idling = 0;
						}
						if(!summData[event.unitid].count_speed){
							summData[event.unitid].count_speed = 0;
						}
						if(!summData[event.unitid].count_break){
							summData[event.unitid].count_break = 0;
						}
						if(!summData[event.unitid].count_fuel_refill){
							summData[event.unitid].count_fuel_refill = 0;
						}
						if(!summData[event.unitid].count_fuel_alert){
							summData[event.unitid].count_fuel_alert = 0;
						}
						if(!summData[event.unitid].count_engine_off){
							summData[event.unitid].count_engine_off = 0;
						}
						if(!summData[event.unitid].count_towed){
							summData[event.unitid].count_towed = 0;
						}
						if(!summData[event.unitid].count_no_gps){
							summData[event.unitid].count_no_gps = 0;
						}
						if(!summData[event.unitid].events){
							summData[event.unitid].events = {};
						}

						let smallEventCode = event.alarmType;//event.alarmName.toLowerCase();
						let smallEvent = event.alarmType;
						let eventCodes:any = {
							alarm: "02",
							tamper: "03",
							idling: "04",
							speed: "05",
							hard_brake: "06",
							fuel_refill: "07",
							fuel_alert: "08",
							power_off: "09",
							towed: "10",
							no_gps: "19"
						};
						if(smallEventCode == "SOS(Adas)" || smallEventCode == "SOS(IPC)" || smallEventCode == "SOS(Passenger)" || smallEventCode == "SOS(Driver)"
							|| smallEventCode == "Exit Area" || smallEventCode == "Harsh Acceleration" || smallEventCode == "Harsh Cornering"
							|| smallEventCode == "Power Supply Low Voltage"
						){
							smallEvent = "alarm";
							summData[event.unitid].events[smallEvent] = "alarm";
							summData[event.unitid].count_alarm += 1;
						}else if(smallEventCode == "Light" || smallEventCode == "Illegal Start"){
							smallEvent = "tamper";
							summData[event.unitid].events[smallEvent] = "tamper";
							summData[event.unitid].count_tamper += 1;
						}else if(smallEventCode == "Device Idling Alarm" || smallEventCode == "Idling(Over 10 minutes)"){
							smallEvent = "idling";
							summData[event.unitid].events[smallEvent] = "idling";
							summData[event.unitid].count_idling += 1;
						}else if(smallEventCode == "OverSpeed(Adas)" || smallEventCode == "Area Overspeed" || smallEventCode == "Overspeed"){
							smallEvent = "speed";
							summData[event.unitid].events[smallEvent] = "speed";
							summData[event.unitid].count_speed += 1;
						}else if(smallEventCode == "Harsh Braking(Adas)" || smallEventCode == "Harsh Braking"){
							smallEvent = "hard_brake";
							summData[event.unitid].events[smallEvent] = "hard_brake";
							summData[event.unitid].count_break += 1;
						}else if(smallEventCode == "Refueling"){
							smallEvent = "fuel_refill";
							summData[event.unitid].events[smallEvent] = "fuel_refill";
							summData[event.unitid].count_fuel_refill += 1;
						}else if(smallEventCode == "Fuel Theft" || smallEventCode == "Oil Theft"){
							smallEvent = "fuel_alert";
							summData[event.unitid].events[smallEvent] = "fuel_alert";
							summData[event.unitid].count_fuel_alert += 1;
						}else if(smallEventCode == "Power OFF" || smallEventCode == "Power Supply Down"){
							smallEvent = "power_off";
							summData[event.unitid].events[smallEvent] = "power_off";
							summData[event.unitid].count_engine_off += 1;
						}else if(smallEventCode == 'towed'){
							smallEvent = "towed";
							summData[event.unitid].events[smallEvent] = "towed";
							summData[event.unitid].count_towed += 1;
						}else if(smallEventCode == 'no_gps'){
							smallEvent = "no_gps";
							summData[event.unitid].events[smallEvent] = "no_gps";
							summData[event.unitid].count_no_gps += 1;
						}
						if(!eventName[event.unitid]){
							eventName[event.unitid] = {};
						}
						if(!eventName[event.unitid][index]){
							eventName[event.unitid][index] = {};
						}
						event.event = summData[event.unitid].events[smallEvent];
						eventName[event.unitid][index] = {plate:summData[event.unitid].plate,event:event.event};

						if(!this.outDetailsReport['mEvent'][event.unitid]){
							this.outDetailsReport['mEvent'][event.unitid] = {};
						}
						if(!this.outDetailsReport['mEvent'][event.unitid][eventCodes[summData[event.unitid].events[smallEvent]]]){
							this.outDetailsReport['mEvent'][event.unitid][eventCodes[summData[event.unitid].events[smallEvent]]] = [];
						}
						(this.outDetailsReport['mEvent'][event.unitid][eventCodes[summData[event.unitid].events[smallEvent]]]).push(event);
						// mobile event summary end */
					});console.log(summData);
					let totalRow = {
						t_count_alarm: 0,
						t_count_tamper: 0,
						t_count_idling: 0,
						t_count_speed: 0,
						t_count_break: 0,
						t_count_fuel_refill: 0,
						t_count_fuel_alert: 0,
						t_count_engine_off: 0,
						t_count_towed: 0,
						t_count_no_gps: 0,
					};
					for(let index in summData){
						let mbl = summData[index];
						if(mbl.plate){
							let repData = {
								mobile: mbl.plate,
								alarm: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['alarm']+'" data-id="'+index+'" data-code="02">'+mbl.count_alarm+'</a>',
								tamper: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['tamper']+'" data-id="'+index+'" data-code="03">'+mbl.count_tamper+'</a>',
								idling: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['idling']+'" data-id="'+index+'" data-code="04">'+mbl.count_idling+'</a>',
								speed: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['speed']+'" data-id="'+index+'" data-code="05">'+mbl.count_speed+'</a>',
								break: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['hard_brake']+'" data-id="'+index+'" data-code="06">'+mbl.count_break+'</a>',
								refill: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['fuel_refill']+'" data-id="'+index+'" data-code="07">'+mbl.count_fuel_refill+'</a>',
								alert: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['fuel_alert']+'" data-id="'+index+'" data-code="08">'+mbl.count_fuel_alert+'</a>',
								off: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['power_off']+'" data-id="'+index+'" data-code="09">'+mbl.count_engine_off+'</a>',
								towed: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['towed']+'" data-id="'+index+'" data-code="10">'+mbl.count_towed+'</a>',
								no_gps: '<a class="fleetDtl" data-report="mEvent" data-event="'+mbl.events['no_gps']+'" data-id="'+index+'" data-code="19">'+mbl.count_no_gps+'</a>'
							};
							this.reportData.push(repData);
						}
						totalRow.t_count_alarm +=  mbl.count_alarm;
						totalRow.t_count_tamper +=  mbl.count_tamper;
						totalRow.t_count_idling +=  mbl.count_idling;
						totalRow.t_count_speed +=  mbl.count_speed;
						totalRow.t_count_break +=  mbl.count_break;
						totalRow.t_count_fuel_refill +=  mbl.count_fuel_refill;
						totalRow.t_count_fuel_alert +=  mbl.count_fuel_alert;
						totalRow.t_count_engine_off +=  mbl.count_engine_off;
						totalRow.t_count_towed +=  mbl.count_towed;
						totalRow.t_count_no_gps +=  mbl.count_no_gps;
					};
					let options = {
						data: this.reportData,
						//pageLength: 25,
						paging:false,
						responsive: false,
						scrollX: true,
						searching: false,
						destroy: true,
						dom: "Blf<t>rtip",
						"stateSave": true,
						buttons: [
							{
								extend: 'colvis',
								className: 'fa fa-eye',
								text: '',
							},
							{
								extend: 'excelHtml5',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore2c').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-excel-o rptBtn',
								text: '',
								title: 'Mobile Events Report Summary'
							}, {
								extend: 'pdfHtml5',
								orientation: 'landscape',
								pageSize: 'A4',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore2c').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-pdf-o rptBtn',
								text: '',
								title: 'Mobile Events Report Summary'
							}
						],
						columns: [
							{
								data: "mobile",
								width: "20%",
								title: "Mobile"
							},
							{
								data: "alarm",
								width: "8%",
								title: "Alarm"
							},
							{
								data: "tamper",
								width: "8%",
								title: "Tamper"
							},
							{
								data: "idling",
								width: "8%",
								title: "Idling"
							},
							{
								data: "speed",
								width: "8%",
								title: "Speed"
							},
							{
								data: "break",
								width: "8%"  ,
								title: "Brake"
							},
							{
								data: "refill",
								width: "8%",
								title: "Fuel Refill"
							},
							{
								data: "alert",
								width: "8%",
								title: "Fuel Alert"
							},
							{
								data: "off",
								width: "8%",
								title: "Power Off"
							},
							{
								data: "towed",
								width: "8%",
								title: "Towed"
							},
							{
								data: "no_gps",
								width: "8%" ,
								title: "No GPS" 
							}
						]
					};
					if($('#oncore2c') && $('#oncore2c_wrapper')[0]){
						$('#oncore2c_wrapper').remove();
						$('#oncore3').before('<table id="oncore2c" class="display table " cellspacing="0" width="100%"></table>');
					}
					this.table = $('#oncore2c').DataTable(options);
					this.reinitClickAction();
					$('.dataTables_scrollBody').scroll(function() {
						$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
					});
					$('#oncore2c').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Mobile Events Report Summary</caption>');
					$('.dt-buttons').css('float','left');
					this.processingDetail = false;
				})
			// })
		}
	}else if(this.reportType == this.reportOptions.iEvent){
		this.vehicleSvc.getAllMobileEvents('01',startDate,startDateOnly,endDateOnly)
		.subscribe((res) => {
			this.eventDatas = res;
			let eventName = {};
			let engine_run = {};
			let tempObjEngine = {};
			this.eventDatas.forEach((event, index) => {
				let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
				if(formattedTime < startDate || formattedTime > endDate){
					return;
				}
				// input event summary - start
				eventName[event.event] = index;
				if(!summData[event.unitid]){
					summData[event.unitid] = {};
					this.vehicles.forEach((vehicle,key) => {
						if(vehicle.unitid == event.unitid){
							summData[event.unitid].plate = vehicle.description;
						}
					});
				}
				if(!engine_run[event.unitid]){
					engine_run[event.unitid] = [];
					engine_run[event.unitid][event.event] = {};
				}else{
					if(!engine_run[event.unitid][event.event]){
						engine_run[event.unitid][event.event] = {};
					}
				}
				if(!summData[event.unitid].count_input1_on){
					summData[event.unitid].count_input1_on = 0;
				}
				if(!summData[event.unitid].count_input1_off){
					summData[event.unitid].count_input1_off = 0;
				}
				if(!summData[event.unitid].count_input2_on){
					summData[event.unitid].count_input2_on = 0;
				}
				if(!summData[event.unitid].count_input2_off){
					summData[event.unitid].count_input2_off = 0;
				}
				if(!summData[event.unitid].total_duration){
					summData[event.unitid].total_duration = '00:00:00';
				}

				if(event.event == 'Input1_On'){
					summData[event.unitid].count_input1_on += 1;

					if(!engine_run[event.unitid]['Input1_On'].tempObjEngine){
						engine_run[event.unitid]['Input1_On'].tempObjEngine = {};
						engine_run[event.unitid]['Input1_On'].tempObjEngine.startEvent_updated = event.updated;
					}
				}else if(event.event == 'Input1_Off' && engine_run[event.unitid]['Input1_On'] && engine_run[event.unitid]['Input1_On'].tempObjEngine){
					summData[event.unitid].count_input1_off += 1;

					if(!engine_run[event.unitid]['Input1_Off'].tempObjEngine){
						engine_run[event.unitid]['Input1_Off'].tempObjEngine = {};
						engine_run[event.unitid]['Input1_Off'].tempObjEngine.endEvent_updated = event.updated;
					}
					let from_mili = (engine_run[event.unitid]['Input1_Off'].tempObjEngine.endEvent_updated - engine_run[event.unitid]['Input1_On'].tempObjEngine.startEvent_updated);
					let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
					hours = (hours < 10)? '0'+hours : hours;
					let seconds:any = Math.floor((from_mili / 1000) % 60);
					seconds = (seconds < 10)? '0'+seconds : seconds;
					let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
					minutes = (minutes < 10)? '0'+minutes : minutes;
					let diff_dur = (hours + ':' + minutes + ":" + seconds);

					if(!summData[event.unitid].total_duration){
						summData[event.unitid].total_duration = '00:00:00';
					}
					summData[event.unitid].total_duration = this.vehicleSvc.addTwoTime(summData[event.unitid].total_duration, diff_dur);

					delete engine_run[event.unitid]['Input1_On'].tempObjEngine;
					delete engine_run[event.unitid]['Input1_Off'].tempObjEngine;
				}else if(event.event == 'Input2_On'){
					summData[event.unitid].count_input2_on += 1;

					if(!engine_run[event.unitid]['Input2_On'].tempObjEngine){
						engine_run[event.unitid]['Input2_On'].tempObjEngine = {};
						engine_run[event.unitid]['Input2_On'].tempObjEngine.startEvent_updated = event.updated;
					}
				}else if(event.event == 'Input2_Off' && engine_run[event.unitid]['Input2_On'] && engine_run[event.unitid]['Input2_On'].tempObjEngine){
					summData[event.unitid].count_input2_off += 1;

					if(!engine_run[event.unitid]['Input2_Off'].tempObjEngine){
						engine_run[event.unitid]['Input2_Off'].tempObjEngine = {};
						engine_run[event.unitid]['Input2_Off'].tempObjEngine.endEvent_updated = event.updated;
					}
					let from_mili = (engine_run[event.unitid]['Input2_Off'].tempObjEngine.endEvent_updated - engine_run[event.unitid]['Input2_On'].tempObjEngine.startEvent_updated);
					let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
					hours = (hours < 10)? '0'+hours : hours;
					let seconds:any = Math.floor((from_mili / 1000) % 60);
					seconds = (seconds < 10)? '0'+seconds : seconds;
					let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
					minutes = (minutes < 10)? '0'+minutes : minutes;
					let diff_dur = (hours + ':' + minutes + ":" + seconds);

					if(!summData[event.unitid].total_duration){
						summData[event.unitid].total_duration = '00:00:00';
					}
					summData[event.unitid].total_duration = this.vehicleSvc.addTwoTime(summData[event.unitid].total_duration, diff_dur);

					delete engine_run[event.unitid]['Input2_On'].tempObjEngine;
					delete engine_run[event.unitid]['Input2_Off'].tempObjEngine;
				}
				// input event summary end */
			});console.log(summData);
			for(let index in summData){
				let mbl = summData[index];
				if((mbl.count_input1_off + mbl.count_input2_off) > 0 && mbl.plate !== undefined){
					let c1 = mbl.count_input1_off < mbl.count_input1_on ? mbl.count_input1_off : mbl.count_input1_on;
					let c2 = mbl.count_input2_off < mbl.count_input2_on ? mbl.count_input2_off : mbl.count_input2_on;
					let repData = {
						mobile: '<a class="fleetDtl" data-report="iEvent" data-id="'+index+'">'+mbl.plate+'</a>',
						count: c1 + c2,
						duration: mbl.total_duration
					};
					this.reportData.push(repData);
				}
			};
			let options = {
				data: this.reportData,
				//pageLength: 25,
				paging:false,
				responsive: false,
				scrollX: true,
				searching: false,
				destroy: true,
				dom: "Blf<t>rtip",
				"stateSave": true,
				buttons: [
					{
						extend: 'colvis',
						className: 'fa fa-eye',
						text: '',
					},
					{
						extend: 'excelHtml5',
						exportOptions: {
							columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore2d').DataTable().column( idx ).visible();
						  }
						},
						className: 'fa fa-file-excel-o rptBtn',
						text: '',
						title: 'Inputs Events Report Summary'
					}, {
						extend: 'pdfHtml5',
						orientation: 'landscape',
						pageSize: 'A4',
						exportOptions: {
							columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore2d').DataTable().column( idx ).visible();
						  }
						},
						className: 'fa fa-file-pdf-o rptBtn',
						text: '',
						title: 'Inputs Events Report Summary'
					}
				],
				columns: [
					{
						data: "mobile",
						width: "35%",
						title: "Mobile"
					},
					{
						data: "count",
						width: "20%",
						title: "Input Count"
					},
					{
						data: "duration",
						width: "30%",
						title: "Input Duration"
					}
				]
			};
			if($('#oncore2d') && $('#oncore2d_wrapper')[0]){
				$('#oncore2d_wrapper').remove();
				$('#oncore3').before('<table id="oncore2d" class="display table " cellspacing="0" width="100%"></table>');
			}
			this.table = $('#oncore2d').DataTable(options);
			this.reinitClickAction();
			$('.dataTables_scrollBody').scroll(function(){
				$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
			});
			$('#oncore2d').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Inputs Events Report Summary</caption');
			$('.dt-buttons').css('float','left');
			this.processingDetail = false;
		},
		err => {
			alert(err.statusText);
			this.processingDetail = false;
			if($('#oncore2d') && $('#oncore2d_wrapper')[0]){
				$('#oncore2d_wrapper').remove();
				$('#oncore3').before('<table id="oncore2d" class="display table" cellspacing="0" width="100%"></table>');
			}
		}
		);
	}else if(this.reportType == this.reportOptions.ffUse){
		this.vehicleSvc.getAllMobileEvents('00',startDate,startDateOnly,endDateOnly)
		.subscribe((firstData) => {
			this.vehicleSvc.getAllMobileEvents('07',startDate,startDateOnly,endDateOnly)
			.subscribe((res) => {
				let frefDatas = res;
				this.eventDatas = firstData;
				let eventName = {};
				let engine_run = {};
				let tempObjEngine = {};
				this.eventDatas.forEach((event, index) => {
					let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
					if(formattedTime < startDate || formattedTime > endDate){
						return;
					}
					// fuel use summary - start
					if(!summData[event.unitid]){
						summData[event.unitid] = {};
						this.vehicles.forEach((vehicle,key) => {
							if(vehicle.unitid == event.unitid){
								summData[event.unitid].plate = vehicle.description;
								summData[event.unitid].mobile_idle = vehicle.idle_period;
								summData[event.unitid].mobile_fuel = vehicle.fuel_usage;
								summData[event.unitid].check_fuel = vehicle.checkfuel;
							}
						});
					}
					if(!eventName[event.unitid]){
						eventName[event.unitid] = {};
					}

					if(!engine_run[event.unitid]){
						engine_run[event.unitid] = {};
					}
					if(!summData[event.unitid].count_engine_on){
						summData[event.unitid].count_engine_on = 0;
					}
					if(!summData[event.unitid].count_engine_off){
						summData[event.unitid].count_engine_off = 0;   
					}
					if(!summData[event.unitid].count_complete){
						summData[event.unitid].count_complete = 0;   
					}
					if(event.event == "Engine_Off"){
						eventName[event.unitid][index] = {plate:summData[event.unitid].plate, event:event.event,level:event.level, refill:event.refill,odo:event.odometer, time: event.updated.format('YYYY-MM-DD HH:mm:ss')};
						if(engine_run[event.unitid].tempObjEngine){
							summData[event.unitid].count_engine_off += 1;

							engine_run[event.unitid].tempObjEngine.odometer.push(parseFloat(event.odometer));    

							let dist:any = Math.round(parseFloat(engine_run[event.unitid].tempObjEngine.odometer[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.odometer[0]));
							if(dist > 0){
								summData[event.unitid].count_complete += 1;
								engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
								engine_run[event.unitid].tempObjEngine.level.push(parseFloat(event.level));
								let total_level = (parseFloat(engine_run[event.unitid].tempObjEngine.level[0]) - parseFloat(engine_run[event.unitid].tempObjEngine.level[1])); 

								frefDatas.forEach((fr, ky) => {
									let formattedFrTime = (fr.updated).format('YYYY-MM-DD HH:mm:ss');
									if(formattedFrTime < startDate || formattedFrTime > endDate){
										return;
									}
									if(fr.unitid == event.unitid && (fr.updated > engine_run[event.unitid].tempObjEngine.updated[0] && fr.updated < engine_run[event.unitid].tempObjEngine.updated[1])){
										eventName[event.unitid][index] = {plate:summData[event.unitid].plate, event:fr.event,level:fr.level, refill:fr.refill,odo:fr.odometer, time: fr.updated.format('YYYY-MM-DD HH:mm:ss')};
										if(engine_run[event.unitid].tempObjEngine){
											if(!engine_run[event.unitid].tempObjEngine.refill){
												engine_run[event.unitid].tempObjEngine.refill = 0;
											}
											engine_run[event.unitid].tempObjEngine.refill += parseFloat(fr.refill);
											delete frefDatas[ky];
										}
									}
								});

								if(engine_run[event.unitid].tempObjEngine.refill){
									total_level += engine_run[event.unitid].tempObjEngine.refill;
								}
								let from_mili:any = (engine_run[event.unitid].tempObjEngine.updated[1] - engine_run[event.unitid].tempObjEngine.updated[0]);
								let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
								hours = (hours < 10)? '0'+hours : hours;
								let seconds:any = Math.floor((from_mili / 1000) % 60);
								seconds = (seconds < 10)? '0'+seconds : seconds;
								let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
								minutes = (minutes < 10)? '0'+minutes : minutes;
								let diff_dur = (hours + ':' + minutes + ":" + seconds);
								if(!summData[event.unitid].total_distance){
									summData[event.unitid].total_distance = 0;
								}
								if(!summData[event.unitid].total_duration){
									summData[event.unitid].total_duration = '00:00:00';
								}
								if(!summData[event.unitid].total_raw_duration){
									summData[event.unitid].total_raw_duration = 0;
								}
								if(!summData[event.unitid].total_level){
									summData[event.unitid].total_level = 0;
								}
								if(!summData[event.unitid].total_level_per_distance){
									summData[event.unitid].total_level_per_distance = 0;
								}
								if(!summData[event.unitid].total_distance_per_level){
									summData[event.unitid].total_distance_per_level = 0;
								}

								let tempSumm = parseFloat(summData[event.unitid].total_distance);
								tempSumm += parseFloat(dist);
								summData[event.unitid].total_distance = tempSumm;

								let tempDurrSumm = parseInt(summData[event.unitid].total_raw_duration);
								tempDurrSumm += parseInt(from_mili);
								let hoursT:any = Math.floor(tempDurrSumm / 1000 / 60 / 60);
								hoursT = (hoursT < 10)? '0'+hoursT : hoursT;
								let secondsT:any = Math.floor((tempDurrSumm / 1000) % 60);
								secondsT = (secondsT < 10)? '0'+secondsT : secondsT;
								let minutesT:any = Math.floor((tempDurrSumm / (60 * 1000)) % 60);
								minutesT = (minutesT < 10)? '0'+minutesT : minutesT;
								let diff_durT = (hours + ':' + minutesT + ":" + secondsT);
								summData[event.unitid].total_raw_duration += tempDurrSumm;
								let tempLvl = parseFloat(summData[event.unitid].total_level);
								summData[event.unitid].total_duration = this.vehicleSvc.addTwoTime(summData[event.unitid].total_duration, diff_dur);
								if(total_level < 0){
									total_level = 0;
								}
								tempLvl += total_level;
								summData[event.unitid].total_level = tempLvl;//.toFixed(2);                                        
								summData[event.unitid].total_level_per_distance = summData[event.unitid].total_level == 0? (0).toFixed(2) : (summData[event.unitid].total_level / summData[event.unitid].total_distance).toFixed(2);
								summData[event.unitid].total_distance_per_level = summData[event.unitid].total_level == 0? (0).toFixed(2) : (summData[event.unitid].total_distance / summData[event.unitid].total_level).toFixed(2);

								if(!summData[event.unitid].journeys){
									summData[event.unitid].journeys = {};
								}
								if(!summData[event.unitid].journeys[index]){
									summData[event.unitid].journeys[index] = {};
								}
								
								summData[event.unitid].journeys[index].duration = diff_dur;
								summData[event.unitid].journeys[index].start_level = engine_run[event.unitid].tempObjEngine.level[0];
								summData[event.unitid].journeys[index].end_level = engine_run[event.unitid].tempObjEngine.level[1];
							}
							delete engine_run[event.unitid].tempObjEngine;
						}
					}else if(event.event == "Engine_On"){
						eventName[event.unitid][index] = {plate:summData[event.unitid].plate, event:event.event,level:event.level, refill:event.refill,odo:event.odometer, time: event.updated.format('YYYY-MM-DD HH:mm:ss')};
						summData[event.unitid].count_engine_on += 1; 

						if(!engine_run[event.unitid].tempObjEngine){
							engine_run[event.unitid].tempObjEngine = {
								odometer:[],
								updated:[],
								level:[]
							};
						}
						engine_run[event.unitid].tempObjEngine.odometer.push(parseFloat(event.odometer));
						engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
						engine_run[event.unitid].tempObjEngine.level.push(parseFloat(event.level));
					}else if(event.event == "Fuel_Refill"){
						eventName[event.unitid][index] = {plate:summData[event.unitid].plate, event:event.event,level:event.level, refill:event.refill,odo:event.odometer, time: event.updated.format('YYYY-MM-DD HH:mm:ss')};
						if(engine_run[event.unitid].tempObjEngine){
							if(!engine_run[event.unitid].tempObjEngine.refill){
								engine_run[event.unitid].tempObjEngine.refill = 0;
							}
							engine_run[event.unitid].tempObjEngine.refill += parseFloat(event.refill);
						}
					}
					// fuel use end*/
				});
				for(let index in summData){
					let mbl = summData[index];
					if(mbl.total_distance > 0 && mbl.check_fuel == true && !isNaN(mbl.total_level) && mbl.plate !== undefined){
						let repData = {
							mobile: '<a class="fleetDtl" data-report="ffUse" data-id="'+index+'">'+mbl.plate+'</a>',
							count: mbl.count_complete,
							duration: mbl.total_duration,
							distance: Math.round(mbl.total_distance),
							level: mbl.total_level.toFixed(2),
							level_per_km: mbl.total_level_per_distance,
							km_per_level: mbl.total_distance_per_level
						};
						this.reportData.push(repData);
					}
				};
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging:false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					dom: "Blf<t>rtip",
					"stateSave": true,
					buttons: [
						{
							extend: 'colvis',
							className: 'fa fa-eye',
							text: '',
						},
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
								 let table_id = node.getAttribute('aria-controls');
								  return $('#oncore2e').DataTable().column( idx ).visible();
							  }
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: 'Fleet Fuel Use Report Summary'
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
								 let table_id = node.getAttribute('aria-controls');
								  return $('#oncore2e').DataTable().column( idx ).visible();
							  }
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: 'Fleet Fuel Use Report Summary'
						}
					],
					columns: [
						{
							data: "mobile",
							width: "24%",
							title: "Mobile"
						},
						{
							data: "count",
							width: "10%",
							title: "Count"
						},
						{
							data: "duration",
							width: "20%",
							title: "Duration"
						},
						{
							data: "distance",
							width: "15%",
							title: "Distance"
						},
						{
							data: "level",
							width: "10%",
							title: "Fuel Liter"
						},
						{
							data: "level_per_km",
							width: "10%",
							title: "Liter Per KM"
						},
						{
							data: "km_per_level",
							width: "10%",
							title: "KM Per Liter"
						}
					]
				};
				if($('#oncore2e') && $('#oncore2e_wrapper')[0]){
					$('#oncore2e_wrapper').remove();
					$('#oncore3').before('<table id="oncore2e" class="display table" cellspacing="0" width="100%"></table>');
				}
				this.table = $('#oncore2e').DataTable(options);
				this.reinitClickAction();
				$('.dataTables_scrollBody').scroll(function(){
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
				$('#oncore2e').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Fleet Fuel Use Report Summary</caption');
				$('.dt-buttons').css('float','left');
				this.processingDetail = false;
			},
			err => {
				alert(err.statusText);
				if($('#oncore2e') && $('#oncore2e_wrapper')[0]){
					$('#oncore2e_wrapper').remove();
					$('#oncore3').before('<table id="oncore2e" class="display table" cellspacing="0" width="100%"></table>');
				}
				this.processingDetail = false;
			});
		},
		err => {
			alert(err.statusText);
			this.processingDetail = false;
			if($('#oncore2e') && $('#oncore2e_wrapper')[0]){
				$('#oncore2e_wrapper').remove();
				$('#oncore3').before('<table id="oncore2e" class="display table" cellspacing="0" width="100%"></table>');
			}
		}
		);
	}else if(this.reportType == this.reportOptions.frEvent){
		this.vehicleSvc.getAllMobileEvents('07',startDate,startDateOnly,endDateOnly)
		.subscribe((res) => {
			this.eventDatas = res;
			let eventName = {};
			let engine_run = {};
			let tempObjEngine = {};
			this.eventDatas.forEach((event, index) => {
				let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
				if(formattedTime < startDate || formattedTime > endDate){
					return;
				}
				// fuel refill summary - start
				if(!summData[event.unitid]){
					summData[event.unitid] = {};
					this.vehicles.forEach((vehicle,key) => {
						if(vehicle.unitid == event.unitid){
							summData[event.unitid].plate = vehicle.description;
						}
						if(vehicle.checkfuel == false){
							let zerorise = 0;
							summData[event.unitid].refill = zerorise;
						}
					});
				}
				if(!summData[event.unitid].count_refill){
					summData[event.unitid].count_refill = 0;   
				}
				if(!summData[event.unitid].refill){
					summData[event.unitid].refill = 0;   
				}
				if(event.event == "Fuel_Refill"){
					summData[event.unitid].count_refill += 1;
					let floatRef = parseFloat(summData[event.unitid].refill);
					let sumRef = floatRef + parseFloat(event.refill);
					summData[event.unitid].refill = sumRef.toFixed(2);
				}
				// fuel refill summary end*/
			});console.log(summData);
			let totalRow = {
				t_count: 0,
				t_refill: 0
			};
			for(let index in summData){
				let mbl = summData[index];
				if(mbl.count_refill > 0 && mbl.plate !== undefined){
					let repData = {
						mobile: '<a class="fleetDtl" data-report="frEvent" data-id="'+index+'">'+mbl.plate+'</a>',
						count: mbl.count_refill,
						refill: mbl.refill
					};
					this.reportData.push(repData);
				}
				totalRow['t_refill'] += parseFloat(mbl.refill);
				totalRow['t_count'] += mbl.count_refill;
			};
			let options = {
				data: this.reportData,
				//pageLength: 25,
				paging:false,
				responsive: false,
				scrollX: true,
				searching: false,
				destroy: true,
				dom: "Blf<t>rtip",
				"stateSave": true,
				buttons: [
					{
						extend: 'colvis',
						className: 'fa fa-eye',
						text: '',
					},
					{
						extend: 'excelHtml5',
						exportOptions: {
							columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore2f').DataTable().column( idx ).visible();
						  }
						},
						className: 'fa fa-file-excel-o rptBtn',
						text: '',
						title: 'Fuel Refill Report Summary'
					}, {
						extend: 'pdfHtml5',
						orientation: 'landscape',
						pageSize: 'A4',
						exportOptions: {
							columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore2f').DataTable().column( idx ).visible();
						  }
						},
						className: 'fa fa-file-pdf-o rptBtn',
						text: '',
						title: 'Fuel Refill Report Summary'
					}
				],
				columns: [
					{
						data: "mobile",
						width: "35%",
						title: "Mobile"
					},
					{
						data: "count",
						width: "20%",
						title: "Count"
					},
					{
						data: "refill",
						width: "25%",
						title: "Amount"
					}
				]
			};
			if($('#oncore2f') && $('#oncore2f_wrapper')[0]){
				$('#oncore2f_wrapper').remove();
				$('#oncore3').before('<table id="oncore2f" class="display table" cellspacing="0" width="100%"></table>');
			}
			this.table = $('#oncore2f').DataTable(options);
			this.reinitClickAction();
			$('.dataTables_scrollBody').scroll(function(){
				$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
			});
			$('#oncore2f').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Fuel Refill Report Summary</caption');
			$('.dt-buttons').css('float','left');
			this.processingDetail = false;
		},
		err => {
			alert(err.statusText);
			this.processingDetail = false;
			if($('#oncore2f') && $('#oncore2f_wrapper')[0]){
				$('#oncore2f_wrapper').remove();
				$('#oncore3').before('<table id="oncore2f" class="display table " cellspacing="0" width="100%"></table>');
			}
		}
		);
	}else if(this.reportType == this.reportOptions.fMovement){
		//redeclareVehicleSelection($scope.vehicleListGroupFilter);
		if(this.userObj.source == "oncore"){
			this.reportData = [];
			this.eventDatas = [];
			let unitId = this.vehicleList;
			if(!unitId){
				alert('Please select a vehicle');
				this.processingDetail = false;
				return false;
			}
			let listOpt = ['engine_on','engine_off','beacon','alarm','speed','idling','input'];
			this.vehicleSvc.getMobileEvent(unitId,startDate,endDate)
			.subscribe((res) => {
				this.eventDatas = res;
				let plate = '';
				let tanks = 0;
				let eventShown:any = this.mvEventType;
				let intervalShown:any = this.timeInterval;
				let startIntervalTime = 0;
				if($.inArray('others', eventShown) !== -1){
					$.each(listOpt, (ind, val) => {
						if($.inArray(val, eventShown) != -1){
							delete listOpt[ind];
						}
					});
				}
				this.eventDatas.forEach((event, index) => {
					let summData:any = {};
					this.vehicles.forEach((vehicle,key) => {
						if(vehicle.unitid == event.unitid){
							plate = vehicle.description;
							tanks = vehicle.tankreserve;
						}
					});
					if($.inArray('all', eventShown) == -1){
						if($.inArray('others', eventShown) != -1){
							if($.inArray(event.event.toLowerCase(), listOpt) != -1 ){
								return
							}
						}else{
							if(($.inArray(event.event.toLowerCase(), eventShown) == -1 )){
								return;
							}
						}
					}
					// if($.inArray("others", eventShown) == -1){console.log(event.event.toLowerCase(), eventShown);
						
					// }
					if(intervalShown != 'all'){
						intervalShown = parseInt(intervalShown);
						if(event.event.toLowerCase() == 'time'){
							if(startIntervalTime == 0){
								startIntervalTime = event.updated;
							}
							let currentTime = event.updated;
							let from_mili:any = currentTime - startIntervalTime; 
							let minutes = Math.floor((from_mili / (60 * 1000)) % 60);
							if(minutes < intervalShown && minutes != 0){
								return;
							}
							startIntervalTime = currentTime;
						}
					}
					let locData = event.location;
					// if(this.locationPreference == "1"){
					let coordData = event.lat + ", " + event.lon;
					// }
					summData = {
						time: event.updated.format('DD-MM-YYYY HH:mm:ss'),
						event: event.event,
						speed: event.speed,
						engine: event.engine,
						odometer: parseFloat(event.odometer).toFixed(2),
						gps: event.gpsstatus,
						level: (parseFloat(event.level) + tanks).toFixed(2),
						location: locData,
						coordinate: '<a class="clickable rpt-coord" data-lat="'+event.lat+'" data-lon="'+event.lon+'" data-loc="'+event.location+'">' + coordData + '</a>'
					};
					if(summData && summData.time){
						this.reportData.push(summData);
					}
				});
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging: false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					//dom: '<lf<t>ip>',
					dom: "Blf<t>rtip",
					"stateSave": true,
					buttons: [
						{
							extend: 'colvis',
							className: 'fa fa-eye',
							text: '',
						},
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore2').DataTable().column( idx ).visible();
								}
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: 'Full Movement Report - '+plate
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore2').DataTable().column( idx ).visible();
								}
								// columns: ':visible'
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: 'Full Movement Report - '+plate
						}
					],
					columns: [
						{
							data: "time",
							width: "15%",
							title: "Time"
						},
						{
							data: "event",
							width: "15%",
							title: "Event"
						},
						{
							data: "speed",
							width: "10%",
							title: "Speed"
						},
						{
							data: "engine",
							width: "5%",
							title: "Engine"
						},
						{
							data: "odometer",
							width: "10%",
							title: "Odometer"
						},
						{
							data: "gps",
							width: "10%",
							title: "GPS" 
						},
						{
							data: "level",
							width: "5%",
							title: "Fuel"
						},
						{
							data: "coordinate",
							width: "10%",
							title: "Coordinate"
						},
						{
							data: "location",
							width: "20%",
							title: "Location"
						}
					]
				};
				if($('#oncore2') && $('#oncore2_wrapper')[0]){
					$('#oncore2_wrapper').remove();
					$('#oncore3').before('<table id="oncore2" class="display table" cellspacing="0" width="100%"></table>');
				}
				this.table = $('#oncore2').DataTable(options);
				this.reinitClickAction();
				$('.dataTables_scrollBody').scroll(function(){
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
				if(unitId){
					
				}else{
					//table.destroy();
					//$(element).html('');
				}
				$('.dt-buttons').css('float','left');
				setTimeout(() => {
					$.each($('#oncore2').children('tbody').find('tr'), () => {
						$(this).children('td:last').css({'white-space':'unset', 'min-width':'255px'});
					});
					$.each($('#oncore2').children('thead').find('tr'), () => {
						$(this).children('th:last').css({'white-space':'unset', 'min-width':'255px'});
					});
					let arrayWdt = [];
					$.each($('.dataTables_scrollBody').find('tbody tr:first td'),function(idx){
						let rowBody = ($(this).width()-28)+"px";
						arrayWdt.push(rowBody);
					});	
					$.each($('.dataTables_scrollHeadInner').find('thead th'),function(idx){
						$(this).css({'min-width':arrayWdt[idx]});
					});	
				}, 1000);
				this.processingDetail = false;
			},
			err => {
				alert(err.statusText);
				this.processingDetail = false;
				if($('#oncore2') && $('#oncore2_wrapper')[0]){
					$('#oncore2_wrapper').remove();
					$('#oncore3').before('<table id="oncore2" class="display table " cellspacing="0" width="100%"></table>');
				}
			}
			);
		}else if(this.userObj.source == "bsj"){
			this.reportData = [];
			this.eventDatas = [];
			this.outDetailsReport['fMovement'] = [];
			let unitId = this.vehicleListBsj;
			if(!unitId){
				alert('Please select a vehicle');
				this.processingDetail = false;
				return false;
			}
			let eventShown:any = this.mvEventType;
			let is_engine_on = false;
			let is_engine_off = false;
			let listOpt = ['engine_on','engine_off','beacon','alarm','speed','idling','input'];
			let eventCodes:any = [];
			eventShown.forEach((ev) => {
				if(this.eventOuts[ev]){
					this.eventOuts[ev].forEach((eot) => {
						eventCodes.push(eot);
					})
				}
				if(ev == 'engine_on'){
					is_engine_on = true;
				}
				if(ev == 'engine_off'){
					is_engine_off = true;
				}
			})
			this.vehicleSvc.getVehicleTracks(unitId,startDate,endDate,1)
			.subscribe((details) => {
				this.vehicleSvc.getVehicleAlarmsAll([unitId],startDate,endDate,eventCodes)
				.subscribe((res) => {	
					this.eventDatas = res;
					let plate = '';
					let tanks = 0;
					let lastEgStt:any = {};
					let intervalShown:any = this.timeInterval;
					let startIntervalTime = 0;
					if($.inArray('others', eventShown) !== -1){
						$.each(listOpt, (ind, val) => {
							if($.inArray(val, eventShown) != -1){
								delete listOpt[ind];
							}
						});
					}
					details.forEach((event, index) => {
						let summData:any = {};
						this.vehicles.forEach((vehicle,key) => {
							if(vehicle.terminalNo == event.vehicleId){
								plate = vehicle.description;
								tanks = vehicle.tankreserve;
							}
						});
						const dateStr = event.devTime;
						// Convert to ISO format (important)
						const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
						// Get milliseconds
						const timestamp = date.getTime();
						// Build .NET format
						const dotNetDate = "/Date(" + timestamp + "+0800)/";
						
						event.updated = (moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x'));
						
						let locData = event.lat + ", " + event.lon;
						// if(this.locationPreference == "1"){
						let coordData = event.lat + ", " + event.lon;
						// }
						let pointTrack:any = {};
						let pointTrackBetween:any = [];
						res.forEach((track) => {
							if(track.startTime <= event.devTime && track.endTime >= event.devTime){
								pointTrack = track;
								return;
							}
							if((index+1) < details.length){
								const datePbtStr = track.startTime;
								const datePbt = new Date(datePbtStr.replace(' ', 'T') + '+08:00');
								const timestampPbt = datePbt.getTime();
								const dotNetDatePbt = "/Date(" + timestampPbt + "+0800)/";
								track.updated = (moment(dotNetDatePbt.substr(6).substr(0, dotNetDatePbt.indexOf('+') - 6), 'x'));

								if(track.startTime > event.devTime && track.endTime < details[index+1].devTime){
									pointTrackBetween.push(track);
									// return;
								}
							}
						});

						// if(is_engine_on && index == 0 && event.accState == 0){
						// 	summData = {
						// 		time: event.updated.format('DD-MM-YYYY HH:mm:ss'),
						// 		event: "Engine_On",
						// 		speed: event.speed,
						// 		engine: event.accState == 0? 'On': 'Off',
						// 		odometer: event.mileage,
						// 		gps: event.positionState == 1? 'Good':'Good*',
						// 		level: (event.oil).toFixed(2),
						// 		location: locData,
						// 		coordinate: '<a class="clickable rpt-coord" data-lat="'+event.lat+'" data-lon="'+event.lon+'" data-loc="'+event.location+'">' + coordData + '</a>'
						// 	};
						// 	if(summData && summData.time){
						// 		this.reportData.push(summData);
						// 	}
						// }
						if(!pointTrack.startTime){
							if($.inArray('all', eventShown) == -1){
								if($.inArray('others', eventShown) != -1){
									// if($.inArray(event.event.toLowerCase(), listOpt) != -1 ){
										return
									// }
								}else{
									// if(($.inArray(event.event.toLowerCase(), eventShown) == -1 )){
										return;
									// }
								}
							}
							// if($.inArray("others", eventShown) == -1){console.log(event.event.toLowerCase(), eventShown);
								
							// }
							if(intervalShown != 'all'){
								intervalShown = parseInt(intervalShown);
								// if(event.event.toLowerCase() == 'time'){
									if(startIntervalTime == 0){
										startIntervalTime = event.updated;
									}
									let currentTime = event.updated;
									let from_mili:any = currentTime - startIntervalTime; 
									let minutes = Math.floor((from_mili / (60 * 1000)) % 60);
									console.log('minutes',minutes + ' : ' + intervalShown);
									if(minutes < intervalShown && minutes != 0){
										return;
									}
									startIntervalTime = currentTime;
								// }
							}
						}
						let hasEOff = false;
						if(index > 0 && lastEgStt.accState != event.accState){
							// if(is_engine_on && event.accState == 0){
							// 	summData = {
							// 		time: event.updated.format('DD-MM-YYYY HH:mm:ss'),
							// 		event: "Engine_On",
							// 		speed: event.speed,
							// 		engine: event.accState == 0? 'On': 'Off',
							// 		odometer: event.mileage,
							// 		gps: event.positionState == 1? 'Good':'Good*',
							// 		level: (event.oil).toFixed(2),
							// 		location: locData,
							// 		coordinate: '<a class="clickable rpt-coord" data-lat="'+event.lat+'" data-lon="'+event.lon+'" data-loc="'+event.location+'">' + coordData + '</a>'
							// 	};
							// 	if(summData && summData.time){
							// 		this.reportData.push(summData);
							// 	}
							// 	hasEOff = true;
							// }else if(is_engine_off && event.accState == 1){
							// 	summData = {
							// 		time: event.updated.format('DD-MM-YYYY HH:mm:ss'),
							// 		event: "Engine_Off",
							// 		speed: event.speed,
							// 		engine: event.accState == 0? 'On': 'Off',
							// 		odometer: event.mileage,
							// 		gps: event.positionState == 1? 'Good':'Good*',
							// 		level: (event.oil).toFixed(2),
							// 		location: locData,
							// 		coordinate: '<a class="clickable rpt-coord" data-lat="'+event.lat+'" data-lon="'+event.lon+'" data-loc="'+event.location+'">' + coordData + '</a>'
							// 	};
							// 	if(summData && summData.time){
							// 		this.reportData.push(summData);
							// 	}
							// 	hasEOff = true;
							// }
						}
						let eventEvType = 'Time';
						if(pointTrack?.alarmType){
							eventEvType = pointTrack.alarmType;
						}else{
							if(event.accState == 1){
								// eventEvType = 'Beacon';
							}
						}
						summData = {
							time: event.updated.format('DD-MM-YYYY HH:mm:ss'),
							event: eventEvType,
							speed: event.speed,
							engine: event.accState == 0? 'On': 'Off',
							odometer: event.mileage,
							gps: event.positionState == 1? 'Good':'Good*',
							level: (event.oil).toFixed(2),
							location: locData,
							coordinate: '<a class="clickable rpt-coord" data-lat="'+event.lat+'" data-lon="'+event.lon+'" data-loc="'+event.location+'">' + coordData + '</a>'
						};
						if(!hasEOff && summData && summData.time){
							this.reportData.push(summData);
						}
						if(pointTrackBetween.length > 0){
							pointTrackBetween.forEach((ptb) => {
								let locPrefRaw = (ptb.lonAndLat).split(',');
								let ptbLat = locPrefRaw[1];
								let ptbLon = locPrefRaw[0];
								let pbtCoord = ptbLat + "," + ptbLon;
								summData = {
									time: ptb.updated.format('DD-MM-YYYY HH:mm:ss'),
									event: ptb.alarmType,
									speed: event.speed,
									engine: event.accState == 0? 'On': 'Off',
									odometer: event.mileage,
									gps: event.positionState == 1? 'Good':'Good*',
									level: (event.oil).toFixed(2),
									location: pbtCoord,
									coordinate: '<a class="clickable rpt-coord" data-lat="'+ptbLat+'" data-lon="'+ptbLon+'" data-loc="'+pbtCoord+'">' + pbtCoord + '</a>'
								};
								if(summData && summData.time){
									this.reportData.push(summData);
								}
							})
						}
						lastEgStt = event;
					});
					let options = {
						data: this.reportData,
						//pageLength: 25,
						paging: false,
						responsive: false,
						scrollX: true,
						searching: false,
						destroy: true,
						//dom: '<lf<t>ip>',
						dom: "Blf<t>rtip",
						"stateSave": true,
						buttons: [
							{
								extend: 'colvis',
								className: 'fa fa-eye',
								text: '',
							},
							{
								extend: 'excelHtml5',
								exportOptions: {
									columns: ( idx, data, node ) => {
										let table_id = node.getAttribute('aria-controls');
										return $('#oncore2').DataTable().column( idx ).visible();
									}
								},
								className: 'fa fa-file-excel-o rptBtn',
								text: '',
								title: 'Full Movement Report - '+plate
							}, {
								extend: 'pdfHtml5',
								orientation: 'landscape',
								pageSize: 'A4',
								exportOptions: {
									columns: ( idx, data, node ) => {
										let table_id = node.getAttribute('aria-controls');
										return $('#oncore2').DataTable().column( idx ).visible();
									}
									// columns: ':visible'
								},
								className: 'fa fa-file-pdf-o rptBtn',
								text: '',
								title: 'Full Movement Report - '+plate
							}
						],
						columns: [
							{
								data: "time",
								width: "15%",
								title: "Time"
							},
							{
								data: "event",
								width: "15%",
								title: "Event"
							},
							{
								data: "speed",
								width: "10%",
								title: "Speed"
							},
							{
								data: "engine",
								width: "5%",
								title: "Engine"
							},
							{
								data: "odometer",
								width: "10%",
								title: "Odometer"
							},
							{
								data: "gps",
								width: "10%",
								title: "GPS" 
							},
							{
								data: "level",
								width: "5%",
								title: "Fuel"
							},
							{
								data: "coordinate",
								width: "10%",
								title: "Coordinate"
							},
							{
								data: "location",
								width: "20%",
								title: "Location"
							}
						]
					};
					if($('#oncore2') && $('#oncore2_wrapper')[0]){
						$('#oncore2_wrapper').remove();
						$('#oncore3').before('<table id="oncore2" class="display table" cellspacing="0" width="100%"></table>');
					}
					this.table = $('#oncore2').DataTable(options);
					this.reinitClickAction();
					$('.dataTables_scrollBody').scroll(function(){
						$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
					});
					if(unitId){
						
					}else{
						//table.destroy();
						//$(element).html('');
					}
					$('.dt-buttons').css('float','left');
					setTimeout(() => {
						$.each($('#oncore2').children('tbody').find('tr'), () => {
							$(this).children('td:last').css({'white-space':'unset', 'min-width':'255px'});
						});
						$.each($('#oncore2').children('thead').find('tr'), () => {
							$(this).children('th:last').css({'white-space':'unset', 'min-width':'255px'});
						});
						let arrayWdt = [];
						$.each($('.dataTables_scrollBody').find('tbody tr:first td'),function(idx){
							let rowBody = ($(this).width()-28)+"px";
							arrayWdt.push(rowBody);
						});	
						$.each($('.dataTables_scrollHeadInner').find('thead th'),function(idx){
							$(this).css({'min-width':arrayWdt[idx]});
						});	
					}, 1000);
					this.processingDetail = false;
				});
			},
			err => {
				alert(err.statusText);
				this.processingDetail = false;
				if($('#oncore2') && $('#oncore2_wrapper')[0]){
					$('#oncore2_wrapper').remove();
					$('#oncore3').before('<table id="oncore2" class="display table " cellspacing="0" width="100%"></table>');
				}
			}
			);
		}else{
			this.reportData = [];
			this.eventDatas = [];
			this.outDetailsReport['fMovement'] = [];
			let unitId = this.vehicleListBsj;
			if(!unitId){
				alert('Please select a vehicle');
				this.processingDetail = false;
				return false;
			}
			let eventShown:any = this.mvEventType;
			let is_engine_on = false;
			let is_engine_off = false;
			let listOpt = ['engine_on','engine_off','beacon','alarm','speed','idling','input'];
			let eventCodes:any = [];
			eventShown.forEach((ev) => {
				if(this.eventTracksolids[ev]){
					this.eventTracksolids[ev].forEach((eot) => {
						eventCodes.push(eot);
					})
				}
				if(ev == 'engine_on'){
					is_engine_on = true;
				}
				if(ev == 'engine_off'){
					is_engine_off = true;
				}
			});
			let localStartDate = new Date(startDate);
			let localEndDate = new Date(endDate);
			localStartDate.setTime(localStartDate.getTime() - 28800000);
			localEndDate.setTime(localEndDate.getTime() - 28800000);
			this.vehicleSvc.getVehicleTripTracksolid(unitId,moment(localStartDate).format("YYYY-MM-DD HH:mm:ss"),moment(localEndDate).format("YYYY-MM-DD HH:mm:ss"))
			.subscribe((details) => {
				this.vehicleSvc.getVehicleTracksolidAlarmsAll([unitId],moment(localStartDate).format("YYYY-MM-DD HH:mm:ss"),moment(localEndDate).format("YYYY-MM-DD HH:mm:ss"))
				.subscribe((res) => {	
					this.eventDatas = res;
					let plate = '';
					let tanks = 0;
					let lastEgStt:any = {};
					let intervalShown:any = this.timeInterval;
					let startIntervalTime = 0;
					if($.inArray('others', eventShown) !== -1){
						$.each(listOpt, (ind, val) => {
							if($.inArray(val, eventShown) != -1){
								delete listOpt[ind];
							}
						});
					}
					details.forEach((event, index) => {
						let summData:any = {};
						this.vehicles.forEach((vehicle,key) => {
							if(vehicle.unitid == unitId){
								plate = vehicle.description;
								tanks = vehicle.tankreserve;
							}
						});
						const dateStr = event.gpsTime;
						// Convert to ISO format (important)
						const date = new Date(dateStr.replace(' ', 'T') + '+00:00');
						// Get milliseconds
						const timestamp = date.getTime();
						// Build .NET format
						const dotNetDate = "/Date(" + timestamp + "+0800)/";
						
						event.updated = (moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x'));
						event.lon = event.lng;
						let locData = event.lat + ", " + event.lon;
						// if(this.locationPreference == "1"){
						let coordData = event.lat + ", " + event.lon;
						// }
						let pointTrack:any = {};
						let pointTrackBetween:any = [];
						res.forEach((track) => {
							if(track.alertTime <= event.gpsTime && track.alertTime >= event.gpsTime){
								pointTrack = track;
								return;
							}
							if((index+1) < details.length){
								const datePbtStr = track.alertTime;
								const datePbt = new Date(datePbtStr.replace(' ', 'T') + '+08:00');
								const timestampPbt = datePbt.getTime();
								const dotNetDatePbt = "/Date(" + timestampPbt + "+0800)/";
								track.updated = (moment(dotNetDatePbt.substr(6).substr(0, dotNetDatePbt.indexOf('+') - 6), 'x'));

								if(track.alertTime > event.gpsTime && track.alertTime < details[index+1].gpsTime){
									pointTrackBetween.push(track);
									// return;
								}
							}
						});

						if(!pointTrack.alertTime){
							if($.inArray('all', eventShown) == -1){
								if($.inArray('others', eventShown) != -1){
									// if($.inArray(event.event.toLowerCase(), listOpt) != -1 ){
										return
									// }
								}else{
									// if(($.inArray(event.event.toLowerCase(), eventShown) == -1 )){
										return;
									// }
								}
							}
							// if($.inArray("others", eventShown) == -1){console.log(event.event.toLowerCase(), eventShown);
								
							// }
							if(intervalShown != 'all'){
								intervalShown = parseInt(intervalShown);
								// if(event.event.toLowerCase() == 'time'){
									if(startIntervalTime == 0){
										startIntervalTime = event.updated;
									}
									let currentTime = event.updated;
									let from_mili:any = currentTime - startIntervalTime; 
									let minutes = Math.floor((from_mili / (60 * 1000)) % 60);
									console.log('minutes',minutes + ' : ' + intervalShown);
									if(minutes < intervalShown && minutes != 0){
										return;
									}
									startIntervalTime = currentTime;
								// }
							}
						}
						let hasEOff = false;
						if(index > 0 && lastEgStt.accState != event.accState){
							
						}
						let eventEvType = 'Time';
						if(pointTrack?.alarmTypeName){
							eventEvType = pointTrack.alarmTypeName;
						}else{
							if(event.accState == 1){
								// eventEvType = 'Beacon';
							}
						}
						summData = {
							time: event.updated.format('DD-MM-YYYY HH:mm:ss'),
							event: eventEvType,
							speed: event.gpsSpeed,
							engine: event.accStatus == "0"? 'On': 'Off',
							odometer: '-',//event.mileage,
							gps: event.confidence > 1? 'Good':'Good*',
							level: '-',//(event.oil).toFixed(2),
							location: locData,
							coordinate: '<a class="clickable rpt-coord" data-lat="'+event.lat+'" data-lon="'+event.lon+'" data-loc="'+event.location+'">' + coordData + '</a>'
						};
						if(!hasEOff && summData && summData.time){
							this.reportData.push(summData);
						}
						if(pointTrackBetween.length > 0){
							pointTrackBetween.forEach((ptb) => {
								let locPrefRaw = (ptb.lonAndLat).split(',');
								let ptbLat = locPrefRaw[1];
								let ptbLon = locPrefRaw[0];
								let pbtCoord = ptbLat + "," + ptbLon;
								summData = {
									time: ptb.updated.format('DD-MM-YYYY HH:mm:ss'),
									event: ptb.alarmTypeName,
									speed: event.gpsSpeed,
									engine: event.accStatus == "0"? 'On': 'Off',
									odometer: '-',//event.mileage,
									gps: event.confidence > 1? 'Good':'Good*',
									level: '-',//(event.oil).toFixed(2),
									location: pbtCoord,
									coordinate: '<a class="clickable rpt-coord" data-lat="'+ptbLat+'" data-lon="'+ptbLon+'" data-loc="'+pbtCoord+'">' + pbtCoord + '</a>'
								};
								if(summData && summData.time){
									this.reportData.push(summData);
								}
							})
						}
						lastEgStt = event;
					});
					let options = {
						data: this.reportData,
						//pageLength: 25,
						paging: false,
						responsive: false,
						scrollX: true,
						searching: false,
						destroy: true,
						//dom: '<lf<t>ip>',
						dom: "Blf<t>rtip",
						"stateSave": true,
						buttons: [
							{
								extend: 'colvis',
								className: 'fa fa-eye',
								text: '',
							},
							{
								extend: 'excelHtml5',
								exportOptions: {
									columns: ( idx, data, node ) => {
										let table_id = node.getAttribute('aria-controls');
										return $('#oncore2').DataTable().column( idx ).visible();
									}
								},
								className: 'fa fa-file-excel-o rptBtn',
								text: '',
								title: 'Full Movement Report - '+plate
							}, {
								extend: 'pdfHtml5',
								orientation: 'landscape',
								pageSize: 'A4',
								exportOptions: {
									columns: ( idx, data, node ) => {
										let table_id = node.getAttribute('aria-controls');
										return $('#oncore2').DataTable().column( idx ).visible();
									}
									// columns: ':visible'
								},
								className: 'fa fa-file-pdf-o rptBtn',
								text: '',
								title: 'Full Movement Report - '+plate
							}
						],
						columns: [
							{
								data: "time",
								width: "15%",
								title: "Time"
							},
							{
								data: "event",
								width: "15%",
								title: "Event"
							},
							{
								data: "speed",
								width: "10%",
								title: "Speed"
							},
							{
								data: "engine",
								width: "5%",
								title: "Engine"
							},
							{
								data: "odometer",
								width: "10%",
								title: "Odometer"
							},
							{
								data: "gps",
								width: "10%",
								title: "GPS" 
							},
							{
								data: "level",
								width: "5%",
								title: "Fuel"
							},
							{
								data: "coordinate",
								width: "10%",
								title: "Coordinate"
							},
							{
								data: "location",
								width: "20%",
								title: "Location"
							}
						]
					};
					if($('#oncore2') && $('#oncore2_wrapper')[0]){
						$('#oncore2_wrapper').remove();
						$('#oncore3').before('<table id="oncore2" class="display table" cellspacing="0" width="100%"></table>');
					}
					this.table = $('#oncore2').DataTable(options);
					this.reinitClickAction();
					$('.dataTables_scrollBody').scroll(function(){
						$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
					});
					if(unitId){
						
					}else{
						//table.destroy();
						//$(element).html('');
					}
					$('.dt-buttons').css('float','left');
					setTimeout(() => {
						$.each($('#oncore2').children('tbody').find('tr'), () => {
							$(this).children('td:last').css({'white-space':'unset', 'min-width':'255px'});
						});
						$.each($('#oncore2').children('thead').find('tr'), () => {
							$(this).children('th:last').css({'white-space':'unset', 'min-width':'255px'});
						});
						let arrayWdt = [];
						$.each($('.dataTables_scrollBody').find('tbody tr:first td'),function(idx){
							let rowBody = ($(this).width()-28)+"px";
							arrayWdt.push(rowBody);
						});	
						$.each($('.dataTables_scrollHeadInner').find('thead th'),function(idx){
							$(this).css({'min-width':arrayWdt[idx]});
						});	
					}, 1000);
					this.processingDetail = false;
				});
			},
			err => {
				alert(err.statusText);
				this.processingDetail = false;
				if($('#oncore2') && $('#oncore2_wrapper')[0]){
					$('#oncore2_wrapper').remove();
					$('#oncore3').before('<table id="oncore2" class="display table " cellspacing="0" width="100%"></table>');
				}
			}
			);
		}
	}else if(this.reportType == this.reportOptions.fPark){
		let dropUnitId = this.vehicleList;
		if(this.userObj.source == "oncore"){
			this.vehicleSvc.getAllMobileEvents('00',startDate,startDateOnly,endDateOnly)
			.subscribe((firstData) => {
				this.vehicleSvc.getAllMobileEvents('04',startDate,startDateOnly,endDateOnly)
				.subscribe((res) => {
					let frefDatas = res;
					this.processingSummary = false;
					this.eventDatas = firstData;
					let eventName = {};
					let engine_run = {};
					let tempObjEngine = {};
					this.eventDatas?.forEach((event, index) => {
						if(dropUnitId){
							if(dropUnitId != event.unitid){
								return;
							}
						}
						let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
						if(formattedTime < startDate || formattedTime > endDate){
							return;
						}
						// fleet summary - start
						if(!summData[event.unitid]){
							summData[event.unitid] = {};
							this.vehicles.forEach((vehicle,key) => {
								if(vehicle.unitid == event.unitid){
									summData[event.unitid].plate = vehicle.description;
									summData[event.unitid].mobile_idle = parseFloat(vehicle.idle_period);
									summData[event.unitid].mobile_fuel = vehicle.fuel_usage;
								}
							});
							summData[event.unitid].fuel_liter = (0).toFixed(4);
							summData[event.unitid].idling = '00:00:00';
							summData[event.unitid].total_distance = (0).toFixed(2);
							summData[event.unitid].total_duration = '00:00:00';
							summData[event.unitid].total_level = (0).toFixed(4);
						}
						if(!engine_run[event.unitid]){
							engine_run[event.unitid] = {};
						}
						if(!summData[event.unitid].count_engine_on){
							summData[event.unitid].count_engine_on = 0;
						}
						if(!summData[event.unitid].count_engine_off){
							summData[event.unitid].count_engine_off = 0;   
						}
						if(!summData[event.unitid].count_idle){
							summData[event.unitid].count_idle = 0;   
						}
						if(event.event == "Engine_Off"){
							summData[event.unitid].count_engine_off += 1; 

							//if(!engine_run[event.unitid].tempObjEngine){
							engine_run[event.unitid].tempObjEngine = {
								odometer:[],
								updated:[],
								level:[]
							};
							//}
							engine_run[event.unitid].tempObjEngine.odometer.push(event.odometer);
							engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
							engine_run[event.unitid].tempObjEngine.level.push(event.level);
						}else if(event.event == "Engine_On"){
							if(engine_run[event.unitid].tempObjEngine){
								summData[event.unitid].count_engine_on += 1;

								engine_run[event.unitid].tempObjEngine.odometer.push(event.odometer);
								engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
								engine_run[event.unitid].tempObjEngine.level.push(event.level);

								
								frefDatas.forEach((fr, ky) => {
									let formattedFrTime = (fr.updated).format('YYYY-MM-DD HH:mm:ss');
									if(formattedFrTime < startDate || formattedFrTime > endDate){
										return;
									}
									if(fr.unitid == event.unitid && (fr.updated > engine_run[event.unitid].tempObjEngine.updated[0] && fr.updated < engine_run[event.unitid].tempObjEngine.updated[1])){
										//if(engine_run[event.unitid].tempObjEngine){
											summData[event.unitid].count_idle += 1; 
											let idle_raw:any = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle);
											summData[event.unitid].idle_raw = idle_raw;
											let idle_hours:any = Math.floor( idle_raw / 60);
											idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
											let idle_minutes:any = idle_raw % 60;
											idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
											let idle_time:any = idle_hours + ':' + idle_minutes + ':00';
											summData[event.unitid].idling = idle_time;

											delete frefDatas[ky];
										// }
									}
								});

								let dist = (parseFloat(engine_run[event.unitid].tempObjEngine.odometer[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.odometer[0])).toFixed(2);
								
								let total_level:any = parseFloat(engine_run[event.unitid].tempObjEngine.level[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.level[0]); 
								let from_mili:any = (engine_run[event.unitid].tempObjEngine.updated[1] - engine_run[event.unitid].tempObjEngine.updated[0]);
								let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
								hours = (hours < 10)? '0'+hours : hours;
								let seconds:any = Math.floor((from_mili / 1000) % 60);
								seconds = (seconds < 10)? '0'+seconds : seconds;
								let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
								minutes = (minutes < 10)? '0'+minutes : minutes;
								let diff_dur:any = (hours + ':' + minutes + ":" + seconds);
								if(!summData[event.unitid].total_distance){
									summData[event.unitid].total_distance = 0;
								}
								if(!summData[event.unitid].total_duration){
									summData[event.unitid].total_duration = '00:00:00';
								}
								if(!summData[event.unitid].total_level){
									summData[event.unitid].total_level = 0;
								}

								let tempSumm = parseFloat(summData[event.unitid].total_distance);
								tempSumm += parseFloat(dist);
								summData[event.unitid].total_distance = tempSumm.toFixed(2);
								let tempLvl = parseFloat(summData[event.unitid].total_level);
								tempLvl += total_level;
								summData[event.unitid].total_level = tempLvl;
								summData[event.unitid].total_duration = this.vehicleSvc.addTwoTime(summData[event.unitid].total_duration, diff_dur);                                    
								summData[event.unitid].fuel_liter = (summData[event.unitid].total_distance * parseFloat(summData[event.unitid].mobile_fuel));

								if(!summData[event.unitid].journeys){
									summData[event.unitid].journeys = {};
								}
								if(!summData[event.unitid].journeys[index]){
									summData[event.unitid].journeys[index] = {};
								}
								summData[event.unitid].journeys[index].dist = diff_dur;
								summData[event.unitid].journeys[index].start_time = engine_run[event.unitid].tempObjEngine.updated[0].format('YYYY-MM-DD HH:mm:ss');
								summData[event.unitid].journeys[index].end_time = engine_run[event.unitid].tempObjEngine.updated[1].format('YYYY-MM-DD HH:mm:ss');
								summData[event.unitid].journeys[index].start_level = engine_run[event.unitid].tempObjEngine.level[0];
								summData[event.unitid].journeys[index].end_level = engine_run[event.unitid].tempObjEngine.level[1];
								summData[event.unitid].journeys[index].start_odo = engine_run[event.unitid].tempObjEngine.odometer[0];
								summData[event.unitid].journeys[index].end_odo = engine_run[event.unitid].tempObjEngine.odometer[1];

								delete engine_run[event.unitid].tempObjEngine;
							}
						}else if(event.event == "Idling"){
							summData[event.unitid].count_idle += 1; 
							let idle_raw:any = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle);
							summData[event.unitid].idle_raw = idle_raw;
							let idle_hours:any = Math.floor( idle_raw / 60);
							idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
							let idle_minutes:any = idle_raw % 60;
							idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
							let idle_time:any = idle_hours + ':' + idle_minutes + ':00';
							summData[event.unitid].idling = idle_time;
						}
					});
					for(let index in summData){
						let mbl = summData[index];
						let noCount = (mbl.count_engine_on < mbl.count_engine_off) ? mbl.count_engine_on : mbl.count_engine_off;
						if(mbl.count_engine_off && mbl.plate !== undefined && noCount > 0){
							let repData = {
								mobile: '<a class="fleetDtl" data-report="fPark" data-id="'+index+'">'+mbl.plate+'</a>',
								count: (mbl.count_engine_on < mbl.count_engine_off) ? mbl.count_engine_on : mbl.count_engine_off,
								// distance: Math.round(mbl.total_distance),
								duration: mbl.total_duration,
								// idling: mbl.idling,
								// fuel_liter: 0 //mbl.fuel_liter.toFixed(2)
							};
							this.reportData.push(repData);
						}
					};
					console.log(summData);
					let options = {
						data: this.reportData,
						//pageLength: 25,
						paging: false,
						responsive: false,
						scrollX: true,
						searching: false,
						destroy: true,
						retrieve: true,
						//dom: '<lf<t>ip>',
						dom: "Blf<t>rtip",
						"stateSave": true,
						buttons: [
							{
								extend: 'colvis',
								className: 'fa fa-eye',
								text: '',
							},
							{
								extend: 'excelHtml5',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore2g').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-excel-o rptBtn',
								text: '',
								title: 'Fleet Parking Report Summary'
							}, {
								extend: 'pdfHtml5',
								orientation: 'landscape',
								pageSize: 'A4',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore2b').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-pdf-o rptBtn',
								text: '',
								title: 'Fleet Parking Report Summary'
							}
						],
						columns: [
							{
								data: "mobile",
								width: "20%",
								title: "Mobile"
							},
							{
								data: "count",
								width: "15%",
								title: "Count"
							},
							// {
							// 	data: "distance",
							// 	width: "15%",
							// 	title: "Distance"
							// },
							{
								data: "duration",
								width: "20%",
								title: "Duration"
							},
							// {
							// 	data: "idling",
							// 	width: "15%",
							// 	title: "Idling"
							// },
							// {
							// 	data: "fuel_liter",
							// 	width: "15%"  ,
							// 	title: "Fuel Liters"
							// }
						]
					};
					if($('#oncore2g') && $('#oncore2g_wrapper')[0]){
						$('#oncore2g_wrapper').remove();
						$('#oncore3').before('<table id="oncore2g" class="display table " cellspacing="0" width="100%"></table>');
					}
					this.table = $('#oncore2g').DataTable(options);
					this.reinitClickAction();
					$('.dataTables_scrollBody').scroll(function(){
						$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
					});
					$('#oncore2g').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Fleet Parking Report Summary</caption>');
					$('.dt-buttons').css('float','left');
					this.processingDetail = false;
				},
				(err) => {
					alert(err.statusText);
					if($('#oncore2g') && $('#oncore2g_wrapper')[0]){
						$('#oncore2_wrapper').remove();
						$('#oncore3').before('<table id="oncore2g" class="display table " cellspacing="0" width="100%"></table>');
					}
					this.processingDetail = false;
				})
			},
			err => {
				alert(err.statusText);
				if($('#oncore2g') && $('#oncore2g_wrapper')[0]){
					$('#oncore2g_wrapper').remove();
					$('#oncore3').before('<table id="oncore2g" class="display table " cellspacing="0" width="100%"></table>');
				}
				this.processingDetail = false;
			}
			);
		}else{
			let driveVhcls:any = [];
			if(this.vehicleListAlt.length > 0){
				driveVhcls = this.vehicleListAlt;
				if(this.vehicleListAlt.length > 10){
					alert('Only allow to select maximum 10 vehicles');
					this.processingDetail = false;
					return false;
				}
			}else{
				alert('Please select a vehicle');
				this.processingDetail = false;
				return false;
				// for(let key of this.objectKeys(this.selectionVehicle)){
				// 	driveVhcls.push(this.selectionVehicle[key].unitId);
				// }
			}
			this.vehicleSvc.getVehicleTrakcsAll(driveVhcls,startDate,endDate,1)
			.subscribe((res) => {
			// this.vehicleSvc.getVehicleTracks(this.vehicleList,startDate,endDate,1)
			// .subscribe((res) => {
				let frefDatas = res;
				this.processingSummary = false;
				this.eventDatas = res;
				let eventName = {};
				let engine_run = {};
				let tempObjEngine = {};
				let selectedVehicle:any = {};
				let lastIndex = 0;
				this.eventDatas?.forEach((event, index) => {
					const dateStr = event.devTime;
					// Convert to ISO format (important)
					const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
					// Get milliseconds
					const timestamp = date.getTime();
					// Build .NET format
					const dotNetDate = "/Date(" + timestamp + "+0800)/";
					
					event.updated = (moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x'));
					event.unitid = event.vehicleId;
					let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
					// fleet summary - start
					if(!summData[event.vehicleId]){
						summData[event.vehicleId] = {};
						this.vehicles.forEach((vehicle,key) => {
							// if((this.vehicleListAlt).includes(vehicle.terminalNo)){
							if(vehicle.vehicleId == event.unitid){
								summData[event.unitid].plate = vehicle.description;
								summData[event.unitid].mobile_idle = 0;
								summData[event.unitid].mobile_fuel = 0;
								summData[event.unitid].terminalNo = vehicle.terminalNo;
								selectedVehicle = vehicle;
								return;
							}
						});
						summData[event.unitid].fuel_liter = (0).toFixed(4);
						summData[event.unitid].idling = '00:00:00';
						summData[event.unitid].total_distance = (0).toFixed(2);
						summData[event.unitid].total_duration = '00:00:00';
						summData[event.unitid].total_level = (0).toFixed(4);
					}
					if(!engine_run[event.unitid]){
						engine_run[event.unitid] = {};
					}
					if(!summData[event.unitid].count_engine_on){
						summData[event.unitid].count_engine_on = 0;
					}
					if(!summData[event.unitid].count_engine_off){
						summData[event.unitid].count_engine_off = 0;   
					}
					if(!summData[event.unitid].count_idle){
						summData[event.unitid].count_idle = 0;   
					}
					if(!summData[event.unitid].count_idle){
						summData[event.unitid].idle_raw = 0;   
					}
					if(event.accState == 1){
						summData[event.unitid].count_engine_off += 1; 

						//if(!engine_run[event.unitid].tempObjEngine){
						engine_run[event.unitid].tempObjEngine = {
							odometer:[],
							updated:[],
							level:[]
						};
						//}
						engine_run[event.unitid].tempObjEngine.odometer.push(event.mileage);
						engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
						engine_run[event.unitid].tempObjEngine.level.push(event.oil);
					}else if(event.accState == 0){
						if(engine_run[event.unitid].tempObjEngine){
							summData[event.unitid].count_engine_on += 1;

							engine_run[event.unitid].tempObjEngine.odometer.push(event.mileage);
							engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
							engine_run[event.unitid].tempObjEngine.level.push(event.oil);

							
							// frefDatas.forEach((fr, ky) => {
							// 	let formattedFrTime = (fr.updated).format('YYYY-MM-DD HH:mm:ss');
							// 	if(formattedFrTime < startDate || formattedFrTime > endDate){
							// 		return;
							// 	}
							// 	if(fr.unitid == event.unitid && (fr.updated > engine_run[event.unitid].tempObjEngine.updated[0] && fr.updated < engine_run[event.unitid].tempObjEngine.updated[1])){
							// 		//if(engine_run[event.unitid].tempObjEngine){
							// 			summData[event.unitid].count_idle += 1; 
							// 			let idle_raw:any = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle);
							// 			summData[event.unitid].idle_raw = idle_raw;
							// 			let idle_hours:any = Math.floor( idle_raw / 60);
							// 			idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
							// 			let idle_minutes:any = idle_raw % 60;
							// 			idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
							// 			let idle_time:any = idle_hours + ':' + idle_minutes + ':00';
							// 			summData[event.unitid].idling = idle_time;

							// 			delete frefDatas[ky];
							// 		// }
							// 	}
							// });

							let dist = (parseFloat(engine_run[event.unitid].tempObjEngine.odometer[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.odometer[0])).toFixed(2);
							
							let total_level:any = parseFloat(engine_run[event.unitid].tempObjEngine.level[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.level[0]); 
							let from_mili:any = (engine_run[event.unitid].tempObjEngine.updated[1] - engine_run[event.unitid].tempObjEngine.updated[0]);
							let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
							hours = (hours < 10)? '0'+hours : hours;
							let seconds:any = Math.floor((from_mili / 1000) % 60);
							seconds = (seconds < 10)? '0'+seconds : seconds;
							let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
							minutes = (minutes < 10)? '0'+minutes : minutes;
							let diff_dur:any = (hours + ':' + minutes + ":" + seconds);
							if(!summData[event.unitid].total_distance){
								summData[event.unitid].total_distance = 0;
							}
							if(!summData[event.unitid].total_duration){
								summData[event.unitid].total_duration = '00:00:00';
							}
							if(!summData[event.unitid].total_level){
								summData[event.unitid].total_level = 0;
							}

							let tempSumm = parseFloat(summData[event.unitid].total_distance);
							tempSumm += parseFloat(dist);
							summData[event.unitid].total_distance = tempSumm.toFixed(2);
							let tempLvl = parseFloat(summData[event.unitid].total_level);
							tempLvl += total_level;
							summData[event.unitid].total_level = tempLvl;
							summData[event.unitid].total_duration = this.vehicleSvc.addTwoTime(summData[event.unitid].total_duration, diff_dur);                                    
							summData[event.unitid].fuel_liter = event.oil;

							if(!summData[event.unitid].journeys){
								summData[event.unitid].journeys = {};
							}
							if(!summData[event.unitid].journeys[index]){
								summData[event.unitid].journeys[index] = {};
							}
							lastIndex = index;
							summData[event.unitid].journeys[index].dist = diff_dur;
							summData[event.unitid].journeys[index].start_time = engine_run[event.unitid].tempObjEngine.updated[0].format('YYYY-MM-DD HH:mm:ss');
							summData[event.unitid].journeys[index].end_time = engine_run[event.unitid].tempObjEngine.updated[1].format('YYYY-MM-DD HH:mm:ss');
							summData[event.unitid].journeys[index].start_level = engine_run[event.unitid].tempObjEngine.level[0];
							summData[event.unitid].journeys[index].end_level = engine_run[event.unitid].tempObjEngine.level[1];
							summData[event.unitid].journeys[index].start_odo = engine_run[event.unitid].tempObjEngine.odometer[0];
							summData[event.unitid].journeys[index].end_odo = engine_run[event.unitid].tempObjEngine.odometer[1];

							delete engine_run[event.unitid].tempObjEngine;
						}
						if(event.runState == 3){
							summData[event.unitid].count_idle += 1; 
							let idle_raw:any = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle);
							summData[event.unitid].idle_raw = idle_raw;
							let idle_hours:any = Math.floor( idle_raw / 60);
							idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
							let idle_minutes:any = idle_raw % 60;
							idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
							let idle_time:any = idle_hours + ':' + idle_minutes + ':00';
							summData[event.unitid].idling = idle_time;
						}
					}
				});
				// if(engine_run[selectedVehicle.vehicleId] && engine_run[selectedVehicle.vehicleId].tempObjEngine
				// 	 && engine_run[selectedVehicle.vehicleId].tempObjEngine.updated[0] 
				// 	 && !engine_run[selectedVehicle.vehicleId].tempObjEngine.updated[1]
				// ){
				// 	let nextIdx = lastIndex + 1;
				// 	let from_mili:any = (engine_run[selectedVehicle.vehicleId].tempObjEngine.updated[1] - engine_run[selectedVehicle.vehicleId].tempObjEngine.updated[0]);
				// 	let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
				// 	hours = (hours < 10)? '0'+hours : hours;
				// 	let seconds:any = Math.floor((from_mili / 1000) % 60);
				// 	seconds = (seconds < 10)? '0'+seconds : seconds;
				// 	let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
				// 	minutes = (minutes < 10)? '0'+minutes : minutes;
				// 	let diff_dur:any = (hours + ':' + minutes + ":" + seconds);
				// 	summData[selectedVehicle.vehicleId].journeys = {};
				// 	if(!summData[selectedVehicle.vehicleId].journeys[nextIdx]){
				// 		summData[selectedVehicle.vehicleId].journeys[nextIdx] = {};
				// 	}
				// 	summData[selectedVehicle.vehicleId].journeys[nextIdx].dist = diff_dur;
				// 	summData[selectedVehicle.vehicleId].journeys[nextIdx].start_time = engine_run[selectedVehicle.vehicleId].tempObjEngine.updated[0].format('YYYY-MM-DD HH:mm:ss');
				// 	summData[selectedVehicle.vehicleId].journeys[nextIdx].end_time = moment(endDate).format('YYYY-MM-DD HH:mm:ss');
				// 	summData[selectedVehicle.vehicleId].journeys[nextIdx].start_level = engine_run[selectedVehicle.vehicleId].tempObjEngine.level[0];
				// 	summData[selectedVehicle.vehicleId].journeys[nextIdx].end_level = engine_run[selectedVehicle.vehicleId].tempObjEngine.level[0];
				// 	summData[selectedVehicle.vehicleId].journeys[nextIdx].start_odo = engine_run[selectedVehicle.vehicleId].tempObjEngine.odometer[0];
				// 	summData[selectedVehicle.vehicleId].journeys[nextIdx].end_odo = engine_run[selectedVehicle.vehicleId].tempObjEngine.odometer[0];

				// 	delete engine_run[selectedVehicle.vehicleId].tempObjEngine;
				// }
				// console.log('engine_run',engine_run)
				for(let index in summData){
					let mbl = summData[index];
					let noCount = (mbl.count_engine_on < mbl.count_engine_off) ? mbl.count_engine_on : mbl.count_engine_off;
					console.log(mbl, noCount);
					if(mbl.count_engine_off && mbl.plate !== undefined && noCount > 0){
						let repData = {
							mobile: '<a class="fleetDtl" data-report="fPark" data-id="'+mbl.terminalNo+'">'+mbl.plate+'</a>',
							count: (mbl.count_engine_on < mbl.count_engine_off) ? mbl.count_engine_on : mbl.count_engine_off,
							// distance: Math.round(mbl.total_distance),
							duration: mbl.total_duration,
							// idling: mbl.idling,
							// fuel_liter: 0 //mbl.fuel_liter.toFixed(2)
						};
						this.reportData.push(repData);
					}
				};
				console.log(summData);
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging: false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					retrieve: true,
					//dom: '<lf<t>ip>',
					dom: "Blf<t>rtip",
					"stateSave": true,
					buttons: [
						{
							extend: 'colvis',
							className: 'fa fa-eye',
							text: '',
						},
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore2g').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: 'Fleet Parking Report Summary'
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore2b').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: 'Fleet Parking Report Summary'
						}
					],
					columns: [
						{
							data: "mobile",
							width: "20%",
							title: "Mobile"
						},
						{
							data: "count",
							width: "15%",
							title: "Count"
						},
						// {
						// 	data: "distance",
						// 	width: "15%",
						// 	title: "Distance"
						// },
						{
							data: "duration",
							width: "20%",
							title: "Duration"
						},
						// {
						// 	data: "idling",
						// 	width: "15%",
						// 	title: "Idling"
						// },
						// {
						// 	data: "fuel_liter",
						// 	width: "15%"  ,
						// 	title: "Fuel Liters"
						// }
					]
				};
				if($('#oncore2g') && $('#oncore2g_wrapper')[0]){
					$('#oncore2g_wrapper').remove();
					$('#oncore3').before('<table id="oncore2g" class="display table " cellspacing="0" width="100%"></table>');
				}
				this.table = $('#oncore2g').DataTable(options);
				this.reinitClickAction();
				$('.dataTables_scrollBody').scroll(function(){
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
				$('#oncore2g').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Fleet Parking Report Summary</caption>');
				$('.dt-buttons').css('float','left');
				this.processingDetail = false;
			},
			(err) => {
				alert(err.statusText);
				if($('#oncore2g') && $('#oncore2g_wrapper')[0]){
					$('#oncore2_wrapper').remove();
					$('#oncore3').before('<table id="oncore2g" class="display table " cellspacing="0" width="100%"></table>');
				}
				this.processingDetail = false;
			})
		}
	}else if(this.reportType == this.reportOptions.genCert){
		this.popupEditCert();
	}
	// else if(this.reportType == this.reportOptions.dMovement){
	// 	const dateFrom:any = new Date(startDate);
	// 	const dateTo:any = new Date(endDate);
	// 	const diffInMs:any = dateTo - dateFrom;
	// 	const diffInHours = (diffInMs / (1000 * 60 * 60));
	// 	const diffInDays = (diffInMs / (1000 * 60 * 60 * 24)) + 1;
	// 	let byDays:any = {};
	// 	this.outDetailsReport['dMovement'] = {};
	// 	if(this.userObj.source == "oncore"){
	// 		let dropUnitId = this.vehicleList;
	// 		this.vehicleSvc.getAllMobileEvents('00',startDate,startDateOnly,endDateOnly)
	// 		.subscribe((firstData) => {
	// 			this.vehicleSvc.getAllMobileEvents('04',startDate,startDateOnly,endDateOnly)
	// 			.subscribe((res) => {
	// 				let frefDatas = res;
	// 				this.processingSummary = false;
	// 				this.eventDatas = firstData;
	// 				let eventName = {};
	// 				let engine_run = {};
	// 				let tempObjEngine = {};
	// 				let vhclInfo:any = "";
	// 				this.eventDatas?.forEach((event, index) => {
	// 					if(dropUnitId){
	// 						if(dropUnitId != event.unitid){
	// 							return;
	// 						}
	// 					}
	// 					let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
	// 					if(formattedTime < startDate || formattedTime > endDate){
	// 						return;
	// 					}
	// 					let formattedDate = (event.updated).format('YYYY-MM-DD');
	// 					if(!byDays[event.unitid]){
	// 						byDays[event.unitid] = {};
	// 					}
	// 					if(!byDays[event.unitid][formattedDate]){
	// 						byDays[event.unitid][formattedDate] = [];
	// 					}
	// 					event.formattedTime = formattedTime;
	// 					byDays[event.unitid][formattedDate].push(event);
	// 				});
	// 				let index = 0;
	// 				let summByDays:any = {};
	// 				let prevEv:any = {};
	// 				for(let vhunid in byDays){
	// 					let idxDay = 0;
	// 					let eventForVchls = byDays[vhunid];
	// 					for(let evDt in eventForVchls){
	// 						// fleet summary - start
	// 						let events = eventForVchls[evDt];
	// 						let prevTimestamp:any = "";
	// 						let currentState:any = "";
	// 						events.forEach((event, ixEv) => {
	// 							if(!summData[event.unitid]){
	// 								summData[event.unitid] = {};
	// 								this.vehicles.forEach((vehicle,key) => {
	// 									if(vehicle.unitid == event.unitid){
	// 										summData[event.unitid].plate = vehicle.description;
	// 										summData[event.unitid].mobile_idle = parseFloat(vehicle.idle_period);
	// 										summData[event.unitid].mobile_fuel = vehicle.fuel_usage;
	// 										vhclInfo = vehicle.description;
	// 									}
	// 								});
	// 								summData[event.unitid].fuel_liter = (0).toFixed(4);
	// 								summData[event.unitid].idling = '00:00:00';
	// 								summData[event.unitid].total_distance = (0).toFixed(2);
	// 								summData[event.unitid].total_duration = '00:00:00';
	// 								summData[event.unitid].total_level = (0).toFixed(4);
	// 							}
	// 							if(!summByDays[event.unitid]){
	// 								summByDays[event.unitid] = {};
	// 							}
	// 							if(!summByDays[event.unitid][evDt]){
	// 								summByDays[event.unitid][evDt] = {
	// 									parking:'00:00:00',
	// 									idling:'00:00:00',
	// 									driving:'00:00:00',
	// 									count_idling: 0,
	// 									plate: vhclInfo
	// 								};
	// 							}
	// 							summByDays[event.unitid][evDt].plate = vhclInfo;
	// 							let formattedDate = (event.updated).format('YYYY-MM-DD');

	// 							if(ixEv == 0){
	// 								let ondaystrat:any = moment(evDt + " 00:00:00");
	// 								if(idxDay == 0){
	// 									ondaystrat = moment(startDate);
	// 								}										
	// 								let from_mili:any = event.updated - ondaystrat;
	// 								let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
	// 								hours = (hours < 10)? '0'+hours : hours;
	// 								let seconds:any = Math.floor((from_mili / 1000) % 60);
	// 								seconds = (seconds < 10)? '0'+seconds : seconds;
	// 								let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
	// 								minutes = (minutes < 10)? '0'+minutes : minutes;	
	// 								if(event.event == 'Engine_Off' || event.event == 'Idling'){							
	// 									summByDays[event.unitid][evDt].driving = hours + ':' + minutes + ":" + seconds;
	// 								}else if(event.event == 'Engine_On'){
	// 									summByDays[event.unitid][evDt].parking = hours + ':' + minutes + ":" + seconds;
	// 								}
	// 							}else{
	// 								if(event.event != currentState){
	// 									let from_mili:any = (event.updated - prevTimestamp);
	// 									let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
	// 									hours = (hours < 10)? '0'+hours : hours;
	// 									let seconds:any = Math.floor((from_mili / 1000) % 60);
	// 									seconds = (seconds < 10)? '0'+seconds : seconds;
	// 									let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
	// 									minutes = (minutes < 10)? '0'+minutes : minutes;
	// 									let diff_dur:any = (hours + ':' + minutes + ":" + seconds);
	// 									let timeExist = "00:00:00";
	// 									let timngType:any = "";
	// 									if(event.event == "Engine_Off" || event.event == "Engine_On"){
	// 										if(event.event == "Engine_Off"){
	// 											timeExist = summByDays[event.unitid][evDt].driving;
	// 											timngType = "driving";

	// 											frefDatas.forEach((fr, ky) => {
	// 												let formattedFrTime = (fr.updated).format('YYYY-MM-DD HH:mm:ss');
	// 												if(formattedFrTime < startDate || formattedFrTime > endDate){
	// 													return;
	// 												}
	// 												let formattedFrDate = (fr.updated).format('YYYY-MM-DD');
	// 												if(index > 0 && formattedDate == formattedFrDate && prevEv[fr.unitid] && prevEv[fr.unitid][formattedDate] && fr.unitid == event.unitid && (fr.updated > prevEv[fr.unitid][formattedDate].updated && fr.updated < event.updated)){
	// 													fr.formattedTime = formattedFrTime;
	// 													summByDays[event.unitid][evDt].count_idling += 1;
	// 													let idle_raw:any = (summByDays[event.unitid][evDt].count_idling * summData[event.unitid].mobile_idle);
	// 													let idle_hours:any = Math.floor( idle_raw / 60);
	// 													idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
	// 													let idle_minutes:any = idle_raw % 60;
	// 													idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
	// 													let idle_time:any = idle_hours + ':' + idle_minutes + ':00';

	// 													summByDays[event.unitid][evDt].idling = idle_time;
	// 													delete frefDatas[ky];
	// 												}
	// 											});
	// 										}else if(event.event == "Engine_On"){
	// 											timeExist = summByDays[event.unitid][evDt].parking;
	// 											timngType = "parking";
	// 										} 
	// 										const time1 = timeExist;
	// 										const time2 = diff_dur;
	// 										// Create durations from the strings
	// 										const duration1 = moment.duration(time1);
	// 										const duration2 = moment.duration(time2);
	// 										// Add them together
	// 										const totalDuration = duration1.add(duration2);
	// 										// Format back to HH:mm:ss
	// 										// We use moment.utc() to avoid local timezone offsets when formatting
	// 										summByDays[event.unitid][evDt][timngType] = moment.utc(totalDuration.asMilliseconds()).format("HH:mm:ss");
	// 									}
	// 								}
	// 							}
	// 							if(ixEv == (events.length - 1)){
	// 								let ondaystrat:any = moment(evDt + " 00:00:00");
	// 								let nextDayStart = ondaystrat.clone().add(1, 'day');
	// 								if(idxDay == (eventForVchls.length - 1)){
	// 									let endSel = moment(endDate).clone().add(1, 'second');
	// 									nextDayStart = endSel;
	// 								}										
	// 								let from_mili:any = nextDayStart - event.updated;
	// 								let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
	// 								hours = (hours < 10)? '0'+hours : hours;
	// 								let seconds:any = Math.floor((from_mili / 1000) % 60);
	// 								seconds = (seconds < 10)? '0'+seconds : seconds;
	// 								let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
	// 								minutes = (minutes < 10)? '0'+minutes : minutes;
	// 								let diff_dur = hours + ':' + minutes + ":" + seconds	
	// 								let timeExist = "00:00:00";
	// 								let timngType:any = "";
	// 								if(event.event == "Engine_Off"){
	// 									timeExist = summByDays[event.unitid][evDt].parking;
	// 									timngType = "parking";
	// 								}else if(event.event == "Engine_On"){
	// 									timeExist = summByDays[event.unitid][evDt].driving;
	// 									timngType = "driving";
	// 								}else if(event.event == "Idling"){
	// 									timeExist = summByDays[event.unitid][evDt].idling;
	// 									timngType = "idling";
	// 								}

	// 								const time1 = timeExist;
	// 								const time2 = diff_dur;
	// 								// Create durations from the strings
	// 								const duration1 = moment.duration(time1);
	// 								const duration2 = moment.duration(time2);
	// 								// Add them together
	// 								const totalDuration = duration1.add(duration2);
	// 								// Format back to HH:mm:ss
	// 								// We use moment.utc() to avoid local timezone offsets when formatting
	// 								summByDays[event.unitid][evDt][timngType] = moment.utc(totalDuration.asMilliseconds()).format("HH:mm:ss");

	// 								const time1d = summByDays[event.unitid][evDt].driving;
	// 								const time2d = summByDays[event.unitid][evDt].idling;
	// 								// Create durations from the strings
	// 								const duration1d = moment.duration(time1d);
	// 								const duration2d = moment.duration(time2d);
	// 								// Add them together
	// 								const totalDurationd = duration1d.subtract(duration2d);
	// 								// Format back to HH:mm:ss
	// 								// We use moment.utc() to avoid local timezone offsets when formatting
	// 								summByDays[event.unitid][evDt].driving = moment.utc(totalDurationd.asMilliseconds()).format("HH:mm:ss");
	// 							}

	// 							prevTimestamp = event.updated;
	// 							currentState = event.event;

	// 							if(!prevEv[event.unitid]){
	// 								prevEv[event.unitid] = {};
	// 							}
	// 							if(!prevEv[event.unitid][formattedDate]){
	// 								prevEv[event.unitid][formattedDate] = [];
	// 							}
	// 							prevEv[event.unitid][formattedDate] = event;
								
	// 						})
	// 						index++;
	// 						idxDay++;
	// 					}
	// 				}
	// 				console.log('bydate', summByDays);
	// 				this.outDetailsReport['dMovement'] = summByDays;
	// 				for(let vhcle in summByDays){
	// 					let mbls = summByDays[vhcle];console.log('mbls',mbls)
	// 					let repData:any = {
	// 						mobile: '',
	// 						driving: "00:00:00",
	// 						idling: "00:00:00",
	// 						parking: "00:00:00"
	// 					};
	// 					for(let index in mbls){
	// 						let mbl = mbls[index];
	// 						if(mbl.plate){
	// 							repData.driving = this.addTimes(repData.driving, mbl.driving);
	// 							repData.parking = this.addTimes(repData.parking,mbl.parking);
	// 							repData.idling = this.addTimes(repData.idling,mbl.idling);
	// 							repData.mobile = '<a class="fleetDtl" data-report="dMovement" data-id="'+vhcle+'">'+mbl.plate+'</a>';
	// 						}
	// 					}
	// 					if(repData.mobile !== ''){
	// 						this.reportData.push(repData);
	// 					}
	// 				};
	// 				let options = {
	// 					data: this.reportData,
	// 					//pageLength: 25,
	// 					paging: false,
	// 					responsive: false,
	// 					scrollX: true,
	// 					searching: false,
	// 					destroy: true,
	// 					retrieve: true,
	// 					//dom: '<lf<t>ip>',
	// 					dom: "Blf<t>rtip",
	// 					"stateSave": true,
	// 					buttons: [
	// 						{
	// 							extend: 'colvis',
	// 							className: 'fa fa-eye',
	// 							text: '',
	// 						},
	// 						{
	// 							extend: 'excelHtml5',
	// 							exportOptions: {
	// 								columns: ( idx, data, node ) => {
	// 								let table_id = node.getAttribute('aria-controls');
	// 								return $('#oncore2b').DataTable().column( idx ).visible();
	// 							}
	// 							},
	// 							className: 'fa fa-file-excel-o rptBtn',
	// 							text: '',
	// 							title: 'Fleet Driving Report Summary'
	// 						}, {
	// 							extend: 'pdfHtml5',
	// 							orientation: 'landscape',
	// 							pageSize: 'A4',
	// 							exportOptions: {
	// 								columns: ( idx, data, node ) => {
	// 								let table_id = node.getAttribute('aria-controls');
	// 								return $('#oncore2b').DataTable().column( idx ).visible();
	// 							}
	// 							},
	// 							className: 'fa fa-file-pdf-o rptBtn',
	// 							text: '',
	// 							title: 'Fleet Driving Report Summary'
	// 						}
	// 					],
	// 					columns: [
	// 						{
	// 							data: "mobile",
	// 							width: "30%",
	// 							title: "Mobile"
	// 						},
	// 						{
	// 							data: "driving",
	// 							width: "20%",
	// 							title: "Driving"
	// 						},
	// 						{
	// 							data: "idling",
	// 							width: "20%",
	// 							title: "Idling"
	// 						},
	// 						{
	// 							data: "parking",
	// 							width: "20%",
	// 							title: "Parking"
	// 						}
	// 					]
	// 				};
	// 				if($('#oncore2h') && $('#oncore2h_wrapper')[0]){
	// 					$('#oncore2h_wrapper').remove();
	// 					$('#oncore3').before('<table id="oncore2h" class="display table " cellspacing="0" width="100%"></table>');
	// 				}
	// 				this.table = $('#oncore2h').DataTable(options);
	// 				this.reinitClickAction();
	// 				$('.dataTables_scrollBody').scroll(function(){
	// 					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
	// 				});
	// 				$('#oncore2h').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Fleet Driving Report Summary</caption>');
	// 				$('.dt-buttons').css('float','left');
	// 				this.processingDetail = false;
	// 			},
	// 			(err) => {
	// 				alert(err.statusText);
	// 				if($('#oncore2h') && $('#oncore2h_wrapper')[0]){
	// 					$('#oncore2_wrapper').remove();
	// 					$('#oncore3').before('<table id="oncore2h" class="display table " cellspacing="0" width="100%"></table>');
	// 				}
	// 				this.processingDetail = false;
	// 			})
	// 		},
	// 		err => {
	// 			alert(err.statusText);
	// 			if($('#oncore2h') && $('#oncore2h_wrapper')[0]){
	// 				$('#oncore2h_wrapper').remove();
	// 				$('#oncore3').before('<table id="oncore2h" class="display table " cellspacing="0" width="100%"></table>');
	// 			}
	// 			this.processingDetail = false;
	// 		}
	// 		);
	// 	}else{
	// 		let driveVhcls:any = [];
	// 		if(this.vehicleListAlt.length > 0){
	// 			driveVhcls = this.vehicleListAlt;
	// 			if(this.vehicleListAlt.length > 10){
	// 				alert('Only allow to select maximum 10 vehicles');
	// 				this.processingDetail = false;
	// 				return false;
	// 			}
	// 		}else{
	// 			alert('Please select a vehicle');
	// 			this.processingDetail = false;
	// 			return false;
	// 			// for(let key of this.objectKeys(this.selectionVehicle)){
	// 			// 	driveVhcls.push(this.selectionVehicle[key].unitId);
	// 			// }
	// 		}
	// 		this.vehicleSvc.getVehicleTrakcsAll(driveVhcls,startDate,endDate,1)
	// 		.subscribe((events:any) => {
	// 		// this.vehicleSvc.getVehicleTracks(driveVhcls[0],startDate,endDate,1)
	// 		// .subscribe((events:any) => {
	// 			let frefDatas = events;
	// 			this.processingSummary = false;
	// 			this.eventDatas = events;
	// 			let eventName = {};
	// 			let engine_run = {};
	// 			let tempObjEngine = {};
	// 			let selectedVehicle:any = {};
	// 			this.eventDatas?.forEach((event, index) => {
	// 				const dateStr = event.devTime;
	// 				// Convert to ISO format (important)
	// 				const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
	// 				// Get milliseconds
	// 				const timestamp = date.getTime();
	// 				// Build .NET format
	// 				const dotNetDate = "/Date(" + timestamp + "+0800)/";

	// 				this.vehicles.forEach((vhc) => {
	// 					if(vhc.vehicleId == event.vehicleId){
	// 						selectedVehicle = vhc;
	// 						return;
	// 					}
	// 				})
					
	// 				event.updated = (moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x'));
	// 				// fleet summary - start
	// 				event.unitid = event.vehicleId;
	// 				if(!summData[event.unitid]){
	// 					summData[event.unitid] = {};
	// 					this.vehicles.forEach((vehicle,key) => {
	// 						if(vehicle.vehicleId == event.unitid){
	// 							summData[event.unitid].plate = vehicle.description;
	// 							summData[event.unitid].mobile_idle = event.timeSecond;
	// 							summData[event.unitid].mobile_fuel = 0;
	// 							summData[event.unitid].terminalNo = vehicle.terminalNo;
	// 						}
	// 					});
	// 					summData[event.unitid].fuel_liter = (0).toFixed(4);
	// 					summData[event.unitid].idling = '00:00:00';
	// 					summData[event.unitid].total_distance = (0).toFixed(2);
	// 					summData[event.unitid].total_duration = '00:00:00';
	// 					summData[event.unitid].total_level = (0).toFixed(4);
	// 				}
	// 				if(!engine_run[event.unitid]){
	// 					engine_run[event.unitid] = {};
	// 				}
	// 				if(!summData[event.unitid].count_engine_on){
	// 					summData[event.unitid].count_engine_on = 0;
	// 				}
	// 				if(!summData[event.unitid].count_engine_off){
	// 					summData[event.unitid].count_engine_off = 0;   
	// 				}
	// 				if(!summData[event.unitid].count_idle){
	// 					summData[event.unitid].count_idle = 0;   
	// 				}
	// 				if(!summData[event.unitid].idle_raw){
	// 					summData[event.unitid].idle_raw = 0;   
	// 				}
	// 				if(event.accState == 1){
	// 					if(engine_run[event.unitid].tempObjEngine){
	// 						summData[event.unitid].count_engine_off += 1;

	// 						engine_run[event.unitid].tempObjEngine.odometer.push(event.mileage);
	// 						engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
	// 						engine_run[event.unitid].tempObjEngine.level.push(event.oil);

							
	// 						// frefDatas.forEach((fr, ky) => {
	// 						// 	let formattedFrTime = (fr.updated).format('YYYY-MM-DD HH:mm:ss');
	// 						// 	if(formattedFrTime < startDate || formattedFrTime > endDate){
	// 						// 		return;
	// 						// 	}
	// 						// 	if(fr.unitid == event.unitid && (fr.updated > engine_run[event.unitid].tempObjEngine.updated[0] && fr.updated < engine_run[event.unitid].tempObjEngine.updated[1])){
	// 						// 		//if(engine_run[event.unitid].tempObjEngine){
	// 						// 			summData[event.unitid].count_idle += 1; 
	// 						// 			let idle_raw:any = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle);
	// 						// 			summData[event.unitid].idle_raw = idle_raw;
	// 						// 			let idle_hours:any = Math.floor( idle_raw / 60);
	// 						// 			idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
	// 						// 			let idle_minutes:any = idle_raw % 60;
	// 						// 			idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
	// 						// 			let idle_time:any = idle_hours + ':' + idle_minutes + ':00';
	// 						// 			summData[event.unitid].idling = idle_time;

	// 						// 			delete frefDatas[ky];
	// 						// 		// }
	// 						// 	}
	// 						// });

	// 						let dist = (parseFloat(engine_run[event.unitid].tempObjEngine.odometer[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.odometer[0])).toFixed(2);
							
	// 						let total_level:any = parseFloat(engine_run[event.unitid].tempObjEngine.level[1]) - parseFloat(engine_run[event.unitid].tempObjEngine.level[0]); 
	// 						let from_mili:any = (engine_run[event.unitid].tempObjEngine.updated[1] - engine_run[event.unitid].tempObjEngine.updated[0]);
	// 						let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
	// 						hours = (hours < 10)? '0'+hours : hours;
	// 						let seconds:any = Math.floor((from_mili / 1000) % 60);
	// 						seconds = (seconds < 10)? '0'+seconds : seconds;
	// 						let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
	// 						minutes = (minutes < 10)? '0'+minutes : minutes;
	// 						let diff_dur:any = (hours + ':' + minutes + ":" + seconds);
	// 						if(!summData[event.unitid].total_distance){
	// 							summData[event.unitid].total_distance = 0;
	// 						}
	// 						if(!summData[event.unitid].total_duration){
	// 							summData[event.unitid].total_duration = '00:00:00';
	// 						}
	// 						if(!summData[event.unitid].total_level){
	// 							summData[event.unitid].total_level = 0;
	// 						}

	// 						let tempSumm = parseFloat(summData[event.unitid].total_distance);
	// 						tempSumm += parseFloat(dist);
	// 						summData[event.unitid].total_distance = tempSumm.toFixed(2);
	// 						let tempLvl = parseFloat(summData[event.unitid].total_level);
	// 						tempLvl += total_level;
	// 						summData[event.unitid].total_level = tempLvl;
	// 						summData[event.unitid].total_duration = this.vehicleSvc.addTwoTime(summData[event.unitid].total_duration, diff_dur);                                    
	// 						summData[event.unitid].fuel_liter = 0;

	// 						if(!summData[event.unitid].journeys){
	// 							summData[event.unitid].journeys = {};
	// 						}
	// 						if(!summData[event.unitid].journeys[index]){
	// 							summData[event.unitid].journeys[index] = {};
	// 						}
	// 						summData[event.unitid].journeys[index].dist = diff_dur;
	// 						summData[event.unitid].journeys[index].start_time = engine_run[event.unitid].tempObjEngine.updated[0].format('YYYY-MM-DD HH:mm:ss');
	// 						summData[event.unitid].journeys[index].end_time = engine_run[event.unitid].tempObjEngine.updated[1].format('YYYY-MM-DD HH:mm:ss');
	// 						summData[event.unitid].journeys[index].start_level = engine_run[event.unitid].tempObjEngine.level[0];
	// 						summData[event.unitid].journeys[index].end_level = engine_run[event.unitid].tempObjEngine.level[1];
	// 						summData[event.unitid].journeys[index].start_odo = engine_run[event.unitid].tempObjEngine.odometer[0];
	// 						summData[event.unitid].journeys[index].end_odo = engine_run[event.unitid].tempObjEngine.odometer[1];

	// 						delete engine_run[event.unitid].tempObjEngine;
	// 					}
	// 				}else if(event.accState == 0){
	// 					summData[event.unitid].count_engine_on += 1; 

	// 					if(!engine_run[event.unitid].tempObjEngine){
	// 						engine_run[event.unitid].tempObjEngine = {
	// 							odometer:[],
	// 							updated:[],
	// 							level:[]
	// 						};
	// 						engine_run[event.unitid].tempObjEngine.odometer.push(event.mileage);
	// 						engine_run[event.unitid].tempObjEngine.updated.push(event.updated);
	// 						engine_run[event.unitid].tempObjEngine.level.push(event.oil);
	// 					}else{

	// 					}

	// 					if(event.runState == 3){
	// 						summData[event.unitid].count_idle += 1; 
	// 						summData[event.unitid].idle_raw += event.timeSecond;
	// 						let idle_raw = summData[event.unitid].idle_raw;
	// 						let idle_hours:any = Math.floor( idle_raw / (60*60));
	// 						idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
	// 						let idle_minutes:any = Math.floor(idle_raw / 60);
	// 						idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
	// 						let idle_secs:any = idle_raw % 60;
	// 						idle_secs = (idle_secs < 10)? '0'+idle_secs : idle_secs;
	// 						let idle_time:any = idle_hours + ':' + idle_minutes + ':' + idle_secs;
	// 						summData[event.unitid].idling = idle_time;
	// 					}
	// 				}
	// 			});
	// 			console.log('summData',summData);
	// 			for(let index in summData){
	// 				let mbl = summData[index];console.log('mbl',mbl);
	// 				if(mbl.count_engine_off && mbl.plate !== undefined){
	// 					let repData = {
	// 						mobile: '<a class="fleetDtl" data-report="fDriving" data-id="'+mbl.terminalNo+'">'+mbl.plate+'</a>',
	// 						count: (mbl.count_engine_off < mbl.count_engine_on) ? mbl.count_engine_off : mbl.count_engine_on,
	// 						distance: Math.round(mbl.total_distance),
	// 						duration: mbl.total_duration,
	// 						idling: mbl.idling,
	// 						fuel_liter: mbl.fuel_liter.toFixed(2)
	// 					};
	// 					this.reportData.push(repData);
	// 				}
	// 			};
	// 			let options = {
	// 				data: this.reportData,
	// 				//pageLength: 25,
	// 				paging: false,
	// 				responsive: false,
	// 				scrollX: true,
	// 				searching: false,
	// 				destroy: true,
	// 				retrieve: true,
	// 				//dom: '<lf<t>ip>',
	// 				dom: "Blf<t>rtip",
	// 				"stateSave": true,
	// 				buttons: [
	// 					{
	// 						extend: 'colvis',
	// 						className: 'fa fa-eye',
	// 						text: '',
	// 					},
	// 					{
	// 						extend: 'excelHtml5',
	// 						exportOptions: {
	// 							columns: ( idx, data, node ) => {
	// 							let table_id = node.getAttribute('aria-controls');
	// 							return $('#oncore2b').DataTable().column( idx ).visible();
	// 						}
	// 						},
	// 						className: 'fa fa-file-excel-o rptBtn',
	// 						text: '',
	// 						title: 'Fleet Driving Report Summary'
	// 					}, {
	// 						extend: 'pdfHtml5',
	// 						orientation: 'landscape',
	// 						pageSize: 'A4',
	// 						exportOptions: {
	// 							columns: ( idx, data, node ) => {
	// 							let table_id = node.getAttribute('aria-controls');
	// 							return $('#oncore2b').DataTable().column( idx ).visible();
	// 						}
	// 						},
	// 						className: 'fa fa-file-pdf-o rptBtn',
	// 						text: '',
	// 						title: 'Fleet Driving Report Summary'
	// 					}
	// 				],
	// 				columns: [
	// 					{
	// 						data: "mobile",
	// 						width: "20%",
	// 						title: "Mobile"
	// 					},
	// 					{
	// 						data: "duration",
	// 						width: "20%",
	// 						title: "Duration"
	// 					},
	// 					{
	// 						data: "idling",
	// 						width: "15%",
	// 						title: "Idling"
	// 					}
	// 				]
	// 			};
	// 			if($('#oncore2h') && $('#oncore2h_wrapper')[0]){
	// 				$('#oncore2h_wrapper').remove();
	// 				$('#oncore3').before('<table id="oncore2h" class="display table " cellspacing="0" width="100%"></table>');
	// 			}
	// 			this.table = $('#oncore2h').DataTable(options);
	// 			this.reinitClickAction();
	// 			$('.dataTables_scrollBody').scroll(function(){
	// 				$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
	// 			});
	// 			$('#oncore2h').prepend('<caption style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">Fleet Driving Report Summary</caption>');
	// 			$('.dt-buttons').css('float','left');
	// 			this.processingDetail = false;
	// 		},
	// 		err => {
	// 			alert(err.statusText);
	// 			if($('#oncore2h') && $('#oncore2h_wrapper')[0]){
	// 				$('#oncore2h_wrapper').remove();
	// 				$('#oncore3').before('<table id="oncore2h" class="display table " cellspacing="0" width="100%"></table>');
	// 			}
	// 			this.processingDetail = false;
	// 		})
	// 	}
	// }
  }
  
  editIcon( data, type, row ){
	if ( type === 'display' ) {
		return '<i class="fa fa-undo fa-2x fleetBack" data-toggle="tooltip" data-placement="bottom" title="Back"></i> &nbsp;&nbsp;' + data;
	}
	return data;  
  }
  
  processReportDetail(selectedReport, unitId, eventType, eventCode){
	this.processingDetail = true;
	let summData = {};
	$('#oncore3').html('');
	this.reportData = [];
	this.eventDatas = [];
	let start_time_raw = this.timeStart + ":00";
	let end_time_raw = this.timeEnd + ":00";
	let start_date = moment(this.dateStart).format('YYYY-MM-DD')+' '+start_time_raw;
	let end_date = moment(this.dateEnd).format('YYYY-MM-DD')+' '+end_time_raw;
	// var events = API.selectedMobileEvent(unitId, start_date, end_date)
	let start_date_only = moment(this.dateStart).format('DDMMYY');
	let end_date_only = moment(this.dateEnd).format('DDMMYY');
	if(this.reportType == this.reportOptions.mEvent){
		if(this.userObj.source == "oncore"){
			this.vehicleSvc.getSelectedEventMobileEvent(unitId, eventCode, start_date, start_date_only, end_date_only)
			.subscribe((r) => {
				this.reportData = [];
				this.processingDetail = false;
				this.eventDatas = r;
				let drName = '';
				let plate = '';
				let event_type = '';
				let tank:any = 0;
				let idle_raw:any = 0;
				let info:any = '-';
				this.eventDatas.forEach((event, index) => {
					let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
					if(formattedTime < start_date || formattedTime > end_date){
						return;
					}
					// mobile event summary - start
					let flagCount = 0;
					let idle_period = '';
					let speed_limit = '';
					let refill = '';
					this.vehicles.forEach((vehicle,key) => {
						if(vehicle.unitid == event.unitid){
							drName = vehicle.drivernamedefault;
							idle_raw = vehicle.idle_period;
							let idle_hours:any = Math.floor( idle_raw / 60);
							idle_hours = (idle_hours < 10)? '0'+idle_hours : idle_hours;
							let idle_minutes:any = idle_raw % 60;
							idle_minutes = (idle_minutes < 10)? '0'+idle_minutes : idle_minutes;
							idle_period = idle_hours + ':' + idle_minutes + ':00';
							speed_limit = vehicle.speed_limit;
							tank = vehicle.tankvolume;
							plate = vehicle.description;
						}
					});
					event_type = eventType;
					let smallEvent = event.event.toLowerCase();
					if(smallEvent == 'alarm'){
						flagCount = 1;
					}else if(smallEvent == 'tamper'){
						flagCount = 1;
					}else if(smallEvent == 'idling'){
						flagCount = 1;
						info = idle_period;
					}else if(smallEvent == 'speed'){
						flagCount = 1;
						info = event.speed;//speed_limit;
					}else if(smallEvent == 'hard_brake'){
						flagCount = 1;
					}else if(smallEvent == 'fuel_refill'){
						event_type = (eventType == 'fuel_refill') ? 'Fuel Refill' : eventType;
						flagCount = 1;
						info = parseFloat(event.refill).toFixed(2);
					}else if(smallEvent == 'fuel_alert'){
						event_type = (eventType == 'fuel_alert') ? 'Fuel Alert' : eventType;
						flagCount = 1;
						info = parseFloat(tank) * 0.1;
					}else if(smallEvent == 'power_off'){
						event_type = (eventType == 'power_off') ? 'Power Off' : eventType;
						flagCount = 1;
					}else if(smallEvent == 'towed'){
						flagCount = 1;
					}else if(smallEvent == 'no_gps'){
						event_type = (eventType == 'no_gps') ? 'No GPS' : eventType;
						flagCount = 1;
					}
					if(flagCount == 1 && smallEvent == eventType){
						summData = {
							update: event.updated.format('YYYY-MM-DD HH:mm:ss'),
							info: info ? info : '-',
							location: event.location,
							driver: drName,
							event: event.event,
							plate: plate,
							empty_str: ''
						};
						this.reportData.push(summData);
					}
					// mobile event summary end */
				});console.log(summData);
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging:false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					dom: "lfr<t>Bpi",
					buttons: [
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore3').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: plate+' '+event_type+' Event Report'
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore3').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: plate+' '+event_type+' Event Report'
						}
					],
					columns: [
						{
							data: "update",
							width: "25%",
							title: "Time",
						},
						{
							data: "info",
							width: "20%",
							title: "Information"
						},
						{
							data: "location",
							width: "35%",
							title: "Location"
						},
						{
							data: "driver",
							width: "15%",
							title: "Driver"
						},
						{
							data: "empty_str",
							width: "5%",
							title: '',
							render: this.editIcon
						}
					]
				};
				$('#oncore3').DataTable(options);
				this.reinitBackToTopReportDetail();
				let newTtl = event_type.replace('_', ' ');
				if($('.detail-title-caption').length == 0){
					$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' <span class="capFirst">'+newTtl+'</span> Event Report</caption');
				}
				$('.dt-buttons').css('float','left');
				$('.capFirst').css('textTransform', 'capitalize');
				$('html,body').animate({
				scrollTop: $('#oncore3').offset().top
				}, 1000);
				$('.dataTables_scrollBody').scroll(function(){
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
				setTimeout(() => {
					$.each($('#oncore3').children('tbody').find('tr'),() => {
						$(this).children('td:nth-child(3)').css('white-space', 'unset');
					});
				}, 1000);
			});
		}else{
			let selectedDatas = this.outDetailsReport['mEvent'][unitId][eventCode];
			if(selectedDatas.length > 0){
				this.reportData = [];
				this.processingDetail = false;
				this.eventDatas = selectedDatas;
				let drName = '';
				let plate = '';
				let event_type = '';
				let tank:any = 0;
				let idle_raw:any = 0;
				let info:any = '-';
				selectedDatas.forEach((event, index) => {
					// mobile event summary - start
					let flagCount = 0;
					let idle_period = '';
					let speed_limit = '';
					let refill = '';
					this.vehicles.forEach((vehicle,key) => {
						if(vehicle.unitid == event.deviceId){
							drName = vehicle.drivernamedefault;
							plate = vehicle.description;
						}
					});
					event_type = eventType;
					info = event.timeOfDuration;
					let smallEvent = event.event.toLowerCase();
					if(smallEvent == 'alarm'){
						flagCount = 1;
						info = event.alarmType;
					}else if(smallEvent == 'tamper'){
						flagCount = 1;
					}else if(smallEvent == 'idling'){
						flagCount = 1;
						const apiValue = info;
						info = this.formatSeconds(this.parseDurationToSeconds(apiValue) + 600);
					}else if(smallEvent == 'speed'){
						flagCount = 1;
					}else if(smallEvent == 'hard_brake'){
						flagCount = 1;
					}else if(smallEvent == 'fuel_refill'){
						event_type = (eventType == 'fuel_refill') ? 'Fuel Refill' : eventType;
						flagCount = 1;
					}else if(smallEvent == 'fuel_alert'){
						event_type = (eventType == 'fuel_alert') ? 'Fuel Alert' : eventType;
						flagCount = 1;
					}else if(smallEvent == 'power_off'){
						event_type = (eventType == 'power_off') ? 'Power Off' : eventType;
						flagCount = 1;
					}else if(smallEvent == 'towed'){
						flagCount = 1;
					}else if(smallEvent == 'no_gps'){
						event_type = (eventType == 'no_gps') ? 'No GPS' : eventType;
						flagCount = 1;
					}
					if(flagCount == 1 && smallEvent == eventType){
						let locSplit = (event.lonAndLat).split(',');
						summData = {
							update: event.updated.format('YYYY-MM-DD HH:mm:ss'),
							info: info ? info : '-',
							location: '<a class="clickable rpt-coord" data-lat="'+locSplit[1]+'" data-lon="'+locSplit[0]+'" data-loc="'+locSplit[1] + ',' + locSplit[0]+'">' + locSplit[1] + ',' + locSplit[0] + '</a>',
							driver: drName,
							event: event.event,
							plate: plate,
							empty_str: ''
						};
						this.reportData.push(summData);
					}
					// mobile event summary end */
				});console.log(summData);
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging:false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					dom: "lfr<t>Bpi",
					buttons: [
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore3').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: plate+' '+event_type+' Event Report'
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore3').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: plate+' '+event_type+' Event Report'
						}
					],
					columns: [
						{
							data: "update",
							width: "25%",
							title: "Time",
						},
						{
							data: "info",
							width: "20%",
							title: "Information"
						},
						{
							data: "location",
							width: "35%",
							title: "Location"
						},
						{
							data: "driver",
							width: "15%",
							title: "Driver"
						},
						{
							data: "empty_str",
							width: "5%",
							title: '',
							render: this.editIcon
						}
					]
				};
				$('#oncore3').DataTable(options);
				this.reinitBackToTopReportDetail();
				let newTtl = event_type.replace('_', ' ');
				if($('.detail-title-caption').length == 0){
					$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' <span class="capFirst">'+newTtl+'</span> Event Report</caption');
				}
				$('.dt-buttons').css('float','left');
				$('.capFirst').css('textTransform', 'capitalize');
				$('html,body').animate({
				scrollTop: $('#oncore3').offset().top
				}, 1000);
				$('.dataTables_scrollBody').scroll(function(){
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
				setTimeout(() => {
					$.each($('#oncore3').children('tbody').find('tr'),() => {
						$(this).children('td:nth-child(3)').css('white-space', 'unset');
					});
				}, 1000);
			}
		}
	}else if(this.reportType == this.reportOptions.frEvent){
		this.vehicleSvc.getSelectedEventMobileEvent(unitId, '07', start_date, start_date_only, end_date_only)
		.subscribe((r) => {
			this.reportData = [];
			this.processingDetail = false;
			this.eventDatas = r;
			let drName = '';
			let plate = '';
			this.eventDatas.forEach((event, index) => {
				let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
				if(formattedTime < start_date || formattedTime > end_date){
					return;
				}
				// fuel refill summary - start
				this.vehicles.forEach((vehicle,key) => {
					if(vehicle.unitid == event.unitid){
						drName = vehicle.drivernamedefault;
						plate = vehicle.description;
					}
				}); 
				
				if(event.event == "Fuel_Refill"){
					summData[index] = {
						time: event.updated.format('YYYY-MM-DD HH:mm:ss'),
						amount: parseFloat(event.refill).toFixed(2),
						location: event.location,
						driver: drName,
						event: event.event
					};
				}
				// fuel refill summary end*/
			});console.log(summData);
			for(let index in summData){
				let mbl = summData[index];
				let repData = {
					time: mbl.time,
					amount: mbl.amount,
					location: mbl.location,
					driver: mbl.driver,
					event: mbl.event,
					empty_str: ''
				};
				this.reportData.push(repData);
			};
			let options = {
				data: this.reportData,
				//pageLength: 25,
				paging:false,
				responsive: false,
				scrollX: true,
				searching: false,
				destroy: true,
				dom: "lfr<t>Bpi",
				buttons: [
					{
						extend: 'excelHtml5',
						exportOptions: {
							columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore3').DataTable().column( idx ).visible();
						  }
						},
						className: 'fa fa-file-excel-o rptBtn',
						text: '',
						title: plate+' Fuel Refill Report Details'
					}, {
						extend: 'pdfHtml5',
						orientation: 'landscape',
						pageSize: 'A4',
						exportOptions: {
							columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore3').DataTable().column( idx ).visible();
						  }
						},
						className: 'fa fa-file-pdf-o rptBtn',
						text: '',
						title: plate+' Fuel Refill Report Details'
					}
				],
				columns: [
					{
						data: "time",
						width: "25%",
						title: "Time"
					},
					{
						data: "amount",
						width: "15%",
						title: "Amount"
					},
					{
						data: "location",
						width: "35%",
						title: "Location"
					},
					{
						data: "driver",
						width: "20%",
						title: "Driver"
					},
					{
						data: "empty_str",
						width: "5%",
						title: '',
						render: this.editIcon
					}
				]
			};
			$('#oncore3').DataTable(options);
			this.reinitBackToTopReportDetail();
			if($('.detail-title-caption').length == 0){
				$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' Fuel Refill Report Details</caption');
			}
			$('.dt-buttons').css('float','left');
			$('html,body').animate({
			  scrollTop: $('#oncore3').offset().top
			}, 1000);
			$('.dataTables_scrollBody').scroll(function(){
				$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
			});
			setTimeout(() => {
				$.each($('#oncore3').children('tbody').find('tr'), () => {
					$(this).children('td:nth-child(3)').css('white-space', 'unset');
				});
			}, 1000);
		});
	}else if(this.reportType == this.reportOptions.fDriving){
		if(this.userObj.source == "oncore"){
			this.vehicleSvc.getSelectedEventMobileEvent(unitId, '00', start_date, start_date_only, end_date_only)
			.subscribe((r) => {
				this.vehicleSvc.getSelectedEventMobileEvent(unitId, '04', start_date, start_date_only, end_date_only)
				.subscribe((s) => {
					this.reportData = [];
					this.processingDetail = false;
					this.eventDatas = r;
					let drName = '';
					let plate = '';
					let countJourney = 0;
					let frefDatas = s;
					this.eventDatas.forEach((event, index) => {
						let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
						if(formattedTime < start_date || formattedTime > end_date){
							return;
						}
						// fleet summary - start
						this.vehicles.forEach((vehicle,key) => {
							if(vehicle.unitid == event.unitid){
								drName = vehicle.drivernamedefault;
								plate = vehicle.description;
							}
						}); 

						if(event.event == "Engine_Off"){
							if(summData[countJourney]){
								summData[countJourney].end_distance = event.odometer;
								summData[countJourney].end_time = event.updated;
								summData[countJourney].end_location = event.location;
								summData[countJourney].end_lat = event.lat;
								summData[countJourney].end_lon = event.lon;
								summData[countJourney].end_coordinate = event.lat + ', ' + event.lon;

								let dist = (parseFloat(summData[countJourney].end_distance) - parseFloat(summData[countJourney].start_distance));
								
								let from_mili:any = (summData[countJourney].end_time - summData[countJourney].start_time);
								let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
								hours = (hours < 10)? '0'+hours : hours;
								let seconds:any = Math.floor((from_mili / 1000) % 60);
								seconds = (seconds < 10)? '0'+seconds : seconds;
								let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
								minutes = (minutes < 10)? '0'+minutes : minutes;
								let diff_dur = (hours + ':' + minutes + ":" + seconds);
								
								summData[countJourney].total_distance = dist;
								summData[countJourney].total_duration = diff_dur;
								//summData[event.unitid].idling = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle).toFixed(2);
								
								countJourney ++;
							}
						}else if(event.event == "Engine_On"){
							summData[countJourney] = {};
							summData[countJourney].start_time = event.updated;
							summData[countJourney].start_location = event.location;
							summData[countJourney].start_distance = event.odometer;
							summData[countJourney].start_lat = event.lat;
							summData[countJourney].start_lon = event.lon;
							summData[countJourney].start_coordinate = event.lat + ', ' + event.lon;
							summData[countJourney].driver = drName;
						}else if(event.event == "Idling"){
							//summData[event.unitid].count_idle += 1; 
						}
						// fleet summary end*/
					});console.log(summData);
					for(let index in summData){
						let mbl = summData[index];
						//if(mbl.total_distance > 0){
						if(mbl.end_time){
							let repData = {
								start_time: mbl.start_time.format('YYYY-MM-DD HH:mm:ss'),
								start_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.start_lat+'" data-lon="'+mbl.start_lon+'" data-loc="'+mbl.start_location+'">' + mbl.start_coordinate + '</a>',
								start_location: mbl.start_location,
								end_time: mbl.end_time.format('YYYY-MM-DD HH:mm:ss'),
								end_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.end_lat+'" data-lon="'+mbl.end_lon+'" data-loc="'+mbl.end_location+'">' + mbl.end_coordinate + '</a>',
								end_location: mbl.end_location,
								distance: Math.round(mbl.total_distance),
								duration: mbl.total_duration,
								driver: mbl.driver,
								empty_str: ''
							};
							this.reportData.push(repData);
						}
					};
					let options = {
						data: this.reportData,
						//pageLength: 25,
						paging:false,
						responsive: false,
						scrollX: true,
						searching: false,
						destroy: true,
						dom: "lfr<t>Bpi",
						buttons: [
							{
								extend: 'excelHtml5',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore3').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-excel-o rptBtn',
								text: '',
								title: plate+' Fleet Driving Report Details'
							}, {
								extend: 'pdfHtml5',
								orientation: 'landscape',
								pageSize: 'A4',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore3').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-pdf-o rptBtn',
								text: '',
								title: plate+' Fleet Driving Report Details'
							}
						],
						columns: [
							{
								data: "start_time",
								width: "12%",
								title: "Time Start"
							},
							{
								data: "start_coordinate",
								width: "25%",
								title: "Coordinate Start"
							},
							{
								data: "start_location",
								width: "25%",
								title: "Location Start"
							},
							{
								data: "end_time",
								width: "12%",
								title: "Time Stop"
							},
							{
								data: "end_coordinate",
								width: "25%",
								title: "Coordinate Stop"
							},
							{
								data: "end_location",
								width: "25%",
								title: "Location Stop"
							},
							{
								data: "distance",
								width: "5%",
								title: "Distance"
							},
							{
								data: "duration",
								width: "6%",
								title: "Duration"
							},
							{
								data: "driver",
								width: "10%",
								title: "Driver Name"
							},
							{
								data: "empty_str",
								width: "5%",
								title: '',
								render: this.editIcon
							}
						]
					};
					$('#oncore3').DataTable(options);
					this.reinitBackToTopReportDetail();
					if($('.detail-title-caption').length == 0){
						$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' Fleet Driving Report Details</caption');
					}
					$('.dt-buttons').css('float','left');
					$('html,body').animate({
					scrollTop: $('#oncore3').offset().top
					}, 1000);
					$('.dataTables_scrollBody').scroll(function(){
						$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
					});
				});    
			});
		}else{
			this.vehicleSvc.getVehicleTracks(unitId,start_date,end_date,1)
			.subscribe((r:any) => {
				this.reportData = [];
				this.processingDetail = false;
				this.eventDatas = r;
				let drName = '';
				let plate = '';
				let countJourney = 0;
				let frefDatas = r;
				this.eventDatas.forEach((event, index) => {
					const dateStr = event.devTime;
					// Convert to ISO format (important)
					const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
					// Get milliseconds
					const timestamp = date.getTime();
					// Build .NET format
					const dotNetDate = "/Date(" + timestamp + "+0800)/";
					
					event.updated = (moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x'));
					let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
					// fleet summary - start
					this.vehicles.forEach((vehicle,key) => {
						if(vehicle.unitid == event.unitid){
							drName = vehicle.driver;
							plate = vehicle.plate;
						}
					}); 

					if(event.accState == 1){
						if(summData[countJourney]){
							summData[countJourney].end_distance = event.mileage;
							summData[countJourney].end_time = event.updated;
							summData[countJourney].end_location = event.lat + ', ' + event.lon;
							summData[countJourney].end_lat = event.lat;
							summData[countJourney].end_lon = event.lon;
							summData[countJourney].end_coordinate = event.lat + ', ' + event.lon;

							let dist = (parseFloat(summData[countJourney].end_distance) - parseFloat(summData[countJourney].start_distance));
							
							let from_mili:any = (summData[countJourney].end_time - summData[countJourney].start_time);
							let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
							hours = (hours < 10)? '0'+hours : hours;
							let seconds:any = Math.floor((from_mili / 1000) % 60);
							seconds = (seconds < 10)? '0'+seconds : seconds;
							let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
							minutes = (minutes < 10)? '0'+minutes : minutes;
							let diff_dur = (hours + ':' + minutes + ":" + seconds);
							
							summData[countJourney].total_distance = dist;
							summData[countJourney].total_duration = diff_dur;
							//summData[event.unitid].idling = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle).toFixed(2);
							
							countJourney ++;
						}
					}else if(event.accState == 0){
						if(!summData[countJourney]){
							summData[countJourney] = {};
							summData[countJourney].start_time = event.updated;
							summData[countJourney].start_location = event.lat + ', ' + event.lon;
							summData[countJourney].start_distance = event.mileage;
							summData[countJourney].start_lat = event.lat;
							summData[countJourney].start_lon = event.lon;
							summData[countJourney].start_coordinate = event.lat + ', ' + event.lon;
							summData[countJourney].driver = drName;
						}
					}else if(event.runState == 3){
						//summData[event.unitid].count_idle += 1; 
					}
					// fleet summary end*/
				});console.log(summData);
				for(let index in summData){
					let mbl = summData[index];
					//if(mbl.total_distance > 0){
					if(mbl.end_time){
						let repData = {
							start_time: mbl.start_time.format('YYYY-MM-DD HH:mm:ss'),
							start_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.start_lat+'" data-lon="'+mbl.start_lon+'" data-loc="'+mbl.start_location+'">' + mbl.start_coordinate + '</a>',
							start_location: mbl.start_location,
							end_time: mbl.end_time.format('YYYY-MM-DD HH:mm:ss'),
							end_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.end_lat+'" data-lon="'+mbl.end_lon+'" data-loc="'+mbl.end_location+'">' + mbl.end_coordinate + '</a>',
							end_location: mbl.end_location,
							distance: Math.round(mbl.total_distance),
							duration: mbl.total_duration,
							driver: mbl.driver,
							empty_str: ''
						};
						this.reportData.push(repData);
					}
				};
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging:false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					dom: "lfr<t>Bpi",
					buttons: [
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore3').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: plate+' Fleet Driving Report Details'
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore3').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: plate+' Fleet Driving Report Details'
						}
					],
					columns: [
						{
							data: "start_time",
							width: "12%",
							title: "Time Start"
						},
						{
							data: "start_coordinate",
							width: "25%",
							title: "Coordinate Start"
						},
						{
							data: "start_location",
							width: "25%",
							title: "Location Start"
						},
						{
							data: "end_time",
							width: "12%",
							title: "Time Stop"
						},
						{
							data: "end_coordinate",
							width: "25%",
							title: "Coordinate Stop"
						},
						{
							data: "end_location",
							width: "25%",
							title: "Location Stop"
						},
						{
							data: "distance",
							width: "5%",
							title: "Distance"
						},
						{
							data: "duration",
							width: "6%",
							title: "Duration"
						},
						{
							data: "driver",
							width: "10%",
							title: "Driver Name"
						},
						{
							data: "empty_str",
							width: "5%",
							title: '',
							render: this.editIcon
						}
					]
				};
				$('#oncore3').DataTable(options);
				this.reinitBackToTopReportDetail();
				if($('.detail-title-caption').length == 0){
					$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' Fleet Driving Report Details</caption');
				}
				$('.dt-buttons').css('float','left');
				$('html,body').animate({
				scrollTop: $('#oncore3').offset().top
				}, 1000);
				$('.dataTables_scrollBody').scroll(function(){
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
			});
		}
	}else if(this.reportType == this.reportOptions.ffUse){
		this.vehicleSvc.getSelectedEventMobileEvent(unitId, '00', start_date, start_date_only, end_date_only)
		.subscribe((r) => {
			this.vehicleSvc.getSelectedEventMobileEvent(unitId, '07', start_date, start_date_only, end_date_only)
			.subscribe((s) => {
				this.reportData = [];
				this.processingDetail = false;
				this.eventDatas = r;
				let drName = '';
				let plate = '';
				let check_fuel = false;
				let countJourney = 0;
				let frefDatas = s;
				this.eventDatas.forEach((event, index) => {
					let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
					if(formattedTime < start_date || formattedTime > end_date){
						return;
					}
					// fuel use summary - start
					this.vehicles.forEach((vehicle,key) => {
						if(vehicle.unitid == event.unitid){
							drName = vehicle.drivernamedefault;
							check_fuel = vehicle.checkfuel;
							plate = vehicle.description;
						}
					}); 

					if(event.event == "Engine_Off"){
						if(summData[countJourney]){
							summData[countJourney].end_time = event.updated;
							summData[countJourney].end_distance = event.odometer;
							summData[countJourney].end_level = event.level;

							let dist = Math.round(parseFloat(summData[countJourney].end_distance) - parseFloat(summData[countJourney].start_distance));
							if(dist > 0){
								let total_level = parseFloat(summData[countJourney].start_level) - parseFloat(summData[countJourney].end_level); 

								frefDatas.forEach((fr, ky) => {
									let formattedFrTime = (fr.updated).format('YYYY-MM-DD HH:mm:ss');
									if(formattedFrTime < start_date || formattedFrTime > end_date){
										return;
									}
									if(fr.updated > summData[countJourney].start_time && fr.updated < summData[countJourney].end_time){
										if(!summData[countJourney].refill){
											summData[countJourney].refill = 0;
										}
										summData[countJourney].refill += parseFloat(fr.refill);
										delete frefDatas[ky];
									}
								});

								if(summData[countJourney].refill){
									total_level += parseFloat(summData[countJourney].refill);
								}
								if(total_level < 0){
									total_level = 0;
								}
								let from_mili = (summData[countJourney].end_time - summData[countJourney].start_time);
								let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
								hours = (hours < 10)? '0'+hours : hours;
								let seconds:any = Math.floor((from_mili / 1000) % 60);
								seconds = (seconds < 10)? '0'+seconds : seconds;
								let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
								minutes = (minutes < 10)? '0'+minutes : minutes;
								let diff_dur = (hours + ':' + minutes + ":" + seconds);
								
								summData[countJourney].total_level = total_level;
								summData[countJourney].total_duration = diff_dur;
								summData[countJourney].total_distance = dist;
								summData[countJourney].total_level_per_distance = summData[countJourney].total_level == 0? (0).toFixed(2) : (summData[countJourney].total_level / summData[countJourney].total_distance).toFixed(2);
								summData[countJourney].total_distance_per_level = summData[countJourney].total_level == 0? (0).toFixed(2) : (summData[countJourney].total_distance / summData[countJourney].total_level).toFixed(2);

							}
							countJourney ++;
						}
					}else if(event.event == "Engine_On"){
						summData[countJourney] = {};
						summData[countJourney].start_time = event.updated;
						summData[countJourney].start_distance = event.odometer;
						summData[countJourney].start_level = event.level;
						summData[countJourney].check_fuel = check_fuel;
					}else if(event.event == "Fuel_Refill"){
						// eventName[event.unitid][index] = {plate:summData[event.unitid].plate, event:event.event,level:event.level, refill:event.refill,odo:event.odometer, time: event.updated.format('YYYY-MM-DD HH:mm:ss')};
						if(!summData[countJourney]){
							summData[countJourney] = {};
						}
						if(!summData[countJourney].refill){
							summData[countJourney].refill = 0;
							//summData[countJourney].total_level += event.refill;
						}
						summData[countJourney].refill += parseFloat(event.refill);
					}
					// fuel use end*/
				});console.log(summData);
				for(let index in summData){
					let mbl = summData[index];
					if(mbl.total_distance > 0 && mbl.check_fuel == true){
						let repData = {
							start_time: mbl.start_time.format('YYYY-MM-DD HH:mm:ss'),
							end_time: mbl.end_time.format('YYYY-MM-DD HH:mm:ss'),
							duration: mbl.total_duration,
							distance: Math.round(mbl.total_distance),
							level: mbl.total_level.toFixed(2),
							level_per_km: mbl.total_level_per_distance,
							km_per_level: mbl.total_distance_per_level,
							empty_str: ''
						};
						this.reportData.push(repData);
					}
				};
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging:false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					dom: "lfr<t>Bpi",
					buttons: [
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
								 let table_id = node.getAttribute('aria-controls');
								  return $('#oncore3').DataTable().column( idx ).visible();
							  }
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: plate+' Fleet Fuel Use Report Details'
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
								 let table_id = node.getAttribute('aria-controls');
								  return $('#oncore3').DataTable().column( idx ).visible();
							  }
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: plate+' Fleet Fuel Use Report Details'
						}
					],
					columns: [
						{
							data: "start_time",
							width: "15%",
							title: "Time Start"
						},
						{
							data: "end_time",
							width: "15%",
							title: "Time Stop"
						},
						{
							data: "duration",
							width: "15%",
							title: "Duration"
						},
						{
							data: "distance",
							width: "15%",
							title: "Distance"
						},
						{
							data: "level",
							width: "10%",
							title: "Fuel Liters"
						},
						{
							data: "level_per_km",
							width: "10%",
							title: "Liter Per KM"
						},
						{
							data: "km_per_level",
							width: "10%",
							title: "KM Per Liter"
						},
						{
							data: "empty_str",
							width: "5%",
							title: '',
							render: this.editIcon
						}
					]
				};
				$('#oncore3').DataTable(options);
				this.reinitBackToTopReportDetail();
				if($('.detail-title-caption').length == 0){
					$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' Fleet Fuel Use Report Details</caption');
				}
				$('.dt-buttons').css('float','left');
				$('html,body').animate({
				  scrollTop: $('#oncore3').offset().top
				}, 1000);
				$('.dataTables_scrollBody').scroll(function(){
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
			});
		});
	}else if(this.reportType == this.reportOptions.iEvent){
		this.vehicleSvc.getSelectedEventMobileEvent(unitId, '01', start_date, start_date_only, end_date_only)
		.subscribe((r) => {
			this.reportData = [];
			this.processingDetail = false;
			this.eventDatas = r;
			let drName = '';
			let plate = '';
			let countJourney1:any = 0;
			let countJourney2:any = 0;
			this.eventDatas.forEach((event, index) => {
				let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
				if(formattedTime < start_date || formattedTime > end_date){
					return;
				}
				
				// fuel refill summary - start
				this.vehicles.forEach((vehicle,key) => {
					if(vehicle.unitid == event.unitid){
						drName = vehicle.drivernamedefault;
						plate = vehicle.description;
					}
				}); 
				
				if(event.event == "Input1_On"){
					summData[countJourney1] = {
						start_time: event.updated,
						start_location: event.location,
						event: event.event,
						driver: drName
					};
				}else if(event.event == "Input2_On"){
					summData[countJourney2] = {
						start_time: event.updated,
						start_location: event.location,
						event: event.event,
						driver: drName
					};
				}else if(event.event == "Input1_Off"){
					if(summData[countJourney1]){
						summData[countJourney1].end_time = event.updated;
						summData[countJourney1].end_location = event.location;
						summData[countJourney1].event = event.event;

						let from_mili = (summData[countJourney1].end_time - summData[countJourney1].start_time);
						let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
						hours = (hours < 10)? '0'+hours : hours;
						let seconds:any = Math.floor((from_mili / 1000) % 60);
						seconds = (seconds < 10)? '0'+seconds : seconds;
						let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
						minutes = (minutes < 10)? '0'+minutes : minutes;
						let diff_dur = (hours + ':' + minutes + ":" + seconds);

						summData[countJourney1].total_duration = diff_dur;

						countJourney1 ++;
					}
				}else if(event.event == "Input2_Off"){
					if(summData[countJourney2]){
						summData[countJourney2].end_time = event.updated;
						summData[countJourney2].end_location = event.location;
						summData[countJourney2].event = event.event;

						let from_mili = (summData[countJourney2].end_time - summData[countJourney2].start_time);
						let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
						hours = (hours < 10)? '0'+hours : hours;
						let seconds:any = Math.floor((from_mili / 1000) % 60);
						seconds = (seconds < 10)? '0'+seconds : seconds;
						let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
						minutes = (minutes < 10)? '0'+minutes : minutes;
						let diff_dur = (hours + ':' + minutes + ":" + seconds);

						summData[countJourney2].total_duration = diff_dur;

						countJourney2 ++;
					}
				}
				// fuel refill summary end*/
			});console.log(summData);
			for(let index in summData){
				let mbl = summData[index];
				if(mbl.end_time){
					let repData = {
						start_time: mbl.start_time.format('YYYY-MM-DD HH:mm:ss'),
						end_time: mbl.end_time.format('YYYY-MM-DD HH:mm:ss'),
						start_location: mbl.start_location,
						end_location: mbl.end_location,
						duration: mbl.total_duration,
						driver: mbl.driver,
						empty_str: ''
					};
					this.reportData.push(repData);
				}
			};
			let options = {
				data: this.reportData,
				//pageLength: 25,
				paging:false,
				responsive: false,
				scrollX: true,
				searching: false,
				destroy: true,
				dom: "lfr<t>Bpi",
				buttons: [
					{
						extend: 'excelHtml5',
						exportOptions: {
							columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore3').DataTable().column( idx ).visible();
						  }
						},
						className: 'fa fa-file-excel-o rptBtn',
						text: '',
						title: plate+' Input Event Report Details'
					}, {
						extend: 'pdfHtml5',
						orientation: 'landscape',
						pageSize: 'A4',
						exportOptions: {
							columns: ( idx, data, node ) => {
							 let table_id = node.getAttribute('aria-controls');
							  return $('#oncore3').DataTable().column( idx ).visible();
						  }
						},
						className: 'fa fa-file-pdf-o rptBtn',
						text: '',
						title: plate+' Input Event Report Details'
					}
				],
				columns: [
					{
						data: "start_time",
						width: "13%",
						title: "Time On"
					},
					{
						data: "start_location",
						width: "25%",
						title: "Location On"
					},
					{
						data: "end_time",
						width: "13%",
						title: "Time Off"
					},
					{
						data: "end_location",
						width: "25%",
						title: "Location Off"
					},
					{
						data: "duration",
						width: "9%",
						title: "Duration"
					},
					{
						data: "driver",
						width: "10%",
						title: "Driver"
					},
					{
						data: "empty_str",
						width: "5%",
						title: '',
						render: this.editIcon
					}
				]
			};
			$('#oncore3').DataTable(options);
			this.reinitBackToTopReportDetail();
			if($('.detail-title-caption').length == 0){
				$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' Input Event Report Details</caption');
			}			
			$('.dt-buttons').css('float','left');
			$('html,body').animate({
			  scrollTop: $('#oncore3').offset().top
			}, 1000);
			$('.dataTables_scrollBody').scroll(function(){
				$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
			});
		});
	}else if(this.reportType == this.reportOptions.fPark){
		if(this.userObj.source == "oncore"){
			this.vehicleSvc.getSelectedEventMobileEvent(unitId, '00', start_date, start_date_only, end_date_only)
			.subscribe((r) => {
				this.vehicleSvc.getSelectedEventMobileEvent(unitId, '04', start_date, start_date_only, end_date_only)
				.subscribe((s) => {
					this.reportData = [];
					this.processingDetail = false;
					this.eventDatas = r;
					let drName = '';
					let plate = '';
					let countJourney = 0;
					let frefDatas = s;
					this.eventDatas.forEach((event, index) => {
						let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
						if(formattedTime < start_date || formattedTime > end_date){
							return;
						}
						// fleet summary - start
						this.vehicles.forEach((vehicle,key) => {
							if(vehicle.unitid == event.unitid){
								drName = vehicle.drivernamedefault;
								plate = vehicle.description;
							}
						}); 

						if(event.event == "Engine_Off"){
							summData[countJourney] = {};
							summData[countJourney].start_time = event.updated;
							summData[countJourney].start_location = event.location;
							summData[countJourney].start_distance = event.odometer;
							summData[countJourney].start_lat = event.lat;
							summData[countJourney].start_lon = event.lon;
							summData[countJourney].start_coordinate = event.lat + ', ' + event.lon;
							summData[countJourney].driver = drName;
						}else if(event.event == "Engine_On"){
							if(summData[countJourney]){
								summData[countJourney].end_distance = event.odometer;
								summData[countJourney].end_time = event.updated;
								summData[countJourney].end_location = event.location;
								summData[countJourney].end_lat = event.lat;
								summData[countJourney].end_lon = event.lon;
								summData[countJourney].end_coordinate = event.lat + ', ' + event.lon;

								let dist = (parseFloat(summData[countJourney].end_distance) - parseFloat(summData[countJourney].start_distance));
								
								let from_mili:any = (summData[countJourney].end_time - summData[countJourney].start_time);
								let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
								hours = (hours < 10)? '0'+hours : hours;
								let seconds:any = Math.floor((from_mili / 1000) % 60);
								seconds = (seconds < 10)? '0'+seconds : seconds;
								let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
								minutes = (minutes < 10)? '0'+minutes : minutes;
								let diff_dur = (hours + ':' + minutes + ":" + seconds);
								
								summData[countJourney].total_distance = dist;
								summData[countJourney].total_duration = diff_dur;
								//summData[event.unitid].idling = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle).toFixed(2);
								
								countJourney ++;
							}
						}else if(event.event == "Idling"){
							//summData[event.unitid].count_idle += 1; 
						}
						// fleet summary end*/
					});console.log(summData);
					for(let index in summData){
						let mbl = summData[index];
						//if(mbl.total_distance > 0){
						if(mbl.end_time){
							let repData = {
								start_time: mbl.start_time.format('YYYY-MM-DD HH:mm:ss'),
								start_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.start_lat+'" data-lon="'+mbl.start_lon+'" data-loc="'+mbl.start_location+'">' + mbl.start_coordinate + '</a>',
								start_location: mbl.start_location,
								end_time: mbl.end_time.format('YYYY-MM-DD HH:mm:ss'),
								end_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.end_lat+'" data-lon="'+mbl.end_lon+'" data-loc="'+mbl.end_location+'">' + mbl.end_coordinate + '</a>',
								end_location: mbl.end_location,
								// distance: Math.round(mbl.total_distance),
								duration: mbl.total_duration,
								driver: mbl.driver,
								empty_str: ''
							};
							this.reportData.push(repData);
						}
					};
					let options = {
						data: this.reportData,
						//pageLength: 25,
						paging:false,
						responsive: false,
						scrollX: true,
						searching: false,
						destroy: true,
						dom: "lfr<t>Bpi",
						buttons: [
							{
								extend: 'excelHtml5',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore3').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-excel-o rptBtn',
								text: '',
								title: plate+' Fleet Parking Report Details'
							}, {
								extend: 'pdfHtml5',
								orientation: 'landscape',
								pageSize: 'A4',
								exportOptions: {
									columns: ( idx, data, node ) => {
									let table_id = node.getAttribute('aria-controls');
									return $('#oncore3').DataTable().column( idx ).visible();
								}
								},
								className: 'fa fa-file-pdf-o rptBtn',
								text: '',
								title: plate+' Fleet Parking Report Details'
							}
						],
						columns: [
							{
								data: "start_time",
								width: "12%",
								title: "Time Start"
							},
							// {
							// 	data: "start_location",
							// 	width: "25%",
							// 	title: "Location Start"
							// },
							{
								data: "end_time",
								width: "12%",
								title: "Time Stop"
							},
							{
								data: "end_coordinate",
								width: "25%",
								title: "Coordinate"
							},
							{
								data: "end_location",
								width: "25%",
								title: "Location"
							},
							// {
							// 	data: "distance",
							// 	width: "5%",
							// 	title: "Distance"
							// },
							{
								data: "duration",
								width: "6%",
								title: "Duration"
							},
							{
								data: "driver",
								width: "10%",
								title: "Driver Name"
							},
							{
								data: "empty_str",
								width: "5%",
								title: '',
								render: this.editIcon
							}
						]
					};
					$('#oncore3').DataTable(options);
					this.reinitBackToTopReportDetail();
					if($('.detail-title-caption').length == 0){
						$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' Fleet Parking Report Details</caption');
					}
					$('.dt-buttons').css('float','left');
					$('html,body').animate({
					scrollTop: $('#oncore3').offset().top
					}, 1000);
					$('.dataTables_scrollBody').scroll(function(){
						$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
					});
				});    
			});
		}else{
			this.vehicleSvc.getVehicleTracks(unitId,start_date,end_date,1)
			.subscribe((r:any) => {
				this.reportData = [];
				this.processingDetail = false;
				this.eventDatas = r;
				let drName = '';
				let plate = '';
				let countJourney = 0;
				let frefDatas = r;
				this.eventDatas.forEach((event, index) => {
					const dateStr = event.devTime;
					// Convert to ISO format (important)
					const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
					// Get milliseconds
					const timestamp = date.getTime();
					// Build .NET format
					const dotNetDate = "/Date(" + timestamp + "+0800)/";
					
					event.updated = (moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x'));
					event.unitid = event.vehicleId;
					let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
					// fleet summary - start
					this.vehicles.forEach((vehicle,key) => {
						if(vehicle.unitid == event.unitid){
							drName = vehicle.driver;
							plate = vehicle.plate;
							return;
						}
					}); 

					if(event.accState == 1){
						summData[countJourney] = {};
						summData[countJourney].start_time = event.updated;
						summData[countJourney].start_location = event.lat + ', ' + event.lon;
						summData[countJourney].start_distance = event.mileage;
						summData[countJourney].start_lat = event.lat;
						summData[countJourney].start_lon = event.lon;
						summData[countJourney].start_coordinate = event.lat + ', ' + event.lon;
						summData[countJourney].driver = drName;
					}else if(event.accState == 0){
						if(summData[countJourney]){
							summData[countJourney].end_distance = event.mileage;
							summData[countJourney].end_time = event.updated;
							summData[countJourney].end_location = event.lat + ', ' + event.lon;
							summData[countJourney].end_lat = event.lat;
							summData[countJourney].end_lon = event.lon;
							summData[countJourney].end_coordinate = event.lat + ', ' + event.lon;

							let dist = (parseFloat(summData[countJourney].end_distance) - parseFloat(summData[countJourney].start_distance));
							
							let from_mili:any = (summData[countJourney].end_time - summData[countJourney].start_time);
							let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
							hours = (hours < 10)? '0'+hours : hours;
							let seconds:any = Math.floor((from_mili / 1000) % 60);
							seconds = (seconds < 10)? '0'+seconds : seconds;
							let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
							minutes = (minutes < 10)? '0'+minutes : minutes;
							let diff_dur = (hours + ':' + minutes + ":" + seconds);
							
							summData[countJourney].total_distance = dist;
							summData[countJourney].total_duration = diff_dur;
							//summData[event.unitid].idling = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle).toFixed(2);
							
							countJourney ++;
						}
					}else if(event.event == "Idling"){
						//summData[event.unitid].count_idle += 1; 
					}
					// fleet summary end*/
				});console.log(summData);
				for(let index in summData){
					let mbl = summData[index];
					//if(mbl.total_distance > 0){
					if(mbl.end_time){
						let repData = {
							start_time: mbl.start_time.format('YYYY-MM-DD HH:mm:ss'),
							start_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.start_lat+'" data-lon="'+mbl.start_lon+'" data-loc="'+mbl.start_location+'">' + mbl.start_coordinate + '</a>',
							start_location: mbl.start_location,
							end_time: mbl.end_time.format('YYYY-MM-DD HH:mm:ss'),
							end_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.end_lat+'" data-lon="'+mbl.end_lon+'" data-loc="'+mbl.end_location+'">' + mbl.end_coordinate + '</a>',
							end_location: mbl.end_location,
							// distance: Math.round(mbl.total_distance),
							duration: mbl.total_duration,
							driver: mbl.driver,
							empty_str: ''
						};
						this.reportData.push(repData);
					}
				};
				let options = {
					data: this.reportData,
					//pageLength: 25,
					paging:false,
					responsive: false,
					scrollX: true,
					searching: false,
					destroy: true,
					dom: "lfr<t>Bpi",
					buttons: [
						{
							extend: 'excelHtml5',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore3').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-excel-o rptBtn',
							text: '',
							title: plate+' Fleet Parking Report Details'
						}, {
							extend: 'pdfHtml5',
							orientation: 'landscape',
							pageSize: 'A4',
							exportOptions: {
								columns: ( idx, data, node ) => {
								let table_id = node.getAttribute('aria-controls');
								return $('#oncore3').DataTable().column( idx ).visible();
							}
							},
							className: 'fa fa-file-pdf-o rptBtn',
							text: '',
							title: plate+' Fleet Parking Report Details'
						}
					],
					columns: [
						{
							data: "start_time",
							width: "12%",
							title: "Time Start"
						},
						// {
						// 	data: "start_location",
						// 	width: "25%",
						// 	title: "Location Start"
						// },
						{
							data: "end_time",
							width: "12%",
							title: "Time Stop"
						},
						{
							data: "end_coordinate",
							width: "25%",
							title: "Coordinate"
						},
						{
							data: "end_location",
							width: "25%",
							title: "Location"
						},
						// {
						// 	data: "distance",
						// 	width: "5%",
						// 	title: "Distance"
						// },
						{
							data: "duration",
							width: "6%",
							title: "Duration"
						},
						{
							data: "driver",
							width: "10%",
							title: "Driver Name"
						},
						{
							data: "empty_str",
							width: "5%",
							title: '',
							render: this.editIcon
						}
					]
				};
				$('#oncore3').DataTable(options);
				this.reinitBackToTopReportDetail();
				if($('.detail-title-caption').length == 0){
					$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' Fleet Parking Report Details</caption');
				}
				$('.dt-buttons').css('float','left');
				$('html,body').animate({
				scrollTop: $('#oncore3').offset().top
				}, 1000);
				$('.dataTables_scrollBody').scroll(function(){
					$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
				});
			});
		}
	}
	// else if(this.reportType == this.reportOptions.dMovement){
	// 	const dateFrom:any = new Date(start_date);
	// 	const dateTo:any = new Date(end_date);
	// 	const diffInMs:any = dateTo - dateFrom;
	// 	const diffInHours = (diffInMs / (1000 * 60 * 60));
	// 	const diffInDays = (diffInMs / (1000 * 60 * 60 * 24)) + 1;
	// 	if(this.userObj.source == "oncore"){
	// 		let plate = "";
	// 		let summByDays = this.outDetailsReport['dMovement'][unitId];
	// 		for(let index in summByDays){
	// 			let mbl = summByDays[index];
	// 			if(mbl.plate){
	// 				this.reportData.push({
	// 					start_time: index,
	// 					driving: mbl.driving,
	// 					parking: mbl.parking,
	// 					idling: mbl.idling,
	// 					empty_str:''
	// 				});
	// 				plate = mbl.plate;
	// 			}
	// 		};
			
	// 		let options = {
	// 			data: this.reportData,
	// 			//pageLength: 25,
	// 			paging:false,
	// 			responsive: false,
	// 			scrollX: true,
	// 			searching: false,
	// 			destroy: true,
	// 			dom: "lfr<t>Bpi",
	// 			buttons: [
	// 				{
	// 					extend: 'excelHtml5',
	// 					exportOptions: {
	// 						columns: ( idx, data, node ) => {
	// 						let table_id = node.getAttribute('aria-controls');
	// 						return $('#oncore3').DataTable().column( idx ).visible();
	// 					}
	// 					},
	// 					className: 'fa fa-file-excel-o rptBtn',
	// 					text: '',
	// 					title: plate+' Daily Movement Report Details'
	// 				}, {
	// 					extend: 'pdfHtml5',
	// 					orientation: 'landscape',
	// 					pageSize: 'A4',
	// 					exportOptions: {
	// 						columns: ( idx, data, node ) => {
	// 						let table_id = node.getAttribute('aria-controls');
	// 						return $('#oncore3').DataTable().column( idx ).visible();
	// 					}
	// 					},
	// 					className: 'fa fa-file-pdf-o rptBtn',
	// 					text: '',
	// 					title: plate+' Daily Movement Report Details'
	// 				}
	// 			],
	// 			columns: [
	// 				{
	// 					data: "start_time",
	// 					width: "12%",
	// 					title: "Date"
	// 				},
	// 				{
	// 					data: "driving",
	// 					width: "6%",
	// 					title: "Driving"
	// 				},
	// 				{
	// 					data: "idling",
	// 					width: "10%",
	// 					title: "Idling"
	// 				},
	// 				{
	// 					data: "parking",
	// 					width: "10%",
	// 					title: "Parking"
	// 				},
	// 				{
	// 					data: "empty_str",
	// 					width: "5%",
	// 					title: '',
	// 					render: this.editIcon
	// 				}
	// 			]
	// 		};
	// 		$('#oncore3').DataTable(options);
	// 		this.reinitBackToTopReportDetail();
	// 		if($('.detail-title-caption').length == 0){
	// 			$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' Daily Movement Report Details</caption');
	// 		}
	// 		$('.dt-buttons').css('float','left');
	// 		$('html,body').animate({
	// 		scrollTop: $('#oncore3').offset().top
	// 		}, 1000);
	// 		$('.dataTables_scrollBody').scroll(function(){
	// 			$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
	// 		});
	// 	}else{
	// 		this.vehicleSvc.getVehicleTracks(unitId,start_date,end_date,1)
	// 		.subscribe((r:any) => {
	// 			this.reportData = [];
	// 			this.processingDetail = false;
	// 			this.eventDatas = r;
	// 			let drName = '';
	// 			let plate = '';
	// 			let countJourney = 0;
	// 			let frefDatas = r;
	// 			this.eventDatas.forEach((event, index) => {
	// 				const dateStr = event.devTime;
	// 				// Convert to ISO format (important)
	// 				const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
	// 				// Get milliseconds
	// 				const timestamp = date.getTime();
	// 				// Build .NET format
	// 				const dotNetDate = "/Date(" + timestamp + "+0800)/";
					
	// 				event.updated = (moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x'));
	// 				let formattedTime = (event.updated).format('YYYY-MM-DD HH:mm:ss');
	// 				// fleet summary - start
	// 				this.vehicles.forEach((vehicle,key) => {
	// 					if(vehicle.unitid == event.unitid){
	// 						drName = vehicle.driver;
	// 						plate = vehicle.plate;
	// 					}
	// 				}); 

	// 				if(event.accState == 1){
	// 					if(summData[countJourney]){
	// 						summData[countJourney].end_distance = event.mileage;
	// 						summData[countJourney].end_time = event.updated;
	// 						summData[countJourney].end_location = event.lat + ', ' + event.lon;
	// 						summData[countJourney].end_lat = event.lat;
	// 						summData[countJourney].end_lon = event.lon;
	// 						summData[countJourney].end_coordinate = event.lat + ', ' + event.lon;

	// 						let dist = (parseFloat(summData[countJourney].end_distance) - parseFloat(summData[countJourney].start_distance));
							
	// 						let from_mili:any = (summData[countJourney].end_time - summData[countJourney].start_time);
	// 						let hours:any = Math.floor(from_mili / 1000 / 60 / 60);
	// 						hours = (hours < 10)? '0'+hours : hours;
	// 						let seconds:any = Math.floor((from_mili / 1000) % 60);
	// 						seconds = (seconds < 10)? '0'+seconds : seconds;
	// 						let minutes:any = Math.floor((from_mili / (60 * 1000)) % 60);
	// 						minutes = (minutes < 10)? '0'+minutes : minutes;
	// 						let diff_dur = (hours + ':' + minutes + ":" + seconds);
							
	// 						summData[countJourney].total_distance = dist;
	// 						summData[countJourney].total_duration = diff_dur;
	// 						//summData[event.unitid].idling = (summData[event.unitid].count_idle * summData[event.unitid].mobile_idle).toFixed(2);
							
	// 						countJourney ++;
	// 					}
	// 				}else if(event.accState == 0){
	// 					if(!summData[countJourney]){
	// 						summData[countJourney] = {};
	// 						summData[countJourney].start_time = event.updated;
	// 						summData[countJourney].start_location = event.lat + ', ' + event.lon;
	// 						summData[countJourney].start_distance = event.mileage;
	// 						summData[countJourney].start_lat = event.lat;
	// 						summData[countJourney].start_lon = event.lon;
	// 						summData[countJourney].start_coordinate = event.lat + ', ' + event.lon;
	// 						summData[countJourney].driver = drName;
	// 					}
	// 				}else if(event.runState == 3){
	// 					//summData[event.unitid].count_idle += 1; 
	// 				}
	// 				// fleet summary end*/
	// 			});console.log(summData);
	// 			for(let index in summData){
	// 				let mbl = summData[index];
	// 				//if(mbl.total_distance > 0){
	// 				if(mbl.end_time){
	// 					let repData = {
	// 						start_time: mbl.start_time.format('YYYY-MM-DD HH:mm:ss'),
	// 						start_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.start_lat+'" data-lon="'+mbl.start_lon+'" data-loc="'+mbl.start_location+'">' + mbl.start_coordinate + '</a>',
	// 						start_location: mbl.start_location,
	// 						end_time: mbl.end_time.format('YYYY-MM-DD HH:mm:ss'),
	// 						end_coordinate: '<a class="clickable rpt-coord" data-lat="'+mbl.end_lat+'" data-lon="'+mbl.end_lon+'" data-loc="'+mbl.end_location+'">' + mbl.end_coordinate + '</a>',
	// 						end_location: mbl.end_location,
	// 						distance: Math.round(mbl.total_distance),
	// 						duration: mbl.total_duration,
	// 						driver: mbl.driver,
	// 						empty_str: ''
	// 					};
	// 					this.reportData.push(repData);
	// 				}
	// 			};
	// 			let options = {
	// 				data: this.reportData,
	// 				//pageLength: 25,
	// 				paging:false,
	// 				responsive: false,
	// 				scrollX: true,
	// 				searching: false,
	// 				destroy: true,
	// 				dom: "lfr<t>Bpi",
	// 				buttons: [
	// 					{
	// 						extend: 'excelHtml5',
	// 						exportOptions: {
	// 							columns: ( idx, data, node ) => {
	// 							let table_id = node.getAttribute('aria-controls');
	// 							return $('#oncore3').DataTable().column( idx ).visible();
	// 						}
	// 						},
	// 						className: 'fa fa-file-excel-o rptBtn',
	// 						text: '',
	// 						title: plate+' Fleet Driving Report Details'
	// 					}, {
	// 						extend: 'pdfHtml5',
	// 						orientation: 'landscape',
	// 						pageSize: 'A4',
	// 						exportOptions: {
	// 							columns: ( idx, data, node ) => {
	// 							let table_id = node.getAttribute('aria-controls');
	// 							return $('#oncore3').DataTable().column( idx ).visible();
	// 						}
	// 						},
	// 						className: 'fa fa-file-pdf-o rptBtn',
	// 						text: '',
	// 						title: plate+' Fleet Driving Report Details'
	// 					}
	// 				],
	// 				columns: [
	// 					{
	// 						data: "start_time",
	// 						width: "12%",
	// 						title: "Time Start"
	// 					},
	// 					{
	// 						data: "start_coordinate",
	// 						width: "25%",
	// 						title: "Coordinate Start"
	// 					},
	// 					{
	// 						data: "start_location",
	// 						width: "25%",
	// 						title: "Location Start"
	// 					},
	// 					{
	// 						data: "end_time",
	// 						width: "12%",
	// 						title: "Time Stop"
	// 					},
	// 					{
	// 						data: "end_coordinate",
	// 						width: "25%",
	// 						title: "Coordinate Stop"
	// 					},
	// 					{
	// 						data: "end_location",
	// 						width: "25%",
	// 						title: "Location Stop"
	// 					},
	// 					{
	// 						data: "distance",
	// 						width: "5%",
	// 						title: "Distance"
	// 					},
	// 					{
	// 						data: "duration",
	// 						width: "6%",
	// 						title: "Duration"
	// 					},
	// 					{
	// 						data: "driver",
	// 						width: "10%",
	// 						title: "Driver Name"
	// 					},
	// 					{
	// 						data: "empty_str",
	// 						width: "5%",
	// 						title: '',
	// 						render: this.editIcon
	// 					}
	// 				]
	// 			};
	// 			$('#oncore3').DataTable(options);
	// 			this.reinitBackToTopReportDetail();
	// 			if($('.detail-title-caption').length == 0){
	// 				$('#oncore3').prepend('<caption class="detail-title-caption" style="color:#000; font-weight:bold; text-align:center;margin:1em 0;font-size:1.2em;">'+plate+' Fleet Driving Report Details</caption');
	// 			}
	// 			$('.dt-buttons').css('float','left');
	// 			$('html,body').animate({
	// 			scrollTop: $('#oncore3').offset().top
	// 			}, 1000);
	// 			$('.dataTables_scrollBody').scroll(function(){
	// 				$('.dataTables_scrollHead').scrollLeft($(this).scrollLeft());
	// 			});
	// 		});
	// 	}
	// }
  }

  closeModalBtn(){
	$('#dispCoordBackdrop').hide().removeClass('in');
	$('#disp-coord').hide().removeClass('in');
  }

  parseDurationToSeconds(value) {
	const regex = /(?:(\d+)\s*h)?\s*(?:(\d+)\s*min)?\s*(?:(\d+)\s*s)?/i;
	const match = value.match(regex);

	if (!match) return 0;

	const hours = parseInt(match[1] || '0', 10);
	const minutes = parseInt(match[2] || '0', 10);
	const seconds = parseInt(match[3] || '0', 10);

	return hours * 3600 + minutes * 60 + seconds;
	}

	formatSeconds(totalSeconds) {
		const hours = Math.floor(totalSeconds / 3600);
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		const seconds = totalSeconds % 60;

		let result = '';

		if (hours > 0) result += `${hours}h`;
		if (minutes > 0) result += `${minutes}min`;
		if (seconds > 0 || result === '') result += `${seconds}s`;

		return result;
	}

	toSeconds(hms) {
		const [h, m, s] = hms.split(':').map(Number);
		return (h * 3600) + (m * 60) + s;
	}

	formatTime(totalSeconds) {
		// Ensure we don't have negative time
		const secs = Math.max(0, totalSeconds); 
		const h = Math.floor(secs / 3600);
		const m = Math.floor((secs % 3600) / 60);
		const s = Math.ceil(secs % 60);
		
		// padStart adds leading zeros
		return [h, m, s].map(val => val.toString().padStart(2, '0')).join(':');
	}

	addTimes(...times) {
		let totalSeconds = 0;

		times.forEach(time => {
			const [h, m, s] = time.split(':').map(Number);
			totalSeconds += h * 3600 + m * 60 + s;
		});

		const hours = Math.floor(totalSeconds / 3600);
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		const seconds = totalSeconds % 60;

		return [
			String(hours).padStart(2, '0'),
			String(minutes).padStart(2, '0'),
			String(seconds).padStart(2, '0')
		].join(':');
	}

	popupEditCert(){
		// - Registration No.
		// - Device Serial No / IMEI
		// - Username
		// - Activation Date
		// - Expiry Date

		// - Chassis No.
		// - Dealer Name (Installed by Dealer)
		// - Dealer Address
		this.certGenerateVehicle = this.vehicleList;
		if(this.userObj?.source == 'bsj'){
			this.certGenerateVehicle = this.vehicleListBsj;
			if(this.userObj?.source == 'bsj'){
				let tempVhcl:any = {}
				this.vehicles?.forEach((vhcl) => {
					if(vhcl.unitid == this.vehicleListBsj){
						tempVhcl = vhcl;
						return;
					}
				});
				this.activationDate = moment(tempVhcl.expireDate).subtract(1, 'years');
				this.expiryDate = tempVhcl.expireDate;
			}
		}
		$('#fieldOpt').show().addClass('in');
		$('#fieldOptBackdrop').show().addClass('in');
	}

	generateCert(vehicleunit) {
		if(!this.installDate){
			alert('Please fill up Installation Date');
			return;
		}
		if(!this.activationDate){
			alert('Please fill up Activation Date');
			return;
		}
		if(!this.expiryDate){
			alert('Please fill up Expiry Date');
			return;
		}
		let tempVhcl:any = {}
		this.vehicles?.forEach((vhcl) => {
			if(vhcl.unitid == vehicleunit){
				tempVhcl = vhcl;
				return;
			}
		});console.log('tempVhcl',tempVhcl)

		let dvcRegId = tempVhcl.unitid;
		let dvcUser = tempVhcl.username;
		if(this.userObj?.source == 'bsj'){
			dvcRegId = tempVhcl.terminalNo;
			dvcUser = this.userObj?.username;
		}

		const doc = new jsPDF('p', 'mm', 'a4');

		const img = new Image();
		img.src = 'assets/images/backgrounds/cert_bge.jpeg'; // your JPEG in assets

		img.onload = () => {

			// Add background image (full page)
			doc.addImage(img, 'JPEG', 0, 0, 210, 297); // A4 size in mm

			// Overlay text
			doc.setFont('Arial');
			doc.setFontSize(13);
			doc.setTextColor(0, 0, 0);

			doc.text(moment(this.issueDate).format('DD/MM/YYYY'), 163.5, 7.5); // (x, y)

			doc.setFontSize(14);

			doc.text('Product Name', 10.5, 164);
			doc.text(':', 63, 164);
			doc.text('Oncore Fleet', 65.5, 164);

			doc.text('Registration No', 10.5, 169.5);
			doc.text(':', 63, 169.5);
			doc.text(tempVhcl.description, 65.5, 169.5);

			let reduceHeight = 0;
			if(this.chasisNo){
				doc.text('Chassis No', 10.5, 175.5);
				doc.text(':', 63, 175.5);
				doc.text(this.chasisNo, 65.5, 175.5);
				reduceHeight = 6;
			}

			doc.text('Device Serial No / IMEI', 10.5, (175.5 + reduceHeight));
			doc.text(':', 63, (175.5 + reduceHeight));
			doc.text((tempVhcl.unitid).toString(), 65.5, (175.5 + reduceHeight));

			doc.text('Installation Date', 10.5, (181.1  + reduceHeight));
			doc.text(':', 63, (181.1 + reduceHeight));
			doc.text(moment(this.installDate).format('DD/MM/YYYY'), 65.5, (181.1 + reduceHeight));
			//187.1

			if(this.dealerName){
				reduceHeight += 5.5;
				doc.text('Installed By Dealer', 10.5, (181.1 + reduceHeight));
				doc.text(':', 63, (181.1 + reduceHeight));
				doc.text(this.dealerName, 65.5, (181.1 + reduceHeight));
			}
			// 192.7

			if(this.dealerAddress){
				reduceHeight += 6;
				doc.text('Dealer Address', 10.5, (181.1 + reduceHeight));
				doc.text(':', 63, (181.1 + reduceHeight));
				let addrByLines = (this.dealerAddress).split(/\r?\n/);
				let addrFirst = (181.1 + reduceHeight);
				addrByLines.forEach((addrLn, ixd) => {
					doc.text(addrLn, 65.5, addrFirst + (ixd * 6));
				});
			}
			// doc.text(this.dealerAddress, 65.5, 198.5);
			// doc.text('Light Industrial Park, Jalan Batu Kawa/Matang,', 65.5, 204.5);
			// doc.text('93250 Kuching, Sarawak.', 65.5, 210.5);

			doc.text('Web Access URL', 10.5, 225.8);
			doc.text(':', 63, 225.8);
			doc.text('https://web.oncore.com.my/#/', 65.5, 225.8);

			doc.text('Username', 10.5, 231.5);
			doc.text(':', 63, 231.5);
			doc.text(dvcUser, 65.5, 231.5);

			doc.text('Activation Date', 10.5, 237.5);
			doc.text(':', 63, 237.5);
			doc.text(moment(this.activationDate).format('DD/MM/YYYY'), 65.5, 237.5);

			doc.text('Expiry Date', 10.5, 243);
			doc.text(':', 63, 243);
			doc.text(moment(this.expiryDate).format('DD/MM/YYYY'), 65.5, 243);

			// Save PDF
			doc.save(tempVhcl.description+'.pdf');

			$('#fieldOptBackdrop').hide().removeClass('in');
			$('#fieldOpt').hide().removeClass('in');
			this.processingDetail = false;
		};
	}

	cancelCert(){
		$('#fieldOptBackdrop').hide().removeClass('in');
		$('#fieldOpt').hide().removeClass('in');
	}

	addYear(){
		this.expiryDate = moment(this.activationDate).add(1, 'years').format('YYYY-MM-DD');
	}

}
